var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoorWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 250,
    viewBox: "0 0 245 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_wd_front_up",
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 -18",
    begin: "hinava_random_uuid_wd_f_arrow_blink.begin+1s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 -18",
    to: "0 0",
    begin: "hinava_random_uuid_wd_hinava_blink.end+2s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.801 56.8837V233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.801 233.105C169.704 239.198 175.007 244.495 181.1 244.404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 244.404C187.192 244.312 228.402 244.404 228.402 244.404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 244.404C234.495 244.495 239.786 239.198 239.695 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.695 233.105V56.8837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.695 56.8837C239.792 50.7908 234.489 45.4992 228.402 45.5906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 45.5906L181.1 45.5906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 45.5906C175.007 45.4938 169.71 50.7962 169.801 56.8837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 245.366H228.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.833 233.105C168.72 239.704 174.496 245.485 181.1 245.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.833 56.8837L168.833 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 44.6226C174.496 44.5097 168.72 50.2853 168.833 56.8837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 44.6226L181.1 44.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.663 56.8838C240.776 50.2853 235 44.5097 228.402 44.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.663 233.105V56.8838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 245.366C235 245.485 240.776 239.704 240.663 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 41.8639C236.484 41.724 243.561 48.8011 243.422 56.8838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.422 56.8838H240.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 41.8639L228.402 44.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 245.366L228.402 248.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 245.366V248.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 41.8639L181.1 44.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08 56.8838L168.833 56.8837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.422 56.8838L243.422 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.663 233.105H243.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.833 233.105L166.08 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 41.8639L228.402 41.8639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23 143.615H164.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23 55.3726V143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.246 144.443H165.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.058 144.443L164.23 143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.058 145.546H165.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.058 144.443V145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.418 146.374H164.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23 146.374L165.058 145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23 146.374V234.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.277 55.3726H245.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.277 234.616L245.277 55.3726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.277 234.616H245.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.583 40.0032V40.1968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.913 40.0032L179.583 40.0032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.913 40.0032L229.913 40.1968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.918 249.964C238.151 250.147 245.449 242.855 245.277 234.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.583 40.0032C171.339 39.8311 164.047 47.1286 164.23 55.3726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.277 55.3726C245.46 47.1232 238.162 39.8257 229.913 40.0032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23 234.616L164.23 234.622C164.068 242.511 170.747 249.523 178.545 249.948C178.884 249.964 179.233 249.97 179.578 249.964",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 143.615H164.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 143.615L166.768 144.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.768 144.443H165.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.246 144.443L164.418 143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 41.7294L229.924 40.2075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.078 55.3672L243.556 56.8837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 248.265L179.578 249.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.418 234.627L165.94 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 233.105C165.94 241.478 172.716 248.26 181.094 248.265L181.1 248.265",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 56.8838L164.418 55.3672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.578 40.2075L181.1 41.7294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 41.7294C180.578 41.7294 180.056 41.7563 179.551 41.8101C171.898 42.5845 165.94 49.0323 165.94 56.8838",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.246 145.546H166.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.556 233.105L245.078 234.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.924 249.787L228.402 248.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 248.265C236.775 248.265 243.556 241.478 243.556 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 56.8838V143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 248.265H228.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 146.374L165.94 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.768 145.551L165.94 146.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.418 146.374L165.94 146.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.418 146.374L165.246 145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.768 144.443L166.768 145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.801 56.8837V233.105C169.704 239.198 175.007 244.495 181.1 244.404C187.192 244.312 228.402 244.404 228.402 244.404C234.495 244.495 239.786 239.198 239.695 233.105V56.8837C239.792 50.7908 234.489 45.4992 228.402 45.5906L181.1 45.5906C175.007 45.4938 169.71 50.7962 169.801 56.8837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 44.6226L228.402 44.6226L228.402 41.8639L181.1 41.8639L181.1 44.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.23 143.615H164.418H165.94L166.768 144.443L166.768 145.546H165.246L164.418 146.374H164.23V234.616L164.23 234.622C164.068 242.511 170.747 249.523 178.545 249.948C178.884 249.964 179.233 249.97 179.578 249.964L229.918 249.964C238.151 250.147 245.449 242.855 245.277 234.616L245.277 55.3726C245.46 47.1232 238.162 39.8257 229.913 40.0032L179.583 40.0032C171.339 39.8311 164.047 47.1286 164.23 55.3726V143.615ZM228.402 245.366H181.1C174.496 245.485 168.72 239.704 168.833 233.105L168.833 56.8837C168.72 50.2853 174.496 44.5097 181.1 44.6226L181.1 41.8639L228.402 41.8639C236.484 41.724 243.561 48.8011 243.422 56.8838L243.422 233.105H240.663C240.776 239.704 235 245.485 228.402 245.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.1 245.366H228.402C235 245.485 240.776 239.704 240.663 233.105V56.8838C240.776 50.2853 235 44.5097 228.402 44.6226L181.1 44.6226C174.496 44.5097 168.72 50.2853 168.833 56.8837L168.833 233.105C168.72 239.704 174.496 245.485 181.1 245.366ZM169.801 233.105V56.8837C169.71 50.7962 175.007 45.4938 181.1 45.5906L228.402 45.5906C234.489 45.4992 239.792 50.7908 239.695 56.8837V233.105C239.786 239.198 234.495 244.495 228.402 244.404C228.402 244.404 187.192 244.312 181.1 244.404C175.007 244.495 169.704 239.198 169.801 233.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.663 56.8838V233.105H243.422L243.422 56.8838H240.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.402 44.6226C235 44.5097 240.776 50.2853 240.663 56.8838H243.422C243.561 48.8011 236.484 41.724 228.402 41.8639L228.402 44.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.246 144.443H165.058V145.546H165.246H166.768L166.768 144.443H165.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 143.615H164.418L165.246 144.443H166.768L165.94 143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 245.366H228.402M181.1 245.366C174.496 245.485 168.72 239.704 168.833 233.105M181.1 245.366V248.125M228.402 245.366C235 245.485 240.776 239.704 240.663 233.105M228.402 245.366L228.402 248.125M168.833 233.105L168.833 56.8837M168.833 233.105L166.08 233.105M168.833 56.8837C168.72 50.2853 174.496 44.5097 181.1 44.6226M168.833 56.8837L166.08 56.8838M181.1 44.6226L228.402 44.6226M181.1 44.6226L181.1 41.8639L228.402 41.8639M228.402 44.6226C235 44.5097 240.776 50.2853 240.663 56.8838M228.402 44.6226L228.402 41.8639M240.663 56.8838V233.105M240.663 56.8838H243.422M240.663 233.105H243.422L243.422 56.8838M228.402 41.8639C236.484 41.724 243.561 48.8011 243.422 56.8838M164.23 143.615H164.418M164.23 143.615V55.3726C164.047 47.1286 171.339 39.8311 179.583 40.0032M164.23 143.615L165.058 144.443M164.418 143.615H165.94M164.418 143.615L165.246 144.443M165.246 144.443H165.058M165.246 144.443H166.768M165.058 144.443V145.546M165.058 145.546H165.246M165.058 145.546L164.23 146.374M165.246 145.546H166.768L166.768 144.443M165.246 145.546L164.418 146.374M164.418 146.374H164.23M164.418 146.374L165.94 146.374M164.23 146.374V234.616L164.23 234.622C164.068 242.511 170.747 249.523 178.545 249.948C178.884 249.964 179.233 249.97 179.578 249.964L229.918 249.964C238.151 250.147 245.449 242.855 245.277 234.616M245.277 55.3726H245.083M245.277 55.3726L245.277 234.616M245.277 55.3726C245.46 47.1232 238.162 39.8257 229.913 40.0032M245.277 234.616H245.083M179.583 40.0032V40.1968M179.583 40.0032L229.913 40.0032M229.913 40.0032L229.913 40.1968M165.94 143.615L166.768 144.443M165.94 143.615V56.8838M228.402 41.7294L229.924 40.2075M245.078 55.3672L243.556 56.8837M181.1 248.265L179.578 249.787M181.1 248.265L181.094 248.265C172.716 248.26 165.94 241.478 165.94 233.105M181.1 248.265H228.402M164.418 234.627L165.94 233.105M165.94 233.105L165.94 146.374M165.94 56.8838L164.418 55.3672M165.94 56.8838C165.94 49.0323 171.898 42.5845 179.551 41.8101C180.056 41.7563 180.578 41.7294 181.1 41.7294L179.578 40.2075M245.078 234.627L243.556 233.105C243.556 241.478 236.775 248.265 228.402 248.265M229.924 249.787L228.402 248.265M165.94 146.374L166.768 145.551M169.801 56.8837V233.105C169.704 239.198 175.007 244.495 181.1 244.404C187.192 244.312 228.402 244.404 228.402 244.404C234.495 244.495 239.786 239.198 239.695 233.105V56.8837C239.792 50.7908 234.489 45.4992 228.402 45.5906L181.1 45.5906C175.007 45.4938 169.71 50.7962 169.801 56.8837Z",
    stroke: "black",
    strokeWidth: 0.381278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#777"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_wd_hinava_blink",
    attributeName: "fill",
    values: "#777;#00FFDC;#777",
    begin: "hinava_random_uuid_wd_back_arrow_move.end",
    end: "hinava_random_uuid_wd_back_arrow_move.end+5s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.773 224.522V230.325L184.66 230.648C184.52 231.072 184.305 231.46 184.025 231.809C183.713 232.196 183.337 232.498 182.901 232.734C182.444 232.987 181.96 233.094 181.444 233.111C181.137 233.137 180.836 233.116 180.535 233.046C180.288 232.982 180.051 232.901 179.82 232.799C179.545 232.686 179.309 232.53 179.088 232.331C178.508 231.852 178.131 231.245 177.894 230.524C177.728 229.599 177.835 228.642 177.798 227.706C177.814 226.797 177.755 225.878 177.846 224.969C178.018 224.404 178.373 223.985 178.857 223.651C180.142 222.925 181.847 223.764 182.019 225.238C182.062 226.066 182.046 226.899 182.046 227.733L182.035 229.895L181.912 230.051C181.826 230.147 181.734 230.223 181.627 230.293C181.207 230.529 180.685 230.25 180.567 229.798C180.503 229.024 180.535 228.238 180.524 227.459V225.281L180.433 225.146C180.191 224.764 179.572 224.791 179.357 225.189C179.174 225.964 179.32 226.808 179.277 227.609C179.33 228.561 179.126 229.577 179.465 230.481C179.696 230.954 180.067 231.277 180.546 231.503C180.793 231.616 181.057 231.653 181.331 231.643C182.068 231.594 182.724 231.234 183.073 230.567C183.498 229.551 183.224 228.362 183.304 227.281C183.337 226.367 183.224 225.426 183.38 224.522C183.6 223.974 184.353 223.931 184.681 224.404L184.773 224.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.09 221.339C184.428 221.511 184.832 221.753 184.794 222.194C184.789 222.431 184.686 222.646 184.498 222.785C184.38 222.904 184.213 222.92 184.057 222.909H183.767L183.062 222.511C182.068 221.957 181.067 221.409 180.067 220.86C179.933 220.79 179.798 220.715 179.664 220.64C179.54 220.57 179.416 220.5 179.293 220.435C179.174 220.366 179.051 220.301 178.932 220.231C178.825 220.172 178.717 220.118 178.61 220.059C178.314 219.882 178.088 219.645 177.916 219.344C177.83 219.177 177.798 218.994 177.798 218.806C177.798 218.661 177.787 218.521 177.819 218.381C177.905 218.123 178.05 217.903 178.244 217.714C179.282 217.026 180.4 216.461 181.492 215.859C181.761 215.714 182.03 215.563 182.293 215.413C182.874 215.122 183.407 214.697 184.041 214.552C184.428 214.552 184.74 214.853 184.783 215.235C184.859 215.714 184.418 215.993 184.047 216.187C183.951 216.239 183.855 216.291 183.759 216.344C182.311 217.13 180.859 217.919 179.427 218.736C179.427 218.795 179.519 218.822 179.562 218.854L179.562 218.855C179.696 218.925 179.831 218.994 179.959 219.069C180.121 219.161 180.282 219.247 180.443 219.338C181.32 219.812 182.191 220.29 183.062 220.78C183.401 220.968 183.745 221.151 184.09 221.339Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.751 205.523C184.826 206.502 184.773 207.491 184.783 208.475L184.773 211.309L184.638 211.686C184.439 212.283 184.09 212.783 183.632 213.224C183.52 213.321 183.412 213.428 183.288 213.504C183.229 213.525 183.181 213.568 183.132 213.6C182.82 213.799 182.487 213.934 182.132 214.031C181.578 214.165 181.024 214.149 180.465 214.031C179.18 213.697 178.179 212.675 177.868 211.385C177.712 210.465 177.814 209.519 177.782 208.588C177.825 207.685 177.69 206.755 177.878 205.873C178.201 204.872 179.207 204.254 180.239 204.399C181.159 204.544 181.874 205.281 182.014 206.195C182.068 207.733 182.068 209.282 182.019 210.825C181.955 211.046 181.777 211.191 181.594 211.32C181.481 211.369 181.363 211.374 181.245 211.363C180.987 211.342 180.766 211.202 180.637 210.981L180.546 210.825L180.524 208.529C180.368 207.733 180.852 206.453 180.169 205.926C179.954 205.835 179.717 205.84 179.529 205.991C178.991 206.712 179.4 207.857 179.282 208.723L179.293 211.067L179.389 211.309C179.621 211.874 180.024 212.251 180.578 212.514C180.804 212.616 181.04 212.643 181.282 212.627C181.53 212.648 181.766 212.611 181.992 212.519C182.584 212.283 182.966 211.853 183.213 211.266C183.347 210.298 183.267 209.304 183.304 208.33C183.455 207.346 182.982 205.991 183.632 205.206C183.756 205.098 183.917 205.077 184.073 205.087C184.251 205.061 184.412 205.114 184.525 205.249C184.611 205.329 184.697 205.415 184.751 205.523Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.493 195.521C184.74 195.763 184.864 196.085 184.826 196.429C184.805 196.861 184.496 197.154 184.205 197.428C184.199 197.434 184.193 197.44 184.186 197.446C183.869 197.747 183.557 198.053 183.245 198.355C183.226 198.373 183.206 198.392 183.186 198.411C182.739 198.838 182.295 199.261 181.852 199.688C181.374 200.145 180.901 200.602 180.422 201.06L179.857 201.603L182.094 201.619C182.874 201.656 183.681 201.576 184.45 201.705C184.885 201.947 184.966 202.576 184.606 202.92C184.536 202.985 184.461 203.033 184.38 203.065C183.407 203.141 182.422 203.098 181.444 203.114C180.39 202.979 179.061 203.426 178.153 202.818C177.927 202.614 177.819 202.361 177.792 202.06C177.755 201.597 178.04 201.248 178.357 200.947C179.142 200.199 179.916 199.452 180.702 198.704C181.215 198.218 181.728 197.721 182.236 197.228C182.244 197.22 182.253 197.212 182.261 197.204L182.772 196.709H178.378L178.196 196.618C177.954 196.489 177.803 196.257 177.798 195.983C177.782 195.865 177.798 195.752 177.846 195.639C177.932 195.483 178.056 195.359 178.206 195.268C179.169 195.123 180.169 195.23 181.148 195.198C182.137 195.219 183.138 195.149 184.122 195.252C184.262 195.316 184.38 195.413 184.493 195.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.547 192.654C184.735 192.826 184.821 193.068 184.783 193.321C184.783 193.482 184.703 193.617 184.579 193.714C184.482 193.805 184.369 193.875 184.246 193.923C182.277 193.993 180.304 193.993 178.335 193.923C178.126 193.837 177.937 193.708 177.841 193.499C177.776 193.3 177.76 193.09 177.846 192.902C177.948 192.73 178.077 192.574 178.266 192.514C179.309 192.455 180.357 192.493 181.395 192.488L184.385 192.498L184.547 192.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.794 190.449C184.799 190.772 184.59 191.057 184.278 191.148C183.256 191.218 182.229 191.17 181.207 191.181L178.287 191.17L178.131 191.073C177.787 190.858 177.685 190.396 177.9 190.046C178.201 189.519 178.927 189.75 179.432 189.697H180.524V184.787L179.422 184.776C179.013 184.738 178.556 184.84 178.174 184.668C177.959 184.534 177.803 184.324 177.798 184.066C177.798 183.953 177.792 183.84 177.83 183.738C177.916 183.566 178.045 183.442 178.206 183.34C179.174 183.2 180.18 183.297 181.164 183.259C182.18 183.265 183.197 183.233 184.208 183.292C184.487 183.378 184.735 183.566 184.778 183.867C184.805 184.088 184.778 184.319 184.622 184.486C184.278 184.921 183.638 184.717 183.148 184.776L182.057 184.787V189.697H183.143C183.552 189.718 183.987 189.643 184.38 189.772C184.649 189.895 184.805 190.159 184.794 190.449Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_wd_f_arrow_blink",
    attributeName: "fill-opacity",
    values: "1;0.5;1",
    begin: "0;hinava_random_uuid_wd_hinava_blink.end+6s",
    end: "hinava_random_uuid_wd_front_up.end+2s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_wd_f_arrow_fadeout",
    attributeName: "fill-opacity",
    to: 0,
    begin: "hinava_random_uuid_wd_f_arrow_blink.end",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    to: 1,
    begin: "hinava_random_uuid_wd_hinava_blink.end+3s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.925 141.193L219.463 130L213 141.193H217.465H221.465H225.925Z",
    fill: "#F26850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.465 158.347H221.465V141.193H217.465V158.347Z",
    fill: "#F26850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.925 141.193L190.463 130L184 141.193H188.465H192.465H196.925Z",
    fill: "#F26850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.465 158.347H192.465V141.193H188.465V158.347Z",
    fill: "#F26850"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_wd_magnet_fadeout",
    attributeName: "fill-opacity",
    from: 1,
    to: 0,
    begin: "hinava_random_uuid_wd_f_arrow_fadeout.end",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    from: 0,
    to: 1,
    begin: "hinava_random_uuid_wd_hinava_blink.end+3s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 187.244L127.188 187.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7 192.563L132.512 192.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.078 144.443L158.906 143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.078 144.443V145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.906 146.374L158.078 145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.188 102.938L127 102.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 187.244V102.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.512 97.2327L132.7 97.4263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.512 97.2327C129.463 97.2327 127 99.701 127 102.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.685 192.757L135.793 192.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.685 192.757H132.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.582 192.757L153.394 192.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.582 192.757H150.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.302 192.649L150.409 192.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.793 192.649H150.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.409 97.2327H153.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.394 97.4263L153.582 97.2327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.512 97.2327L135.685 97.2327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.685 97.2327L135.793 97.3402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.302 97.3402H135.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.906 187.051L159.094 187.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.582 192.757C156.631 192.757 159.094 190.294 159.094 187.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.094 102.745L158.906 102.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.094 102.745C159.094 99.701 156.631 97.2327 153.582 97.2327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.078 145.546H158.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.266 144.443H158.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.266 144.443V145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.094 143.615H158.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.094 143.615L158.266 144.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.906 146.374H159.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.266 145.546L159.094 146.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.094 102.745V143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.094 146.374V187.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.115 145.546H158.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.906 146.374H157.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 146.374L157.115 145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 186.088L158.906 187.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.394 192.563L152.431 191.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.431 191.6C155.475 191.6 157.938 189.137 157.938 186.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.078 144.443H157.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.115 144.443L157.938 143.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 143.615H158.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.156 103.901L127.188 102.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7 97.4263L133.668 98.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.668 98.3889C130.619 98.3889 128.156 100.857 128.156 103.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.115 144.443V145.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 186.088V146.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.668 191.6H152.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.156 186.088C128.156 189.137 130.619 191.6 133.668 191.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.156 103.901L128.156 186.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.431 98.3889H133.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 103.901C157.938 100.857 155.475 98.3889 152.431 98.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 143.615L157.938 103.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.431 98.3889L153.394 97.4263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.906 102.938L157.938 103.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.668 191.6L132.7 192.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.188 187.051L128.156 186.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 146.374L157.115 145.546V144.443L157.938 143.615L157.938 103.901C157.938 100.857 155.475 98.3889 152.431 98.3889H133.668C130.619 98.3889 128.156 100.857 128.156 103.901L128.156 186.088C128.156 189.137 130.619 191.6 133.668 191.6H152.431C155.475 191.6 157.938 189.137 157.938 186.088V146.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7 192.563L132.512 192.757H135.685L135.793 192.649H150.302L150.409 192.757H153.582L153.394 192.563L152.431 191.6H133.668L132.7 192.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.394 192.563L153.582 192.757C156.631 192.757 159.094 190.294 159.094 187.244L158.906 187.051L157.938 186.088C157.938 189.137 155.475 191.6 152.431 191.6L153.394 192.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.906 187.051L159.094 187.244V146.374H158.906H157.938V186.088L158.906 187.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 187.244L127.188 187.051L128.156 186.088L128.156 103.901L127.188 102.938L127 102.745V187.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.188 187.051L127 187.244C127 190.294 129.463 192.757 132.512 192.757L132.7 192.563L133.668 191.6C130.619 191.6 128.156 189.137 128.156 186.088L127.188 187.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 102.745L127.188 102.938L128.156 103.901C128.156 100.857 130.619 98.3889 133.668 98.3889L132.7 97.4263L132.512 97.2327C129.463 97.2327 127 99.701 127 102.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.094 102.745L158.906 102.938L157.938 103.901L157.938 143.615H158.906H159.094V102.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.582 97.2327L153.394 97.4263L152.431 98.3889C155.475 98.3889 157.938 100.857 157.938 103.901L158.906 102.938L159.094 102.745C159.094 99.701 156.631 97.2327 153.582 97.2327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.906 146.374L158.078 145.546H157.115L157.938 146.374H158.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.078 145.546V144.443H157.115V145.546H158.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.078 144.443L158.906 143.615H157.938L157.115 144.443H158.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.512 97.2327L132.7 97.4263L133.668 98.3889H152.431L153.394 97.4263L153.582 97.2327H150.409L150.302 97.3402H135.793L135.685 97.2327L132.512 97.2327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.968 97.4233L133.747 98.1982H152.352L153.127 97.4233H150.488L150.436 97.475C150.401 97.5107 150.352 97.5308 150.302 97.5308H135.792C135.742 97.5308 135.693 97.5107 135.658 97.475L135.606 97.4233L132.968 97.4233ZM153.662 97.4239L153.528 97.561L152.874 98.2152C155.67 98.4303 157.898 100.663 158.112 103.459L158.769 102.805L158.771 102.803L158.903 102.668C158.862 99.7913 156.543 97.4662 153.662 97.4239ZM158.903 103.21V143.425H158.128L158.128 103.98L158.903 103.21ZM157.747 143.537L157.747 103.901C157.747 100.962 155.369 98.5795 152.431 98.5795H133.668C130.725 98.5795 128.347 100.962 128.347 103.901L128.347 186.088C128.347 189.032 130.724 191.41 133.668 191.41H152.431C155.369 191.41 157.747 189.032 157.747 186.088V146.453L156.98 145.68C156.944 145.644 156.924 145.596 156.924 145.546V144.443C156.924 144.393 156.944 144.345 156.98 144.309L157.747 143.537ZM158.128 146.565V186.009L158.903 186.78V146.565H158.128ZM158.457 145.467L159.229 146.239C159.265 146.275 159.285 146.323 159.285 146.374V187.244C159.285 190.399 156.736 192.947 153.582 192.947H150.409C150.358 192.947 150.31 192.927 150.274 192.891L150.223 192.84H135.871L135.82 192.891C135.784 192.927 135.736 192.947 135.685 192.947H132.512C129.358 192.947 126.809 190.399 126.809 187.244V102.745C126.809 99.5958 129.358 97.042 132.512 97.042L135.685 97.042C135.735 97.042 135.784 97.0621 135.82 97.0978L135.871 97.1495H150.223L150.274 97.0978C150.31 97.0621 150.358 97.042 150.409 97.042H153.582C156.736 97.042 159.285 99.5958 159.285 102.745V143.615C159.285 143.666 159.265 143.714 159.229 143.75L158.457 144.522V145.467ZM158.446 143.806H158.017L157.573 144.253H157.999L158.446 143.806ZM157.887 144.634H157.306V145.355H157.887V144.634ZM157.999 145.736H157.573L158.017 146.183H158.446L157.999 145.736ZM158.769 187.184L158.112 186.53C157.898 189.331 155.67 191.559 152.874 191.774L153.53 192.43L153.662 192.565C156.543 192.523 158.862 190.203 158.903 187.321L158.771 187.186L158.769 187.184ZM153.127 192.566L152.352 191.791H133.747L132.968 192.566H135.606L135.658 192.514C135.693 192.478 135.742 192.458 135.792 192.458H150.302C150.352 192.458 150.401 192.478 150.436 192.514L150.488 192.566H153.127ZM132.432 192.565L132.564 192.43L132.566 192.428L133.223 191.774C130.423 191.559 128.196 189.33 127.982 186.53L127.325 187.184L127.323 187.186L127.191 187.321C127.232 190.203 129.551 192.523 132.432 192.565ZM127.191 186.78V103.21L127.966 103.98L127.966 186.009L127.191 186.78ZM127.982 103.459C128.196 100.663 130.424 98.4308 133.223 98.2153L132.564 97.5591L132.432 97.4239C129.551 97.4662 127.232 99.7913 127.191 102.668L127.324 102.804L127.982 103.459Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    transform: "translate(0 -18)"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_wd_back_fadein",
    attributeName: "fill-opacity",
    from: 0,
    to: 1,
    begin: "hinava_random_uuid_wd_magnet_fadeout.end+1s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    from: 1,
    to: 0,
    begin: "hinava_random_uuid_wd_hinava_blink.end+2s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78 69.43V70.22H36.05L33.46 70.32V69.43H50.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7799 69.2V69.24H45.6299V66.6V66.24H46.7399V69.04L50.7799 69.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2799 69.38H42.1699V66.6H45.6299V69.24L49.2799 69.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17 66.6V69.38L38.27 69.24V66.24L39.19 66.32V66.33L42.17 66.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2701 66.24V69.24H32.3V66.24H32.8801H38.2701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3001 66.24V69.24L27.0901 69.04V58L29.0501 58.08V61.67V63.3C29.0501 64.78 29.5901 65.99 30.2901 66.05L32.3001 66.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 58.08V64L29.05 61.67V58.08H31.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 64L32.8801 66.24H32.3L30.2901 66.05C29.5901 65.99 29.05 64.78 29.05 63.3V61.67L31.0001 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.41 58.74V58.08H35.12V58.74H35.08V59.32H35.53H35.66V59.46H35.78C35.78 59.46 35.86 59.46 35.97 59.46H36.49H36.55C36.75 59.46 36.96 59.46 37.17 59.46H37.54H38.99L39.19 59.7L38.98 59.88C38.64 60.13 38.25 60.23 37.84 60.26H39.19V66.32L38.27 66.24H32.88L31 64V58.08H31.74V58.74H31.7V59.32H32.16H32.98V58.74H33.41V58.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7399 60.17V66.24H45.6299V66.6H42.1699L39.1899 66.33V66.32V60.26H39.2099H40.5399C40.1299 60.23 39.7499 60.13 39.4099 59.88L39.1899 59.7L39.3999 59.46H39.4099H39.5099H39.8699H41.1699V60.17H41.3199H41.6599H41.8099V59.46H41.8999V60.17H42.0499H42.3899H42.5499V59.46H42.6899H43.0599H43.0699H43.1299V60.17H43.2799H43.6199H43.7699V59.46H43.8899V60.17H44.0199H44.3799H44.5099V59.46H45.1199V60.17H45.2499H45.6099H45.7399V59.46H46.3499V60.17H46.4699H46.7399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7399 58.08V59.46H46.3499H45.7399H45.6099H45.1199H44.5099H44.3799H43.8899H43.7699H43.6199H43.1299H43.0699H43.0599H42.6899V58.08H46.7399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.69 58.08V59.46H42.55H42.39H41.9H41.81H41.66H41.17H39.87H39.51V57.53H39.53H40.42V58L42.14 58.08H42.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9899 59.46H37.5399H37.1699V51.29H40.4199V51.81C40.2699 51.92 40.1799 52.1 40.1899 52.28V53.39C40.1799 53.57 40.2699 53.75 40.4199 53.85V57.53H39.5299H39.5099H39.4099H39.3899H39.0099V59.46H38.9899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1699 51.29V59.46C36.9599 59.46 36.7499 59.46 36.5499 59.46H36.4899H35.9699C35.8599 59.46 35.7799 59.46 35.7799 59.46H35.6599V59.32V58.74V57.09V56.51V51.29H37.1699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4699 57.09V58.08L33.4199 58V51.11L35.4699 51.29V56.51V57.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5601 46.1V46.28C15.5601 46.66 15.29 46.97 14.95 46.97H14.1001C13.7601 46.97 13.48 47.28 13.48 47.66V54.15C13.48 54.54 13.2101 54.84 12.8701 54.84H12.5001C12.1601 54.84 11.89 54.54 11.89 54.15V47.66C11.89 47.31 11.6501 47.02 11.3401 46.98C11.3201 46.97 11.2901 46.97 11.2701 46.97H10.4301C10.1001 46.97 9.82007 46.66 9.82007 46.28V46.1C9.82007 45.72 10.1001 45.41 10.4301 45.41H10.6801H14.95C15.29 45.41 15.5601 45.72 15.5601 46.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8101 46.77C19.7701 46.76 19.7301 46.75 19.6901 46.75H19.6801C18.1001 46.86 17.8501 48.85 17.8301 50.12C17.8501 51.37 18.1101 53.36 19.6701 53.48C19.7201 53.48 19.7601 53.47 19.8001 53.46C21.2701 53.25 21.4801 51.3 21.5101 50.08C21.4801 48.87 21.2501 46.97 19.8101 46.77ZM23.1901 50.01C23.2901 52.18 22.2401 54.93 19.7401 54.93H19.6201C17.1501 54.98 16.0801 52.27 16.1401 50.15C16.0801 47.98 17.2301 45.27 19.7201 45.29H19.7901C22.1901 45.29 23.2601 47.92 23.1901 50.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7799 48.21C29.8799 50 28.4599 51.49 26.6599 51.4C26.2999 51.39 26.0299 51.74 26.0299 52.09V54.2C26.0299 54.58 25.7599 54.89 25.4199 54.89H25.2999H25.0499C24.7099 54.89 24.4399 54.58 24.4399 54.2L24.4299 46.19C24.4299 45.87 24.6599 45.54 24.9799 45.5C25.5099 45.44 26.0399 45.42 26.5699 45.41H26.5999C27.4299 45.41 28.3299 45.54 28.9699 46.12C29.5399 46.65 29.7799 47.45 29.7799 48.21ZM26.6699 49.96C27.5799 50 28.2299 49.17 28.1799 48.3C28.2399 47.5 27.6799 46.78 26.8899 46.76C26.8499 46.74 26.7999 46.75 26.7599 46.75H26.7299H26.6299C26.2899 46.76 26.0299 47.1 26.0299 47.44V49.27C26.0299 49.63 26.3099 49.98 26.6699 49.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5699 206.79H35.6699V208.7H36.5699V206.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3399 106.73V107.78H37.1899H37.1599V109.02H36.2199V107.78H35.1499V106.73H36.2199V105.5H37.1599V106.73H37.1899H38.3399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0099 219.71H30.03C30 220.15 29.99 220.62 30.02 221.09H26.95C26.95 220.35 27.23 219.74 27.58 219.71H30.0099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0799 218.96H30.0899C30.0599 219.2 30.0399 219.45 30.0299 219.71H30.0099H27.5799L23.0499 220.13H4.92993L18.1699 218.96H30.0799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.37 223.06H27.59C27.24 223.04 26.95 222.43 26.95 221.68H30.07C30.13 222.16 30.22 222.63 30.37 223.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78 225.16V225.95H33.46V225.06L36.05 225.16H50.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4601 225.06V225.95L23.05 226.34V220.13L27.58 219.71C27.23 219.74 26.95 220.35 26.95 221.09V221.68C26.95 222.43 27.2401 223.04 27.5901 223.06L30.4001 223.16C30.7101 224.05 31.2501 224.76 32.0901 225.01L33.4601 225.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.42 226.34V235.45H29.55V243.31H18.35H14.5C8.93999 243.37 4.79998 237.88 4.92998 232.55V232.53V220.13H23.05V226.34H33.42V226.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2899 235.52V236.53H41.9099V235.51L42.2399 235.52H44.2899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3201 229.17V231.22L35.3701 231.01V229.44L38.3201 229.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5199 226V226.26L40.4199 226.34V228.97L38.3199 229.17L35.3699 229.44V231.01V231.22V234.34V235.52L33.4199 235.45V226.34L42.5199 226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2901 236.53V237.56H40.2801C38.2501 237.56 36.3701 236.33 35.3701 234.34V231.22H38.3201V229.17L40.4201 228.97V235.45L41.9101 235.51V236.53H44.2901V236.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.28 237.56L33.23 238.07C32.64 238.07 32.06 237.96 31.5 237.76V235.52H35.37V234.34C36.37 236.33 38.25 237.56 40.28 237.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5001 242.36V243.13L29.55 243.31V235.45L31.5001 235.52V237.76V241.92V242.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.26 238.07V242.21H33.72C32.97 242.21 32.23 242.11 31.5 241.92V237.76C32.06 237.96 32.64 238.07 33.23 238.07H37.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29 237.56V241.7L39.28 242.06L37.3 242.21H37.26V238.07L44.29 237.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.55 243.23C65.49 242.56 69.03 237.48 68.91 232.55H69.15C69.15 238.17 65.43 242.79 60.6 243.48L59.34 243.58H14.5L18.35 243.31H29.55L31.5 243.13V242.36L33.72 242.21H37.26H37.3H44.29V243.31H59.34C59.61 243.31 59.88 243.3 60.14 243.27C60.28 243.27 60.42 243.25 60.55 243.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3299 231.03C96.4799 238.48 90.7799 246.12 82.9499 246.06H79.6799C86.3199 245.06 91.3599 238.67 91.3599 231.03H96.3299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.84 232.56L91.36 231.03C91.36 238.67 86.32 245.06 79.68 246.06C79.41 246.1 79.13 246.14 78.85 246.16L60.76 247.64C67.55 246.85 72.84 240.4 72.84 232.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9099 232.55C69.0299 237.48 65.4899 242.56 60.5499 243.23L60.1399 243.27C59.8799 243.3 59.6099 243.31 59.3399 243.31H44.2899V242.21V242.06V241.7V237.56V236.53V235.52V235.45H40.4199V228.97V226.34H50.7799V225.95V225.16V225.01V224.48V221.68V221.09V220.13H68.9099V232.55V232.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1501 218.96V220.1L68.9101 220.13H50.7801L55.01 219.71H50.55C50.58 219.45 50.63 219.21 50.7 218.96H65.4401L65.7501 218.93C65.9901 218.95 66.4501 218.96 67.0601 218.96H69.1501V218.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2401 141.62V144.1L90.6201 143.41V142.31L91.2401 141.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3601 141.48L91.2401 141.62L90.6201 142.31H72.1001L72.8401 141.48H91.3601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2401 144.1L91.3601 144.24H72.8401L72.1001 143.41H90.6201L91.2401 144.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6201 142.31H72.1001V143.41H90.6201V142.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.95 73.7H30.07C30.04 73.89 30.03 74.09 30.02 74.29H26.95V73.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.03 75.67H30.0099H27.58C27.23 75.64 26.95 75.03 26.95 74.29H30.02C29.99 74.75 29.99 75.22 30.03 75.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.59 72.32H30.37C30.22 72.74 30.13 73.21 30.07 73.7H26.95C26.95 72.95 27.24 72.34 27.59 72.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4601 69.43V70.32L32.0901 70.37C31.2701 70.61 30.7301 71.31 30.4101 72.22L27.5901 72.32C27.2401 72.34 26.95 72.95 26.95 73.7V74.29C26.95 75.03 27.23 75.64 27.58 75.67L23.05 75.25V69.04L33.4601 69.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1099 76.42H30.0799H18.1699L4.92993 75.25H23.0499L27.5799 75.67H30.0099H30.0299C30.0499 75.93 30.0699 76.18 30.1099 76.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.56 76.49V218.89C65.55 218.91 65.51 218.94 65.44 218.96H50.7C50.76 218.73 50.84 218.49 50.94 218.27H57.39H61.07C61.48 218.22 61.89 218.2 62.3 218.2H65.43V99.81C65.43 98.23 64.98 96.67 64.13 95.33V92.31H65.43V85.31C65.43 84.35 64.78 83.51 63.86 83.27H53.93V83.2C53.75 83.2 53.58 83.12 53.46 82.99H53.69V82.98C53.7 82.99 53.7199 82.99 53.7299 82.99L58.32 82.81L58.3 80.88H53.25C53.11 80.78 52.99 80.64 52.92 80.48L51.0099 77.24C50.8799 76.98 50.77 76.7 50.7 76.42H65.44C65.51 76.44 65.55 76.47 65.56 76.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0601 76.42V218.96C66.4501 218.96 65.9901 218.95 65.7501 218.93C65.6301 218.92 65.5601 218.9 65.5601 218.89V76.49C65.5601 76.48 65.6301 76.46 65.7501 76.45C65.9901 76.43 66.4501 76.42 67.0601 76.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.15 75.28V76.42H67.06C66.45 76.42 65.99 76.43 65.75 76.45L65.44 76.42H50.7C50.62 76.18 50.57 75.93 50.54 75.67H50.55H55.01L50.78 75.25H68.91L69.15 75.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1799 79.38V83.27H28.0899C27.1699 83.51 26.5199 84.35 26.5199 85.31V92.31H27.8199V95.33C26.9699 96.67 26.5199 98.23 26.5199 99.81V218.2H29.6499C29.8399 218.2 30.0299 218.21 30.2099 218.21C30.1599 218.43 30.1199 218.69 30.0899 218.96H30.0799H18.1699V76.42H30.0799H30.1099C30.2399 77.37 30.4899 78.21 30.8199 78.77L31.1799 79.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1699 76.42V218.96L4.92993 220.13V232.53L4.67993 232.55V53.17L4.92993 53.19V75.25L18.1699 76.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3601 144.24V231.03L72.8401 232.56V144.24H91.3601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.33 54.69V231.03H91.36V144.24L91.24 144.1V141.62L91.36 141.48V54.69H96.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9499 39.66C90.7799 39.61 96.4799 47.24 96.3299 54.69H91.3599C91.3599 47.05 86.3199 40.66 79.6799 39.66H82.9499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3601 54.69L72.8401 53.17C72.8401 45.16 67.3301 38.61 60.3301 38.05V38.04L78.8501 39.56C79.1301 39.58 79.4101 39.62 79.6801 39.66C86.3201 40.66 91.3601 47.05 91.3601 54.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3601 54.69V141.48H72.8401V53.17L91.3601 54.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6 243.48C65.43 242.79 69.15 238.17 69.15 232.55V220.1V218.96V76.42V75.28V53.17C69.15 47.63 65.51 43.04 60.77 42.26H60.75C60.3 42.18 59.83 42.14 59.36 42.14H59.34H14.52H14.5C9.08 42.14 4.67999 47.08 4.67999 53.17V232.55C4.67999 238.65 9.08 243.58 14.5 243.58H59.34C59.77 243.58 60.19 243.55 60.6 243.48ZM72.84 144.24V232.56C72.84 240.4 67.55 246.85 60.76 247.64C60.62 247.66 60.47 247.68 60.33 247.68C60 247.72 59.67 247.73 59.34 247.73H14.5C7.04 247.73 1 240.94 1 232.56V53.17C1 44.79 7.04 38 14.5 38H59.34C59.67 38 60 38.01 60.33 38.05C67.33 38.61 72.84 45.16 72.84 53.17V141.48L72.1 142.31V143.41L72.84 144.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57 45.41C26.04 45.42 25.51 45.44 24.98 45.5C24.66 45.54 24.43 45.87 24.43 46.19L24.44 54.2C24.44 54.58 24.71 54.89 25.05 54.89H25.3H25.42H25.68C26.02 54.89 26.29 54.58 26.29 54.2V52.1C26.28 51.75 26.55 51.41 26.89 51.41C26.9 51.41 26.91 51.41 26.91 51.41C28.72 51.49 30.14 50 30.03 48.21C30.03 47.45 29.8 46.65 29.22 46.12C28.58 45.54 27.69 45.4 26.85 45.4L26.6 45.41H26.57ZM68.91 53.17V75.25H50.78V74.29V73.7V70.9V70.37V70.22V69.43V69.24V69.2V69.04H46.74V66.24V60.17V59.46V58.08V58H40.42V57.53V53.85V53.39V52.28V51.81V51.29V51.11H33.42V58H27.09V69.04H23.05V75.25H4.92998V53.19V53.17C4.79998 47.85 8.93999 42.35 14.5 42.42H18.35H59.34C59.72 42.42 60.08 42.44 60.44 42.48C65.44 43.09 69.03 48.21 68.91 53.17ZM19.87 54.94C22.46 55.03 23.54 52.22 23.45 50.01C23.52 47.9 22.42 45.24 19.98 45.29H19.79H19.72C17.23 45.27 16.08 47.98 16.14 50.15C16.08 52.27 17.15 54.98 19.62 54.93H19.74L19.87 54.94ZM15.82 46.29V46.1C15.82 45.71 15.54 45.41 15.2 45.41H14.95H10.68H10.43C10.1 45.41 9.81999 45.72 9.81999 46.1V46.28C9.81999 46.66 10.1 46.97 10.43 46.97L10.68 46.98H11.34C11.65 47.02 11.89 47.31 11.89 47.66V54.15C11.89 54.54 12.16 54.84 12.5 54.84L12.75 54.85H13.13C13.47 54.85 13.74 54.54 13.74 54.16V47.67C13.74 47.29 14.01 46.98 14.35 46.98H15.2C15.54 46.98 15.82 46.67 15.82 46.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4299 99.81V218.2H62.2999H60.6799V99.81H65.4299Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4299 85.31V92.31H64.1299H60.6799V85.31H65.4299Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.43 85.31H60.68H26.52C26.52 84.35 27.17 83.51 28.09 83.27H31.18H34.11H38.02H53.93H63.86C64.78 83.51 65.43 84.35 65.43 85.31Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.43 99.81H60.68C60.69 98.26 60.33 96.73 59.7 95.33H64.13C64.98 96.67 65.43 98.23 65.43 99.81Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13 92.31V95.33H59.7V92.31H60.68H64.13Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78 221.68V224.48C49.62 222.61 49.28 220.33 49.87 218.2H60.68H62.3C61.89 218.2 61.48 218.22 61.07 218.27H57.39H50.94C50.84 218.49 50.76 218.73 50.7 218.96C50.63 219.21 50.58 219.45 50.55 219.71H55.01L50.78 220.13V221.09V221.68V221.68Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68 99.81V218.2H49.87H29.65H26.52V99.81H60.68ZM38.37 107.78V106.73H38.34H37.19V105.5H37.16H36.22V106.73H35.15V107.78H36.22V109.02H37.16H37.19V107.78H38.34H38.37ZM36.6 208.7V206.79H36.57H35.67V208.7H36.57H36.6Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7 95.33C60.33 96.73 60.69 98.26 60.68 99.81H26.52C26.52 98.23 26.97 96.67 27.82 95.33H59.7Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68 85.31V92.31H59.7H27.82H26.52V85.31H60.68Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7 92.31H27.8201V95.33H59.7V92.31Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3 80.88L58.32 82.81L53.7299 82.99L53.71 81.06L58.3 80.88Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7801 74.29V75.25L55.0101 75.67H50.5501H50.5401C50.5701 75.93 50.6201 76.18 50.7001 76.42C50.7701 76.7 50.8801 76.98 51.0101 77.24L50.4701 78.77C49.1601 76.28 49.2801 73.28 50.7801 70.9V73.7V74.29V74.29Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.46 82.99C53.58 83.12 53.75 83.2 53.93 83.2H51.99H38.02C38.2 83.2 38.37 83.12 38.49 82.99H34.11H34.08C33.48 82.93 32.97 82.56 32.73 82.01H52.38C52.61 82.55 53.11 82.91 53.69 82.98V82.99H53.46Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7099 81.06L53.7299 82.99C53.7199 82.99 53.6999 82.99 53.6899 82.98C53.1099 82.91 52.6099 82.55 52.3799 82.01L52.9199 80.48C52.9899 80.64 53.1099 80.78 53.2499 80.88C53.3799 80.98 53.5399 81.04 53.7099 81.06Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0099 77.24L52.92 80.48L52.38 82.01L50.47 78.77L51.0099 77.24Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4701 78.77L52.3801 82.01H32.73L31.1801 79.38L30.8201 78.77H50.4701Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 223.16C30.3899 223.13 30.3699 223.09 30.3699 223.06C30.2199 222.63 30.1299 222.16 30.0699 221.68C30.0499 221.48 30.0299 221.29 30.0199 221.09C29.9899 220.62 29.9999 220.15 30.0299 219.71C30.0399 219.45 30.0599 219.2 30.0899 218.96C30.1199 218.69 30.1599 218.43 30.2099 218.21C30.0299 218.21 29.8399 218.2 29.6499 218.2H49.8699C49.2799 220.33 49.6199 222.61 50.7799 224.48V225.01H32.0899C31.2499 224.76 30.7099 224.05 30.3999 223.16Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4099 72.22C30.7299 71.31 31.2699 70.61 32.0899 70.37H50.7799V70.9C49.2799 73.28 49.1599 76.28 50.4699 78.77H30.8199C30.4899 78.21 30.2399 77.37 30.1099 76.42C30.0699 76.18 30.0499 75.93 30.0299 75.67C29.9899 75.22 29.9899 74.75 30.0199 74.29C30.0299 74.09 30.0399 73.89 30.0699 73.7C30.1299 73.21 30.2199 72.74 30.3699 72.32C30.3799 72.28 30.3899 72.25 30.4099 72.22Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5201 99.4556C26.7158 99.4556 26.8745 99.6143 26.8745 99.81V218.2C26.8745 218.396 26.7158 218.554 26.5201 218.554C26.3244 218.554 26.1658 218.396 26.1658 218.2V99.81C26.1658 99.6143 26.3244 99.4556 26.5201 99.4556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.43 99.4556C65.6257 99.4556 65.7844 99.6143 65.7844 99.81V218.2C65.7844 218.396 65.6257 218.554 65.43 218.554C65.2343 218.554 65.0757 218.396 65.0757 218.2V99.81C65.0757 99.6143 65.2343 99.4556 65.43 99.4556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5201 84.9556C26.7158 84.9556 26.8745 85.1143 26.8745 85.31V92.31C26.8745 92.5057 26.7158 92.6643 26.5201 92.6643C26.3244 92.6643 26.1658 92.5057 26.1658 92.31V85.31C26.1658 85.1143 26.3244 84.9556 26.5201 84.9556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.43 84.9556C65.6257 84.9556 65.7844 85.1143 65.7844 85.31V92.31C65.7844 92.5057 65.6257 92.6643 65.43 92.6643C65.2343 92.6643 65.0757 92.5057 65.0757 92.31V85.31C65.0757 85.1143 65.2343 84.9556 65.43 84.9556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0099 95.0308C28.1752 95.1356 28.2242 95.3545 28.1194 95.5198C27.3055 96.8028 26.8745 98.2969 26.8745 99.81C26.8745 100.006 26.7158 100.164 26.5201 100.164C26.3244 100.164 26.1658 100.006 26.1658 99.81C26.1658 98.1631 26.6347 96.5372 27.5209 95.1402C27.6257 94.9749 27.8447 94.9259 28.0099 95.0308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9402 95.0308C64.1055 94.9259 64.3244 94.9749 64.4293 95.1402C65.3154 96.5372 65.7844 98.1631 65.7844 99.81C65.7844 100.006 65.6257 100.164 65.43 100.164C65.2343 100.164 65.0757 100.006 65.0757 99.81C65.0757 98.2969 64.6446 96.8028 63.8308 95.5198C63.726 95.3545 63.775 95.1356 63.9402 95.0308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5172 83.1805C63.5666 82.9912 63.7601 82.8777 63.9495 82.9271C65.0262 83.208 65.7844 84.1894 65.7844 85.31C65.7844 85.5057 65.6258 85.6643 65.4301 85.6643C65.2344 85.6643 65.0757 85.5057 65.0757 85.31C65.0757 84.5106 64.5339 83.812 63.7706 83.6128C63.5812 83.5634 63.4678 83.3699 63.5172 83.1805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.433 83.1805C28.4824 83.3699 28.3689 83.5634 28.1796 83.6128C27.4162 83.812 26.8745 84.5106 26.8745 85.31C26.8745 85.5057 26.7158 85.6643 26.5201 85.6643C26.3244 85.6643 26.1658 85.5057 26.1658 85.31C26.1658 84.1894 26.924 83.208 28.0007 82.9271C28.19 82.8777 28.3836 82.9912 28.433 83.1805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8202 91.9556C28.0159 91.9556 28.1745 92.1143 28.1745 92.31V95.33C28.1745 95.5257 28.0159 95.6843 27.8202 95.6843C27.6245 95.6843 27.4658 95.5257 27.4658 95.33V92.31C27.4658 92.1143 27.6245 91.9556 27.8202 91.9556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1302 91.9556C64.3259 91.9556 64.4846 92.1143 64.4846 92.31V95.33C64.4846 95.5257 64.3259 95.6843 64.1302 95.6843C63.9345 95.6843 63.7759 95.5257 63.7759 95.33V92.31C63.7759 92.1143 63.9345 91.9556 64.1302 91.9556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2957 218.2C29.2957 218.004 29.4543 217.846 29.65 217.846C29.7505 217.846 29.8501 217.848 29.9432 217.851L29.9445 217.851C30.0388 217.853 30.126 217.856 30.21 217.856C30.4057 217.856 30.5644 218.014 30.5644 218.21C30.5644 218.406 30.4057 218.564 30.21 218.564C30.1164 218.564 30.0211 218.562 29.9302 218.559L29.9243 218.559C29.8299 218.557 29.7395 218.554 29.65 218.554C29.4543 218.554 29.2957 218.396 29.2957 218.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0273 217.918C61.4542 217.866 61.8787 217.846 62.3002 217.846C62.4959 217.846 62.6545 218.004 62.6545 218.2C62.6545 218.396 62.4959 218.554 62.3002 218.554C61.9016 218.554 61.5063 218.574 61.1131 218.622C60.9188 218.645 60.7422 218.507 60.7185 218.313C60.6948 218.119 60.833 217.942 61.0273 217.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2197 82.7296C53.3635 82.5969 53.5877 82.6058 53.7204 82.7496C53.7779 82.8119 53.8555 82.8456 53.9301 82.8456C54.1258 82.8456 54.2844 83.0043 54.2844 83.2C54.2844 83.3957 54.1258 83.5543 53.9301 83.5543C53.6447 83.5543 53.3822 83.4281 53.1997 83.2303C53.0669 83.0865 53.0759 82.8623 53.2197 82.7296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7305 82.7296C38.8743 82.8623 38.8832 83.0865 38.7505 83.2303C38.568 83.4281 38.3055 83.5543 38.0201 83.5543C37.8244 83.5543 37.6658 83.3957 37.6658 83.2C37.6658 83.0043 37.8244 82.8456 38.0201 82.8456C38.0947 82.8456 38.1723 82.8119 38.2297 82.7496C38.3625 82.6058 38.5867 82.5969 38.7305 82.7296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0201 82.8456C38.2158 82.8456 38.3745 83.0043 38.3745 83.2V83.27C38.3745 83.4657 38.2158 83.6243 38.0201 83.6243C37.8244 83.6243 37.6658 83.4657 37.6658 83.27V83.2C37.6658 83.0043 37.8244 82.8456 38.0201 82.8456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.93 82.8456C54.1257 82.8456 54.2844 83.0043 54.2844 83.2V83.27C54.2844 83.4657 54.1257 83.6243 53.93 83.6243C53.7343 83.6243 53.5757 83.4657 53.5757 83.27V83.2C53.5757 83.0043 53.7343 82.8456 53.93 82.8456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6858 82.99C33.6858 82.7943 33.8444 82.6356 34.0401 82.6356H38.6301C38.8258 82.6356 38.9845 82.7943 38.9845 82.99C38.9845 83.1857 38.8258 83.3443 38.6301 83.3443H34.0401C33.8444 83.3443 33.6858 83.1857 33.6858 82.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7458 82.99C48.7458 82.7943 48.9045 82.6356 49.1002 82.6356H53.6902C53.8859 82.6356 54.0445 82.7943 54.0445 82.99C54.0445 83.1857 53.8859 83.3443 53.6902 83.3443H49.1002C48.9045 83.3443 48.7458 83.1857 48.7458 82.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.66 50.9356C35.8557 50.9356 36.0144 51.0943 36.0144 51.29V59.46C36.0144 59.6557 35.8557 59.8143 35.66 59.8143C35.4643 59.8143 35.3057 59.6557 35.3057 59.46V51.29C35.3057 51.0943 35.4643 50.9356 35.66 50.9356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7874 42.4147C59.8069 42.22 59.9805 42.0779 60.1753 42.0974L60.4744 42.1273L62.0535 42.2772C62.2483 42.2957 62.3913 42.4686 62.3728 42.6634C62.3543 42.8583 62.1814 43.0012 61.9865 42.9827L60.4048 42.8326L60.1048 42.8025C59.91 42.7831 59.768 42.6094 59.7874 42.4147Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3728 243.056C62.3913 243.251 62.2484 243.424 62.0536 243.443L60.5844 243.583L60.1744 243.623C59.9797 243.642 59.8064 243.499 59.7873 243.304C59.7683 243.11 59.9108 242.936 60.1056 242.917L60.5156 242.877L61.9864 242.737C62.1812 242.719 62.3542 242.862 62.3728 243.056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9658 45.41C25.9658 45.2143 26.1245 45.0557 26.3202 45.0557H26.5702C26.7659 45.0557 26.9245 45.2143 26.9245 45.41C26.9245 45.6057 26.7659 45.7644 26.5702 45.7644H26.3202C26.1245 45.7644 25.9658 45.6057 25.9658 45.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5602 76.1356C65.7559 76.1356 65.9145 76.2943 65.9145 76.49V218.9C65.9145 219.096 65.7559 219.254 65.5602 219.254C65.3645 219.254 65.2058 219.096 65.2058 218.9V76.49C65.2058 76.2943 65.3645 76.1356 65.5602 76.1356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.977 38.011C59.993 37.8159 60.1641 37.6708 60.3592 37.6868L78.8792 39.2068C79.0743 39.2228 79.2194 39.3939 79.2034 39.589C79.1874 39.784 79.0163 39.9292 78.8212 39.9131L60.3012 38.3931C60.1062 38.3771 59.961 38.206 59.977 38.011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2033 246.131C79.2193 246.326 79.0741 246.497 78.8791 246.513L60.789 247.993C60.594 248.009 60.4229 247.864 60.407 247.669C60.391 247.474 60.5362 247.303 60.7312 247.287L78.8213 245.807C79.0163 245.791 79.1874 245.936 79.2033 246.131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3257 218.2C60.3257 218.004 60.4843 217.846 60.68 217.846H65.43C65.6257 217.846 65.7844 218.004 65.7844 218.2C65.7844 218.396 65.6257 218.554 65.43 218.554H60.68C60.4843 218.554 60.3257 218.396 60.3257 218.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1658 218.2C26.1658 218.004 26.3244 217.846 26.5201 217.846H60.6801C60.8758 217.846 61.0345 218.004 61.0345 218.2C61.0345 218.396 60.8758 218.554 60.6801 218.554H26.5201C26.3244 218.554 26.1658 218.396 26.1658 218.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.68 99.4556C60.8757 99.4556 61.0344 99.6143 61.0344 99.81V218.2C61.0344 218.396 60.8757 218.554 60.68 218.554C60.4843 218.554 60.3257 218.396 60.3257 218.2V99.81C60.3257 99.6143 60.4843 99.4556 60.68 99.4556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.19 105.146C37.3857 105.146 37.5444 105.304 37.5444 105.5V106.73C37.5444 106.926 37.3857 107.084 37.19 107.084C36.9943 107.084 36.8357 106.926 36.8357 106.73V105.5C36.8357 105.304 36.9943 105.146 37.19 105.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.19 107.426C37.3857 107.426 37.5444 107.584 37.5444 107.78V109.02C37.5444 109.216 37.3857 109.374 37.19 109.374C36.9943 109.374 36.8357 109.216 36.8357 109.02V107.78C36.8357 107.584 36.9943 107.426 37.19 107.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.37 106.376C38.5657 106.376 38.7243 106.534 38.7243 106.73V107.78C38.7243 107.976 38.5657 108.134 38.37 108.134C38.1743 108.134 38.0156 107.976 38.0156 107.78V106.73C38.0156 106.534 38.1743 106.376 38.37 106.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6002 206.436C36.7959 206.436 36.9545 206.594 36.9545 206.79V208.7C36.9545 208.896 36.7959 209.054 36.6002 209.054C36.4045 209.054 36.2458 208.896 36.2458 208.7V206.79C36.2458 206.594 36.4045 206.436 36.6002 206.436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3257 92.31C60.3257 92.1143 60.4843 91.9556 60.68 91.9556H65.43C65.6257 91.9556 65.7844 92.1143 65.7844 92.31C65.7844 92.5057 65.6257 92.6643 65.43 92.6643H60.68C60.4843 92.6643 60.3257 92.5057 60.3257 92.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1658 92.31C26.1658 92.1143 26.3244 91.9556 26.5201 91.9556H60.6801C60.8758 91.9556 61.0345 92.1143 61.0345 92.31C61.0345 92.5057 60.8758 92.6643 60.6801 92.6643H26.5201C26.3244 92.6643 26.1658 92.5057 26.1658 92.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.68 84.9556C60.8757 84.9556 61.0344 85.1143 61.0344 85.31V92.31C61.0344 92.5057 60.8757 92.6643 60.68 92.6643C60.4843 92.6643 60.3257 92.5057 60.3257 92.31V85.31C60.3257 85.1143 60.4843 84.9556 60.68 84.9556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3457 95.33C59.3457 95.1343 59.5044 94.9756 59.7001 94.9756H64.1301C64.3258 94.9756 64.4844 95.1343 64.4844 95.33C64.4844 95.5257 64.3258 95.6843 64.1301 95.6843H59.7001C59.5044 95.6843 59.3457 95.5257 59.3457 95.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4658 95.33C27.4658 95.1343 27.6245 94.9756 27.8202 94.9756H59.7001C59.8958 94.9756 60.0545 95.1343 60.0545 95.33C60.0545 95.5257 59.8958 95.6843 59.7001 95.6843H27.8202C27.6245 95.6843 27.4658 95.5257 27.4658 95.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5547 95.0068C59.7332 94.9265 59.943 95.0061 60.0233 95.1845C60.6719 96.6259 61.0449 98.2061 61.0345 99.8122C61.0332 100.008 60.8736 100.166 60.6779 100.164C60.4822 100.163 60.3245 100.003 60.3258 99.8077C60.3354 98.3138 59.9884 96.834 59.377 95.4754C59.2967 95.2969 59.3763 95.0871 59.5547 95.0068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7358 83.27C27.7358 83.0743 27.8945 82.9156 28.0902 82.9156H63.8602C64.0559 82.9156 64.2145 83.0743 64.2145 83.27C64.2145 83.4657 64.0559 83.6243 63.8602 83.6243H28.0902C27.8945 83.6243 27.7358 83.4657 27.7358 83.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7001 91.9556C59.8958 91.9556 60.0544 92.1143 60.0544 92.31V95.33C60.0544 95.5257 59.8958 95.6843 59.7001 95.6843C59.5044 95.6843 59.3457 95.5257 59.3457 95.33V92.31C59.3457 92.1143 59.5044 91.9556 59.7001 91.9556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0356 218.27C57.0356 218.074 57.1943 217.916 57.39 217.916H61.07C61.2657 217.916 61.4244 218.074 61.4244 218.27C61.4244 218.466 61.2657 218.624 61.07 218.624H57.39C57.1943 218.624 57.0356 218.466 57.0356 218.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5757 218.27C50.5757 218.074 50.7343 217.916 50.93 217.916H57.39C57.5857 217.916 57.7444 218.074 57.7444 218.27C57.7444 218.466 57.5857 218.624 57.39 218.624H50.93C50.7343 218.624 50.5757 218.466 50.5757 218.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9158 218.27C32.9158 218.074 33.0744 217.916 33.2701 217.916H46.7801C46.9758 217.916 47.1345 218.074 47.1345 218.27C47.1345 218.466 46.9758 218.624 46.7801 218.624H33.2701C33.0744 218.624 32.9158 218.466 32.9158 218.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3402 106.376C38.5359 106.376 38.6945 106.534 38.6945 106.73V107.78C38.6945 107.976 38.5359 108.134 38.3402 108.134C38.1445 108.134 37.9858 107.976 37.9858 107.78V106.73C37.9858 106.534 38.1445 106.376 38.3402 106.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9858 106.73C37.9858 106.534 38.1445 106.376 38.3402 106.376H38.3702C38.5659 106.376 38.7245 106.534 38.7245 106.73C38.7245 106.926 38.5659 107.084 38.3702 107.084H38.3402C38.1445 107.084 37.9858 106.926 37.9858 106.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9858 107.78C37.9858 107.584 38.1445 107.426 38.3402 107.426H38.3702C38.5659 107.426 38.7245 107.584 38.7245 107.78C38.7245 107.976 38.5659 108.134 38.3702 108.134H38.3402C38.1445 108.134 37.9858 107.976 37.9858 107.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2201 107.426C36.4158 107.426 36.5744 107.584 36.5744 107.78V109.02C36.5744 109.216 36.4158 109.374 36.2201 109.374C36.0244 109.374 35.8657 109.216 35.8657 109.02V107.78C35.8657 107.584 36.0244 107.426 36.2201 107.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7957 107.78C34.7957 107.584 34.9543 107.426 35.15 107.426H36.22C36.4157 107.426 36.5744 107.584 36.5744 107.78C36.5744 107.976 36.4157 108.134 36.22 108.134H35.15C34.9543 108.134 34.7957 107.976 34.7957 107.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.15 106.376C35.3457 106.376 35.5044 106.534 35.5044 106.73V107.78C35.5044 107.976 35.3457 108.134 35.15 108.134C34.9543 108.134 34.7957 107.976 34.7957 107.78V106.73C34.7957 106.534 34.9543 106.376 35.15 106.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7957 106.73C34.7957 106.534 34.9543 106.376 35.15 106.376H36.22C36.4157 106.376 36.5744 106.534 36.5744 106.73C36.5744 106.926 36.4157 107.084 36.22 107.084H35.15C34.9543 107.084 34.7957 106.926 34.7957 106.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2201 105.146C36.4158 105.146 36.5744 105.304 36.5744 105.5V106.73C36.5744 106.926 36.4158 107.084 36.2201 107.084C36.0244 107.084 35.8657 106.926 35.8657 106.73V105.5C35.8657 105.304 36.0244 105.146 36.2201 105.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8657 105.5C35.8657 105.304 36.0244 105.146 36.2201 105.146H37.1601C37.3558 105.146 37.5144 105.304 37.5144 105.5C37.5144 105.696 37.3558 105.854 37.1601 105.854H36.2201C36.0244 105.854 35.8657 105.696 35.8657 105.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.16 105.146C37.3557 105.146 37.5144 105.304 37.5144 105.5V106.73C37.5144 106.926 37.3557 107.084 37.16 107.084C36.9643 107.084 36.8057 106.926 36.8057 106.73V105.5C36.8057 105.304 36.9643 105.146 37.16 105.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.16 107.426C37.3557 107.426 37.5144 107.584 37.5144 107.78V109.02C37.5144 109.216 37.3557 109.374 37.16 109.374C36.9643 109.374 36.8057 109.216 36.8057 109.02V107.78C36.8057 107.584 36.9643 107.426 37.16 107.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8657 109.02C35.8657 108.824 36.0244 108.666 36.2201 108.666H37.1601C37.3558 108.666 37.5144 108.824 37.5144 109.02C37.5144 109.216 37.3558 109.374 37.1601 109.374H36.2201C36.0244 109.374 35.8657 109.216 35.8657 109.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8057 106.73C36.8057 106.534 36.9643 106.376 37.16 106.376H38.34C38.5357 106.376 38.6944 106.534 38.6944 106.73C38.6944 106.926 38.5357 107.084 38.34 107.084H37.16C36.9643 107.084 36.8057 106.926 36.8057 106.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8057 107.78C36.8057 107.584 36.9643 107.426 37.16 107.426H38.34C38.5357 107.426 38.6944 107.584 38.6944 107.78C38.6944 107.976 38.5357 108.134 38.34 108.134H37.16C36.9643 108.134 36.8057 107.976 36.8057 107.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8057 109.02C36.8057 108.824 36.9643 108.666 37.16 108.666H37.19C37.3857 108.666 37.5444 108.824 37.5444 109.02C37.5444 109.216 37.3857 109.374 37.19 109.374H37.16C36.9643 109.374 36.8057 109.216 36.8057 109.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8057 105.5C36.8057 105.304 36.9643 105.146 37.16 105.146H37.19C37.3857 105.146 37.5444 105.304 37.5444 105.5C37.5444 105.696 37.3857 105.854 37.19 105.854H37.16C36.9643 105.854 36.8057 105.696 36.8057 105.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2158 208.7C36.2158 208.504 36.3745 208.346 36.5702 208.346H36.6002C36.7959 208.346 36.9545 208.504 36.9545 208.7C36.9545 208.896 36.7959 209.054 36.6002 209.054H36.5702C36.3745 209.054 36.2158 208.896 36.2158 208.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5702 206.436C36.7659 206.436 36.9245 206.594 36.9245 206.79V208.7C36.9245 208.896 36.7659 209.054 36.5702 209.054C36.3745 209.054 36.2158 208.896 36.2158 208.7V206.79C36.2158 206.594 36.3745 206.436 36.5702 206.436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2158 206.79C36.2158 206.594 36.3745 206.436 36.5702 206.436H36.6002C36.7959 206.436 36.9545 206.594 36.9545 206.79C36.9545 206.986 36.7959 207.144 36.6002 207.144H36.5702C36.3745 207.144 36.2158 206.986 36.2158 206.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.67 206.436C35.8657 206.436 36.0244 206.594 36.0244 206.79V208.7C36.0244 208.896 35.8657 209.054 35.67 209.054C35.4743 209.054 35.3157 208.896 35.3157 208.7V206.79C35.3157 206.594 35.4743 206.436 35.67 206.436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3157 208.7C35.3157 208.504 35.4743 208.346 35.67 208.346H36.57C36.7658 208.346 36.9244 208.504 36.9244 208.7C36.9244 208.896 36.7658 209.054 36.57 209.054H35.67C35.4743 209.054 35.3157 208.896 35.3157 208.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3157 206.79C35.3157 206.594 35.4743 206.436 35.67 206.436H36.57C36.7658 206.436 36.9244 206.594 36.9244 206.79C36.9244 206.986 36.7658 207.144 36.57 207.144H35.67C35.4743 207.144 35.3157 206.986 35.3157 206.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6658 83.2C37.6658 83.0043 37.8244 82.8456 38.0201 82.8456H51.9901C52.1858 82.8456 52.3445 83.0043 52.3445 83.2C52.3445 83.3957 52.1858 83.5543 51.9901 83.5543H38.0201C37.8244 83.5543 37.6658 83.3957 37.6658 83.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6357 83.2C51.6357 83.0043 51.7944 82.8456 51.9901 82.8456H53.9301C54.1258 82.8456 54.2844 83.0043 54.2844 83.2C54.2844 83.3957 54.1258 83.5543 53.9301 83.5543H51.9901C51.7944 83.5543 51.6357 83.3957 51.6357 83.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9691 70.6002C51.1347 70.7046 51.1843 70.9234 51.08 71.0889C49.6473 73.3621 49.5328 76.2272 50.7838 78.605C50.8749 78.7782 50.8084 78.9925 50.6352 79.0836C50.462 79.1747 50.2477 79.1082 50.1566 78.935C48.7876 76.3327 48.9131 73.1979 50.4804 70.7111C50.5848 70.5455 50.8036 70.4959 50.9691 70.6002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5612 74.307C50.7561 74.3242 50.9002 74.4962 50.883 74.6911C50.8548 75.0109 50.8553 75.3258 50.8918 75.6273L50.8921 75.6294L50.8921 75.6294C50.9199 75.8707 50.9655 76.096 51.0362 76.3079C51.039 76.3165 51.0416 76.3252 51.0438 76.334C51.1064 76.5844 51.2062 76.84 51.3269 77.0815C51.4145 77.2565 51.3435 77.4694 51.1685 77.5569C50.9934 77.6444 50.7806 77.5735 50.6931 77.3984C50.5558 77.1239 50.4371 76.8242 50.3596 76.5191C50.2729 76.2555 50.2198 75.9854 50.1881 75.7116C50.1448 75.3534 50.1453 74.9887 50.177 74.6288C50.1942 74.4339 50.3662 74.2898 50.5612 74.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1281 76.9059C51.3126 76.971 51.4094 77.1734 51.3443 77.3579L50.8043 78.8879C50.7392 79.0725 50.5368 79.1693 50.3522 79.1042C50.1677 79.039 50.0709 78.8366 50.136 78.6521L50.676 77.1221C50.7411 76.9375 50.9435 76.8407 51.1281 76.9059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4658 78.77C30.4658 78.5743 30.6245 78.4156 30.8202 78.4156H50.4702C50.6659 78.4156 50.8245 78.5743 50.8245 78.77C50.8245 78.9657 50.6659 79.1243 50.4702 79.1243H30.8202C30.6245 79.1243 30.4658 78.9657 30.4658 78.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4301 70.2705C32.4851 70.4583 32.3774 70.6551 32.1896 70.7101C31.5233 70.9051 31.0449 71.4828 30.7443 72.3376C30.7367 72.3592 30.727 72.3801 30.7154 72.3999C30.7149 72.4016 30.7144 72.4036 30.7138 72.4059C30.711 72.4172 30.7076 72.4283 30.7037 72.4392C30.566 72.8247 30.4802 73.2661 30.4218 73.7431L30.4203 73.7553L30.42 73.7553C30.3935 73.9233 30.3841 74.104 30.3739 74.3077L30.3737 74.3131L30.3736 74.3131C30.3446 74.7581 30.3448 75.2096 30.383 75.6386L30.3834 75.6428L30.3833 75.6428C30.4035 75.9049 30.4225 76.1396 30.4595 76.3618L30.4612 76.3719L30.4611 76.372C30.5877 77.2975 30.8284 78.0862 31.1253 78.5901C31.2247 78.7587 31.1685 78.9759 30.9999 79.0753C30.8313 79.1746 30.6141 79.1185 30.5147 78.9499C30.1523 78.3349 29.8932 77.4456 29.7596 76.4731C29.7173 76.2176 29.6965 75.9548 29.6769 75.6993C29.6353 75.2298 29.6355 74.7431 29.6662 74.2697L29.6665 74.2639C29.6761 74.0717 29.6868 73.858 29.719 73.651C29.7799 73.1557 29.8725 72.6648 30.0308 72.2163C30.0416 72.1757 30.0578 72.1246 30.0874 72.0697C30.4289 71.1186 31.0278 70.3117 31.9905 70.0299C32.1783 69.975 32.3751 70.0826 32.4301 70.2705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.038 80.1458C53.2225 80.211 53.3193 80.4134 53.2542 80.5979L52.7142 82.1279C52.6491 82.3125 52.4467 82.4093 52.2622 82.3441C52.0776 82.279 51.9808 82.0766 52.0459 81.8921L52.5859 80.3621C52.651 80.1775 52.8534 80.0807 53.038 80.1458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2902 78.4647C50.4588 78.3654 50.676 78.4215 50.7754 78.59L52.6854 81.83C52.7848 81.9986 52.7287 82.2159 52.5601 82.3153C52.3915 82.4146 52.1743 82.3585 52.0749 82.19L50.1649 78.9499C50.0655 78.7814 50.1216 78.5641 50.2902 78.4647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8302 76.9347C50.9988 76.8353 51.216 76.8914 51.3154 77.06L53.2254 80.3C53.3248 80.4686 53.2687 80.6858 53.1001 80.7852C52.9315 80.8846 52.7143 80.8285 52.6149 80.6599L50.7049 77.4199C50.6055 77.2513 50.6616 77.0341 50.8302 76.9347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3757 82.01C32.3757 81.8143 32.5344 81.6556 32.7301 81.6556H52.3801C52.5758 81.6556 52.7345 81.8143 52.7345 82.01C52.7345 82.2057 52.5758 82.3643 52.3801 82.3643H32.7301C32.5344 82.3643 32.3757 82.2057 32.3757 82.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6401 78.4648C30.8087 78.3654 31.0259 78.4214 31.1254 78.5899L33.0355 81.8301C33.1348 81.9987 33.0787 82.2159 32.9101 82.3153C32.7415 82.4146 32.5243 82.3585 32.4249 82.1899L30.5151 78.9501C30.4156 78.7815 30.4716 78.5643 30.6401 78.4648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4043 70.2063C36.4118 70.4019 36.2594 70.5666 36.0639 70.5741L33.4739 70.6741L33.4731 70.6741L32.1031 70.7241C31.9075 70.7313 31.7432 70.5785 31.7361 70.3829C31.7289 70.1874 31.8817 70.023 32.0773 70.0159L33.4465 69.9659L33.4473 69.9659L36.0365 69.8659C36.2321 69.8584 36.3967 70.0108 36.4043 70.2063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6958 70.22C35.6958 70.0243 35.8544 69.8657 36.0502 69.8657H50.7802C50.9759 69.8657 51.1345 70.0243 51.1345 70.22C51.1345 70.4157 50.9759 70.5744 50.7802 70.5744H36.0502C35.8544 70.5744 35.6958 70.4157 35.6958 70.22Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2412 81.6839C52.4213 81.6073 52.6294 81.6911 52.7061 81.8711C52.8842 82.2894 53.2726 82.5727 53.7325 82.6282C53.754 82.6307 53.775 82.6353 53.7953 82.6416C53.9599 82.6722 54.0844 82.8166 54.0844 82.99C54.0844 83.1857 53.9258 83.3443 53.7301 83.3443C53.7299 83.3443 53.7297 83.3443 53.7293 83.3443C53.7235 83.3444 53.69 83.3446 53.6518 83.3382C53.6402 83.3363 53.6203 83.3326 53.5956 83.3248C52.9173 83.2254 52.3289 82.7941 52.0541 82.1488C51.9774 81.9688 52.0612 81.7606 52.2412 81.6839ZM53.7301 82.6356C53.7276 82.6356 53.7284 82.6355 53.7316 82.6356C53.7311 82.6356 53.7306 82.6356 53.7301 82.6356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7781 80.1553C52.9574 80.0769 53.1663 80.1587 53.2448 80.338C53.2866 80.4335 53.3627 80.5249 53.4561 80.5916L53.4663 80.5989L53.4662 80.5991C53.539 80.6552 53.6365 80.6945 53.7515 80.7081C53.9459 80.7309 54.0849 80.907 54.062 81.1014C54.0392 81.2958 53.8631 81.4348 53.6687 81.4119C53.4457 81.3857 53.2252 81.3063 53.0391 81.1647C52.8546 81.0316 52.6928 80.8444 52.5955 80.622C52.517 80.4427 52.5988 80.2338 52.7781 80.1553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7064 80.7056C53.9021 80.7036 54.0624 80.8606 54.0644 81.0563L54.0844 82.9863C54.0864 83.182 53.9294 83.3423 53.7337 83.3443C53.538 83.3463 53.3777 83.1893 53.3757 82.9936L53.3557 81.0636C53.3537 80.868 53.5107 80.7077 53.7064 80.7056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5885 81.6852C32.7678 81.6069 32.9767 81.6889 33.0549 81.8682C33.2433 82.2999 33.6421 82.59 34.1154 82.6374C34.3102 82.6568 34.4522 82.8305 34.4328 83.0252C34.4133 83.2199 34.2397 83.362 34.0449 83.3425C33.3183 83.2699 32.697 82.82 32.4054 82.1517C32.3271 81.9723 32.4091 81.7635 32.5885 81.6852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6541 80.8661C58.6618 81.0617 58.5095 81.2264 58.314 81.2341L53.724 81.4141C53.5284 81.4217 53.3637 81.2694 53.356 81.0739C53.3483 80.8783 53.5006 80.7136 53.6962 80.7059L58.2862 80.5259C58.4817 80.5182 58.6465 80.6706 58.6541 80.8661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8958 80.88C52.8958 80.6843 53.0544 80.5256 53.2501 80.5256H58.3001C58.4958 80.5256 58.6544 80.6843 58.6544 80.88C58.6544 81.0757 58.4958 81.2343 58.3001 81.2343H53.2501C53.0544 81.2343 52.8958 81.0757 52.8958 80.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2965 80.5257C58.4922 80.5236 58.6525 80.6806 58.6545 80.8763L58.6745 82.8063C58.6765 83.002 58.5195 83.1623 58.3238 83.1643C58.1282 83.1664 57.9679 83.0094 57.9658 82.8137L57.9458 80.8837C57.9438 80.688 58.1008 80.5277 58.2965 80.5257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6742 82.7961C58.6819 82.9916 58.5296 83.1564 58.334 83.1641L53.744 83.3441C53.5484 83.3517 53.3837 83.1994 53.376 83.0039C53.3683 82.8083 53.5207 82.6436 53.7162 82.6359L58.3062 82.4559C58.5018 82.4482 58.6665 82.6005 58.6742 82.7961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2887 217.864C30.4795 217.908 30.5991 218.098 30.5557 218.289C30.5096 218.491 30.4714 218.737 30.4424 218.999L30.4418 219.004L30.4418 219.004C30.4131 219.233 30.3939 219.473 30.3843 219.724L30.3839 219.734L30.3837 219.734C30.3545 220.163 30.345 220.617 30.3738 221.067L30.3741 221.072L30.3741 221.072C30.3828 221.246 30.3994 221.412 30.4178 221.595C30.4193 221.61 30.4208 221.625 30.4223 221.64C30.4807 222.106 30.5665 222.547 30.7047 222.943C30.7116 222.963 30.7167 222.983 30.72 223.004L30.7215 223.008L30.7279 223.024C30.7301 223.03 30.7327 223.037 30.7354 223.045C31.0254 223.877 31.5033 224.466 32.1913 224.67C32.3788 224.726 32.4856 224.924 32.4298 225.111C32.374 225.299 32.1767 225.405 31.9891 225.35C30.9975 225.055 30.3956 224.224 30.0655 223.277L30.0643 223.273C30.0643 223.273 30.0635 223.271 30.061 223.264L30.0601 223.262C30.0573 223.255 30.0524 223.242 30.0477 223.229C30.0424 223.214 30.0351 223.192 30.0289 223.167C30.0272 223.16 30.0253 223.151 30.0235 223.142C29.8695 222.689 29.7787 222.205 29.7186 221.724L29.7175 221.715L29.7176 221.715C29.7159 221.698 29.7142 221.681 29.7124 221.664C29.6944 221.484 29.676 221.302 29.6664 221.11C29.6355 220.623 29.6459 220.14 29.6763 219.691C29.6867 219.424 29.7073 219.167 29.7383 218.918C29.7691 218.641 29.8109 218.368 29.8646 218.131C29.908 217.941 30.0979 217.821 30.2887 217.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9647 217.859C50.1533 217.911 50.2639 218.106 50.2116 218.295C49.6484 220.328 49.9727 222.506 51.0813 224.293C51.1844 224.46 51.1332 224.678 50.9669 224.781C50.8006 224.884 50.5822 224.833 50.479 224.667C49.2676 222.714 48.9119 220.332 49.5287 218.105C49.5809 217.917 49.7761 217.806 49.9647 217.859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9501 217.896C51.1458 217.896 51.3044 218.054 51.3044 218.25C51.3044 218.281 51.3005 218.315 51.2909 218.349C51.2819 218.381 51.269 218.41 51.2548 218.434C51.1685 218.627 51.0974 218.841 51.043 219.049L51.0414 219.056L51.0413 219.056C50.9756 219.29 50.9297 219.512 50.9021 219.751L50.901 219.76L50.9009 219.76C50.8556 220.077 50.8548 220.399 50.8832 220.741C50.8995 220.936 50.7546 221.107 50.5595 221.123C50.3645 221.139 50.1932 220.994 50.177 220.799C50.1455 220.422 50.1446 220.046 50.1986 219.665C50.231 219.387 50.2845 219.13 50.358 218.867C50.4199 218.631 50.5025 218.381 50.6074 218.146C50.6159 218.122 50.6263 218.101 50.6376 218.082C50.6387 218.08 50.6399 218.078 50.6411 218.076C50.7019 217.968 50.8175 217.896 50.9501 217.896ZM50.6937 218.01C50.6941 218.01 50.6943 218.01 50.694 218.01ZM51.1962 218.51L51.1965 218.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7361 224.997C31.7432 224.802 31.9075 224.649 32.1031 224.656L33.4731 224.706L36.0639 224.806C36.2594 224.813 36.4118 224.978 36.4043 225.174C36.3967 225.369 36.2321 225.522 36.0365 225.514L33.4473 225.414L32.0773 225.364C31.8817 225.357 31.7289 225.193 31.7361 224.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6958 225.16C35.6958 224.964 35.8544 224.806 36.0502 224.806H50.7802C50.9759 224.806 51.1345 224.964 51.1345 225.16C51.1345 225.356 50.9759 225.514 50.7802 225.514H36.0502C35.8544 225.514 35.6958 225.356 35.6958 225.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3257 39.66C79.3257 39.4643 79.4843 39.3057 79.68 39.3057H82.95C83.1457 39.3057 83.3044 39.4643 83.3044 39.66C83.3044 39.8557 83.1457 40.0144 82.95 40.0144H79.68C79.4843 40.0144 79.3257 39.8557 79.3257 39.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9478 39.3056C91.0284 39.254 96.8372 47.103 96.6843 54.6971C96.6804 54.8927 96.5186 55.0482 96.3229 55.0442C96.1273 55.0403 95.9718 54.8785 95.9758 54.6828C96.1229 47.3769 90.5317 39.9659 82.9523 40.0143C82.7566 40.0155 82.597 39.8579 82.5957 39.6622C82.5945 39.4665 82.7521 39.3069 82.9478 39.3056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2401 141.266C91.4358 141.266 91.5944 141.424 91.5944 141.62V144.1C91.5944 144.296 91.4358 144.454 91.2401 144.454C91.0444 144.454 90.8857 144.296 90.8857 144.1V141.62C90.8857 141.424 91.0444 141.266 91.2401 141.266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3302 54.3356C96.5259 54.3356 96.6845 54.4943 96.6845 54.69V231.03C96.6845 231.226 96.5259 231.384 96.3302 231.384C96.1345 231.384 95.9758 231.226 95.9758 231.03V54.69C95.9758 54.4943 96.1345 54.3356 96.3302 54.3356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3229 230.676C96.5186 230.672 96.6804 230.827 96.6843 231.023C96.8372 238.616 91.0287 246.476 82.9473 246.414C82.7516 246.413 82.5942 246.253 82.5957 246.057C82.5972 245.862 82.7571 245.704 82.9528 245.706C90.5315 245.764 96.1229 238.344 95.9758 231.037C95.9718 230.841 96.1273 230.68 96.3229 230.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3257 246.06C79.3257 245.864 79.4843 245.706 79.68 245.706H82.95C83.1457 245.706 83.3044 245.864 83.3044 246.06C83.3044 246.256 83.1457 246.414 82.95 246.414H79.68C79.4843 246.414 79.3257 246.256 79.3257 246.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5557 236.53C41.5557 236.334 41.7143 236.176 41.91 236.176H44.29C44.4857 236.176 44.6444 236.334 44.6444 236.53C44.6444 236.726 44.4857 236.884 44.29 236.884H41.91C41.7143 236.884 41.5557 236.726 41.5557 236.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.91 235.146C42.1057 235.146 42.2644 235.304 42.2644 235.5V236.53C42.2644 236.726 42.1057 236.884 41.91 236.884C41.7143 236.884 41.5557 236.726 41.5557 236.53V235.5C41.5557 235.304 41.7143 235.146 41.91 235.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7258 59.32C34.7258 59.1243 34.8845 58.9656 35.0802 58.9656H35.6602C35.8559 58.9656 36.0145 59.1243 36.0145 59.32C36.0145 59.5157 35.8559 59.6743 35.6602 59.6743H35.0802C34.8845 59.6743 34.7258 59.5157 34.7258 59.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7258 58.74C34.7258 58.5443 34.8845 58.3856 35.0802 58.3856H35.6602C35.8559 58.3856 36.0145 58.5443 36.0145 58.74C36.0145 58.9357 35.8559 59.0943 35.6602 59.0943H35.0802C34.8845 59.0943 34.7258 58.9357 34.7258 58.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0802 58.3856C35.2759 58.3856 35.4345 58.5443 35.4345 58.74V59.32C35.4345 59.5157 35.2759 59.6743 35.0802 59.6743C34.8845 59.6743 34.7258 59.5157 34.7258 59.32V58.74C34.7258 58.5443 34.8845 58.3856 35.0802 58.3856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1758 57.09C35.1758 56.8943 35.3344 56.7357 35.5301 56.7357H35.6601C35.8558 56.7357 36.0145 56.8943 36.0145 57.09C36.0145 57.2857 35.8558 57.4444 35.6601 57.4444H35.5301C35.3344 57.4444 35.1758 57.2857 35.1758 57.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1157 57.09C35.1157 56.8943 35.2744 56.7357 35.4701 56.7357H35.5301C35.7258 56.7357 35.8844 56.8943 35.8844 57.09C35.8844 57.2857 35.7258 57.4444 35.5301 57.4444H35.4701C35.2744 57.4444 35.1157 57.2857 35.1157 57.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1157 56.51C35.1157 56.3143 35.2744 56.1556 35.4701 56.1556H35.6601C35.8558 56.1556 36.0144 56.3143 36.0144 56.51C36.0144 56.7057 35.8558 56.8643 35.6601 56.8643H35.4701C35.2744 56.8643 35.1157 56.7057 35.1157 56.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.12 57.7256C35.3157 57.7256 35.4743 57.8843 35.4743 58.08V58.74C35.4743 58.9357 35.3157 59.0944 35.12 59.0944C34.9243 59.0944 34.7656 58.9357 34.7656 58.74V58.08C34.7656 57.8843 34.9243 57.7256 35.12 57.7256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3457 58.74C31.3457 58.5443 31.5044 58.3856 31.7001 58.3856H32.9801C33.1758 58.3856 33.3344 58.5443 33.3344 58.74C33.3344 58.9357 33.1758 59.0943 32.9801 59.0943H31.7001C31.5044 59.0943 31.3457 58.9357 31.3457 58.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9801 58.3856C33.1758 58.3856 33.3344 58.5443 33.3344 58.74V59.32C33.3344 59.5157 33.1758 59.6743 32.9801 59.6743C32.7844 59.6743 32.6257 59.5157 32.6257 59.32V58.74C32.6257 58.5443 32.7844 58.3856 32.9801 58.3856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8057 59.32C31.8057 59.1243 31.9643 58.9656 32.16 58.9656H32.98C33.1757 58.9656 33.3343 59.1243 33.3343 59.32C33.3343 59.5157 33.1757 59.6743 32.98 59.6743H32.16C31.9643 59.6743 31.8057 59.5157 31.8057 59.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7001 58.3856C31.8958 58.3856 32.0544 58.5443 32.0544 58.74V59.32C32.0544 59.5157 31.8958 59.6743 31.7001 59.6743C31.5044 59.6743 31.3457 59.5157 31.3457 59.32V58.74C31.3457 58.5443 31.5044 58.3856 31.7001 58.3856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3457 59.32C31.3457 59.1243 31.5044 58.9656 31.7001 58.9656H32.1601C32.3558 58.9656 32.5144 59.1243 32.5144 59.32C32.5144 59.5157 32.3558 59.6743 32.1601 59.6743H31.7001C31.5044 59.6743 31.3457 59.5157 31.3457 59.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6257 59.32C32.6257 59.1243 32.7844 58.9656 32.9801 58.9656H33.4301C33.6258 58.9656 33.7844 59.1243 33.7844 59.32C33.7844 59.5157 33.6258 59.6743 33.4301 59.6743H32.9801C32.7844 59.6743 32.6257 59.5157 32.6257 59.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6257 58.74C32.6257 58.5443 32.7844 58.3856 32.9801 58.3856H33.4301C33.6258 58.3856 33.7844 58.5443 33.7844 58.74C33.7844 58.9357 33.6258 59.0943 33.4301 59.0943H32.9801C32.7844 59.0943 32.6257 58.9357 32.6257 58.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9701 57.7256C33.1658 57.7256 33.3244 57.8843 33.3244 58.08V58.74C33.3244 58.9357 33.1658 59.0944 32.9701 59.0944C32.7744 59.0944 32.6157 58.9357 32.6157 58.74V58.08C32.6157 57.8843 32.7744 57.7256 32.9701 57.7256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7401 57.7256C31.9358 57.7256 32.0944 57.8843 32.0944 58.08V58.74C32.0944 58.9357 31.9358 59.0944 31.7401 59.0944C31.5444 59.0944 31.3857 58.9357 31.3857 58.74V58.08C31.3857 57.8843 31.5444 57.7256 31.7401 57.7256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.41 57.7256C33.6057 57.7256 33.7644 57.8843 33.7644 58.08V58.74C33.7644 58.9357 33.6057 59.0944 33.41 59.0944C33.2143 59.0944 33.0557 58.9357 33.0557 58.74V58.08C33.0557 57.8843 33.2143 57.7256 33.41 57.7256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6102 59.1057C45.8059 59.1057 45.9646 59.2643 45.9646 59.46V60.17C45.9646 60.3657 45.8059 60.5244 45.6102 60.5244C45.4145 60.5244 45.2559 60.3657 45.2559 60.17V59.46C45.2559 59.2643 45.4145 59.1057 45.6102 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.12 59.1057C45.3157 59.1057 45.4743 59.2643 45.4743 59.46V60.17C45.4743 60.3657 45.3157 60.5244 45.12 60.5244C44.9243 60.5244 44.7656 60.3657 44.7656 60.17V59.46C44.7656 59.2643 44.9243 59.1057 45.12 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8958 60.17C44.8958 59.9743 45.0544 59.8156 45.2501 59.8156H45.7401C45.9358 59.8156 46.0944 59.9743 46.0944 60.17C46.0944 60.3657 45.9358 60.5243 45.7401 60.5243H45.2501C45.0544 60.5243 44.8958 60.3657 44.8958 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7656 60.17C44.7656 59.9743 44.9243 59.8156 45.12 59.8156H45.25C45.4457 59.8156 45.6043 59.9743 45.6043 60.17C45.6043 60.3657 45.4457 60.5243 45.25 60.5243H45.12C44.9243 60.5243 44.7656 60.3657 44.7656 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7401 59.1057C45.9358 59.1057 46.0944 59.2643 46.0944 59.46V60.17C46.0944 60.3657 45.9358 60.5244 45.7401 60.5244C45.5444 60.5244 45.3857 60.3657 45.3857 60.17V59.46C45.3857 59.2643 45.5444 59.1057 45.7401 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3502 59.1057C46.5459 59.1057 46.7045 59.2643 46.7045 59.46V60.17C46.7045 60.3657 46.5459 60.5244 46.3502 60.5244C46.1545 60.5244 45.9958 60.3657 45.9958 60.17V59.46C45.9958 59.2643 46.1545 59.1057 46.3502 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1157 60.17C46.1157 59.9743 46.2744 59.8156 46.4701 59.8156H46.7401C46.9358 59.8156 47.0944 59.9743 47.0944 60.17C47.0944 60.3657 46.9358 60.5243 46.7401 60.5243H46.4701C46.2744 60.5243 46.1157 60.3657 46.1157 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9958 60.17C45.9958 59.9743 46.1545 59.8156 46.3502 59.8156H46.4702C46.6659 59.8156 46.8245 59.9743 46.8245 60.17C46.8245 60.3657 46.6659 60.5243 46.4702 60.5243H46.3502C46.1545 60.5243 45.9958 60.3657 45.9958 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3802 59.1057C44.5759 59.1057 44.7346 59.2643 44.7346 59.46V60.17C44.7346 60.3657 44.5759 60.5244 44.3802 60.5244C44.1845 60.5244 44.0259 60.3657 44.0259 60.17V59.46C44.0259 59.2643 44.1845 59.1057 44.3802 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.89 59.1057C44.0857 59.1057 44.2443 59.2643 44.2443 59.46V60.17C44.2443 60.3657 44.0857 60.5244 43.89 60.5244C43.6943 60.5244 43.5356 60.3657 43.5356 60.17V59.46C43.5356 59.2643 43.6943 59.1057 43.89 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6658 60.17C43.6658 59.9743 43.8244 59.8156 44.0201 59.8156H44.5101C44.7058 59.8156 44.8645 59.9743 44.8645 60.17C44.8645 60.3657 44.7058 60.5243 44.5101 60.5243H44.0201C43.8244 60.5243 43.6658 60.3657 43.6658 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5356 60.17C43.5356 59.9743 43.6943 59.8156 43.89 59.8156H44.02C44.2157 59.8156 44.3743 59.9743 44.3743 60.17C44.3743 60.3657 44.2157 60.5243 44.02 60.5243H43.89C43.6943 60.5243 43.5356 60.3657 43.5356 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5101 59.1057C44.7058 59.1057 44.8645 59.2643 44.8645 59.46V60.17C44.8645 60.3657 44.7058 60.5244 44.5101 60.5244C44.3144 60.5244 44.1558 60.3657 44.1558 60.17V59.46C44.1558 59.2643 44.3144 59.1057 44.5101 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0356 59.46C39.0356 59.2643 39.1943 59.1057 39.39 59.1057H39.4C39.5957 59.1057 39.7544 59.2643 39.7544 59.46C39.7544 59.6557 39.5957 59.8144 39.4 59.8144H39.39C39.1943 59.8144 39.0356 59.6557 39.0356 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0557 59.46C39.0557 59.2643 39.2143 59.1057 39.41 59.1057H39.51C39.7057 59.1057 39.8643 59.2643 39.8643 59.46C39.8643 59.6557 39.7057 59.8144 39.51 59.8144H39.41C39.2143 59.8144 39.0557 59.6557 39.0557 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.69 57.7256C42.8857 57.7256 43.0444 57.8843 43.0444 58.08V59.46C43.0444 59.6557 42.8857 59.8143 42.69 59.8143C42.4943 59.8143 42.3357 59.6557 42.3357 59.46V58.08C42.3357 57.8843 42.4943 57.7256 42.69 57.7256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0101 57.1757C39.2058 57.1757 39.3645 57.3343 39.3645 57.53V59.46C39.3645 59.6557 39.2058 59.8144 39.0101 59.8144C38.8144 59.8144 38.6558 59.6557 38.6558 59.46V57.53C38.6558 57.3343 38.8144 57.1757 39.0101 57.1757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.19 51.9257C40.3857 51.9257 40.5444 52.0843 40.5444 52.28V53.39C40.5444 53.5857 40.3857 53.7444 40.19 53.7444C39.9943 53.7444 39.8357 53.5857 39.8357 53.39V52.28C39.8357 52.0843 39.9943 51.9257 40.19 51.9257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.41 57.1757C39.6057 57.1757 39.7644 57.3343 39.7644 57.53V59.45C39.7644 59.6457 39.6057 59.8044 39.41 59.8044C39.2143 59.8044 39.0557 59.6457 39.0557 59.45V57.53C39.0557 57.3343 39.2143 57.1757 39.41 57.1757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7058 59.46C42.7058 59.2643 42.8645 59.1057 43.0602 59.1057H43.0702C43.2659 59.1057 43.4245 59.2643 43.4245 59.46C43.4245 59.6557 43.2659 59.8144 43.0702 59.8144H43.0602C42.8645 59.8144 42.7058 59.6557 42.7058 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3357 59.46C42.3357 59.2643 42.4943 59.1057 42.69 59.1057H43.06C43.2557 59.1057 43.4144 59.2643 43.4144 59.46C43.4144 59.6557 43.2557 59.8144 43.06 59.8144H42.69C42.4943 59.8144 42.3357 59.6557 42.3357 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1558 59.46C39.1558 59.2643 39.3144 59.1057 39.5101 59.1057H42.6901C42.8858 59.1057 43.0445 59.2643 43.0445 59.46C43.0445 59.6557 42.8858 59.8144 42.6901 59.8144H39.5101C39.3144 59.8144 39.1558 59.6557 39.1558 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7158 59.46C42.7158 59.2643 42.8745 59.1057 43.0702 59.1057H46.7402C46.9359 59.1057 47.0945 59.2643 47.0945 59.46C47.0945 59.6557 46.9359 59.8144 46.7402 59.8144H43.0702C42.8745 59.8144 42.7158 59.6557 42.7158 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1758 57.53C39.1758 57.3343 39.3344 57.1757 39.5301 57.1757H40.4201C40.6158 57.1757 40.7745 57.3343 40.7745 57.53C40.7745 57.7257 40.6158 57.8844 40.4201 57.8844H39.5301C39.3344 57.8844 39.1758 57.7257 39.1758 57.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6558 57.53C38.6558 57.3343 38.8144 57.1757 39.0101 57.1757H39.3901C39.5858 57.1757 39.7445 57.3343 39.7445 57.53C39.7445 57.7257 39.5858 57.8844 39.3901 57.8844H39.0101C38.8144 57.8844 38.6558 57.7257 38.6558 57.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0356 57.53C39.0356 57.3343 39.1943 57.1757 39.39 57.1757H39.53C39.7257 57.1757 39.8844 57.3343 39.8844 57.53C39.8844 57.7257 39.7257 57.8844 39.53 57.8844H39.39C39.1943 57.8844 39.0356 57.7257 39.0356 57.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5101 57.1757C39.7058 57.1757 39.8645 57.3343 39.8645 57.53V59.46C39.8645 59.6557 39.7058 59.8144 39.5101 59.8144C39.3144 59.8144 39.1558 59.6557 39.1558 59.46V57.53C39.1558 57.3343 39.3144 57.1757 39.5101 57.1757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8157 59.46C36.8157 59.2643 36.9743 59.1057 37.17 59.1057H37.54C37.7358 59.1057 37.8944 59.2643 37.8944 59.46C37.8944 59.6557 37.7358 59.8144 37.54 59.8144H37.17C36.9743 59.8144 36.8157 59.6557 36.8157 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4258 59.46C35.4258 59.2643 35.5844 59.1057 35.7801 59.1057H37.1701C37.3658 59.1057 37.5245 59.2643 37.5245 59.46C37.5245 59.6557 37.3658 59.8144 37.1701 59.8144H35.7802C35.5845 59.8144 35.4258 59.6557 35.4258 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1858 59.46C37.1858 59.2643 37.3444 59.1057 37.5401 59.1057H39.3901C39.5858 59.1057 39.7445 59.2643 39.7445 59.46C39.7445 59.6557 39.5858 59.8144 39.3901 59.8144H37.5401C37.3444 59.8144 37.1858 59.6557 37.1858 59.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.39 57.1757C39.5857 57.1757 39.7443 57.3343 39.7443 57.53V59.46C39.7443 59.6557 39.5857 59.8144 39.39 59.8144C39.1943 59.8144 39.0356 59.6557 39.0356 59.46V57.53C39.0356 57.3343 39.1943 57.1757 39.39 57.1757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9258 60.17C42.9258 59.9743 43.0844 59.8156 43.2801 59.8156H43.7701C43.9658 59.8156 44.1245 59.9743 44.1245 60.17C44.1245 60.3657 43.9658 60.5243 43.7701 60.5243H43.2801C43.0844 60.5243 42.9258 60.3657 42.9258 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7759 60.17C42.7759 59.9743 42.9345 59.8156 43.1302 59.8156H43.2802C43.4759 59.8156 43.6346 59.9743 43.6346 60.17C43.6346 60.3657 43.4759 60.5243 43.2802 60.5243H43.1302C42.9345 60.5243 42.7759 60.3657 42.7759 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.62 59.1057C43.8157 59.1057 43.9743 59.2643 43.9743 59.46V60.17C43.9743 60.3657 43.8157 60.5244 43.62 60.5244C43.4243 60.5244 43.2656 60.3657 43.2656 60.17V59.46C43.2656 59.2643 43.4243 59.1057 43.62 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1302 59.1057C43.3259 59.1057 43.4846 59.2643 43.4846 59.46V60.17C43.4846 60.3657 43.3259 60.5244 43.1302 60.5244C42.9345 60.5244 42.7759 60.3657 42.7759 60.17V59.46C42.7759 59.2643 42.9345 59.1057 43.1302 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7701 59.1057C43.9658 59.1057 44.1245 59.2643 44.1245 59.46V60.17C44.1245 60.3657 43.9658 60.5244 43.7701 60.5244C43.5744 60.5244 43.4158 60.3657 43.4158 60.17V59.46C43.4158 59.2643 43.5744 59.1057 43.7701 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6958 60.17C41.6958 59.9743 41.8544 59.8156 42.0502 59.8156H42.5502C42.7459 59.8156 42.9045 59.9743 42.9045 60.17C42.9045 60.3657 42.7459 60.5243 42.5502 60.5243H42.0502C41.8544 60.5243 41.6958 60.3657 41.6958 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5457 60.17C41.5457 59.9743 41.7043 59.8156 41.9 59.8156H42.05C42.2457 59.8156 42.4043 59.9743 42.4043 60.17C42.4043 60.3657 42.2457 60.5243 42.05 60.5243H41.9C41.7043 60.5243 41.5457 60.3657 41.5457 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.39 59.1057C42.5857 59.1057 42.7443 59.2643 42.7443 59.46V60.17C42.7443 60.3657 42.5857 60.5244 42.39 60.5244C42.1943 60.5244 42.0356 60.3657 42.0356 60.17V59.46C42.0356 59.2643 42.1943 59.1057 42.39 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9 59.1057C42.0957 59.1057 42.2544 59.2643 42.2544 59.46V60.17C42.2544 60.3657 42.0957 60.5244 41.9 60.5244C41.7043 60.5244 41.5457 60.3657 41.5457 60.17V59.46C41.5457 59.2643 41.7043 59.1057 41.9 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5502 59.1057C42.7459 59.1057 42.9045 59.2643 42.9045 59.46V60.17C42.9045 60.3657 42.7459 60.5244 42.5502 60.5244C42.3544 60.5244 42.1958 60.3657 42.1958 60.17V59.46C42.1958 59.2643 42.3544 59.1057 42.5502 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9658 60.17C40.9658 59.9743 41.1245 59.8156 41.3202 59.8156H41.8102C42.0059 59.8156 42.1645 59.9743 42.1645 60.17C42.1645 60.3657 42.0059 60.5243 41.8102 60.5243H41.3202C41.1245 60.5243 40.9658 60.3657 40.9658 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8157 60.17C40.8157 59.9743 40.9743 59.8156 41.17 59.8156H41.32C41.5158 59.8156 41.6744 59.9743 41.6744 60.17C41.6744 60.3657 41.5158 60.5243 41.32 60.5243H41.17C40.9743 60.5243 40.8157 60.3657 40.8157 60.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.66 59.1057C41.8557 59.1057 42.0144 59.2643 42.0144 59.46V60.17C42.0144 60.3657 41.8557 60.5244 41.66 60.5244C41.4643 60.5244 41.3057 60.3657 41.3057 60.17V59.46C41.3057 59.2643 41.4643 59.1057 41.66 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.17 59.1057C41.3657 59.1057 41.5244 59.2643 41.5244 59.46V60.17C41.5244 60.3657 41.3657 60.5244 41.17 60.5244C40.9743 60.5244 40.8157 60.3657 40.8157 60.17V59.46C40.8157 59.2643 40.9743 59.1057 41.17 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8102 59.1057C42.0059 59.1057 42.1645 59.2643 42.1645 59.46V60.17C42.1645 60.3657 42.0059 60.5244 41.8102 60.5244C41.6145 60.5244 41.4558 60.3657 41.4558 60.17V59.46C41.4558 59.2643 41.6145 59.1057 41.8102 59.1057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8357 60.26C38.8357 60.0643 38.9943 59.9056 39.19 59.9056H40.54C40.7358 59.9056 40.8944 60.0643 40.8944 60.26C40.8944 60.4557 40.7358 60.6143 40.54 60.6143H39.19C38.9943 60.6143 38.8357 60.4557 38.8357 60.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1246 59.6701C39.2405 59.5124 39.4623 59.4786 39.62 59.5945C39.8895 59.7927 40.1982 59.8797 40.5659 59.9066C40.7611 59.9209 40.9077 60.0907 40.8934 60.2859C40.8792 60.481 40.7094 60.6277 40.5142 60.6134C40.0619 60.5803 39.6105 60.4673 39.2001 60.1655C39.0425 60.0496 39.0086 59.8278 39.1246 59.6701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9158 59.4756C39.0397 59.3242 39.263 59.3018 39.4144 59.4258L39.6344 59.6058C39.7859 59.7297 39.8082 59.9529 39.6843 60.1044C39.5604 60.2559 39.3371 60.2782 39.1857 60.1543L38.9657 59.9743C38.8142 59.8503 38.7919 59.6271 38.9158 59.4756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.41 59.0956C39.6058 59.0956 39.7644 59.2543 39.7644 59.45V59.46C39.7644 59.5757 39.7089 59.6785 39.6231 59.7431L39.4567 59.9333C39.3279 60.0806 39.104 60.0955 38.9567 59.9667C38.8094 59.8378 38.7945 59.6139 38.9234 59.4667L39.1334 59.2267C39.1402 59.2188 39.1473 59.2114 39.1547 59.2043C39.2192 59.1373 39.3098 59.0956 39.41 59.0956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4858 60.26C37.4858 60.0643 37.6445 59.9056 37.8402 59.9056H39.1902C39.3859 59.9056 39.5445 60.0643 39.5445 60.26C39.5445 60.4557 39.3859 60.6143 39.1902 60.6143H37.8402C37.6445 60.6143 37.4858 60.4557 37.4858 60.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0001 57.7256C31.1958 57.7256 31.3545 57.8843 31.3545 58.08V64C31.3545 64.1957 31.1958 64.3543 31.0001 64.3543C30.8044 64.3543 30.6458 64.1957 30.6458 64V58.08C30.6458 57.8843 30.8044 57.7256 31.0001 57.7256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7132 59.1277C38.8636 59.0024 39.087 59.0228 39.2123 59.1731L39.4623 59.4731C39.5876 59.6234 39.5672 59.8469 39.4169 59.9722C39.2666 60.0975 39.0431 60.0771 38.9178 59.9268L38.6678 59.6268C38.5425 59.4764 38.5629 59.253 38.7132 59.1277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4592 59.4694C39.5865 59.618 39.5693 59.8417 39.4207 59.9691L39.2107 60.1491C39.0621 60.2764 38.8384 60.2592 38.711 60.1106C38.5837 59.962 38.6009 59.7383 38.7495 59.6109L38.9595 59.4309C39.1081 59.3036 39.3318 59.3208 39.4592 59.4694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2657 59.6701C39.3816 59.8278 39.3478 60.0496 39.1901 60.1655C38.7784 60.4682 38.3162 60.5805 37.8661 60.6134C37.6709 60.6277 37.5011 60.481 37.4868 60.2859C37.4725 60.0907 37.6192 59.9209 37.8143 59.9066C38.1842 59.8795 38.5019 59.7918 38.7703 59.5945C38.9279 59.4786 39.1497 59.5124 39.2657 59.6701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.228 60.0625C40.2653 60.2546 40.1398 60.4406 39.9476 60.4779L39.2776 60.6079C39.0855 60.6451 38.8995 60.5196 38.8623 60.3275C38.825 60.1354 38.9505 59.9494 39.1426 59.9121L39.8126 59.7821C40.0048 59.7449 40.1907 59.8704 40.228 60.0625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6592 42.6407C61.6864 42.4469 61.8656 42.3119 62.0594 42.3391L62.6294 42.4191C62.8232 42.4463 62.9583 42.6254 62.9311 42.8192C62.9039 43.013 62.7247 43.1481 62.5309 43.1209L61.9609 43.0409C61.7671 43.0137 61.632 42.8345 61.6592 42.6407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9858 42.42C58.9858 42.2243 59.1445 42.0656 59.3402 42.0656C59.733 42.0656 60.1061 42.0863 60.4793 42.1278L60.4831 42.1282L60.4831 42.1282C65.7014 42.7649 69.3879 48.0764 69.2644 53.1785C69.2597 53.3742 69.0973 53.5289 68.9016 53.5242C68.706 53.5195 68.5512 53.357 68.556 53.1614C68.6725 48.3442 65.1799 43.4164 60.3992 42.8319C60.0531 42.7935 59.7067 42.7743 59.3402 42.7743C59.1445 42.7743 58.9858 42.6157 58.9858 42.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9585 45.8809C29.0905 45.7365 29.3146 45.7264 29.4591 45.8584C30.137 46.4779 30.3844 47.3893 30.3844 48.21C30.3844 48.4057 30.2258 48.5643 30.0301 48.5643C29.8344 48.5643 29.6757 48.4057 29.6757 48.21C29.6757 47.5106 29.4631 46.8221 28.981 46.3816C28.8366 46.2495 28.8265 46.0254 28.9585 45.8809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4958 45.4C26.4958 45.2043 26.6545 45.0457 26.8502 45.0457C27.7145 45.0457 28.7176 45.1863 29.4581 45.8574C29.6032 45.9889 29.6142 46.2129 29.4828 46.358C29.3513 46.503 29.1273 46.514 28.9822 46.3826C28.4428 45.8937 27.6659 45.7544 26.8502 45.7544C26.6545 45.7544 26.4958 45.5957 26.4958 45.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.29 53.8456C26.4858 53.8456 26.6444 54.0043 26.6444 54.2C26.6444 54.7318 26.2569 55.2443 25.68 55.2443C25.4843 55.2443 25.3257 55.0857 25.3257 54.89C25.3257 54.6943 25.4843 54.5356 25.68 54.5356C25.7831 54.5356 25.9357 54.4282 25.9357 54.2C25.9357 54.0043 26.0943 53.8456 26.29 53.8456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2901 51.7456C26.4858 51.7456 26.6445 51.9043 26.6445 52.1V54.2C26.6445 54.3957 26.4858 54.5543 26.2901 54.5543C26.0944 54.5543 25.9358 54.3957 25.9358 54.2V52.1C25.9358 51.9043 26.0944 51.7456 26.2901 51.7456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9359 52.1101C25.9216 51.6094 26.3048 51.0557 26.8901 51.0557C27.0858 51.0557 27.2445 51.2143 27.2445 51.41C27.2445 51.6057 27.0858 51.7644 26.8901 51.7644C26.7954 51.7644 26.6387 51.8906 26.6443 52.0899C26.6499 52.2855 26.4959 52.4486 26.3003 52.4542C26.1046 52.4598 25.9415 52.3058 25.9359 52.1101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0083 47.8563C30.2036 47.8443 30.3717 47.9929 30.3837 48.1882C30.5063 50.1829 28.92 51.8535 26.8944 51.764C26.6989 51.7553 26.5474 51.5898 26.556 51.3943C26.5647 51.1988 26.7302 51.0473 26.9257 51.056C28.52 51.1264 29.7738 49.817 29.6763 48.2317C29.6643 48.0364 29.8129 47.8683 30.0083 47.8563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3958 54.85C12.3958 54.6543 12.5544 54.4956 12.7501 54.4956H13.1301C13.3258 54.4956 13.4845 54.6543 13.4845 54.85C13.4845 55.0457 13.3258 55.2043 13.1301 55.2043H12.7501C12.5544 55.2043 12.3958 55.0457 12.3958 54.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7402 53.8057C13.9359 53.8057 14.0946 53.9643 14.0946 54.16C14.0946 54.6918 13.7071 55.2044 13.1302 55.2044C12.9345 55.2044 12.7759 55.0457 12.7759 54.85C12.7759 54.6543 12.9345 54.4957 13.1302 54.4957C13.2333 54.4957 13.3859 54.3882 13.3859 54.16C13.3859 53.9643 13.5445 53.8057 13.7402 53.8057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7401 47.3156C13.9358 47.3156 14.0944 47.4743 14.0944 47.67V54.16C14.0944 54.3557 13.9358 54.5143 13.7401 54.5143C13.5444 54.5143 13.3857 54.3557 13.3857 54.16V47.67C13.3857 47.4743 13.5444 47.3156 13.7401 47.3156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3857 47.67C13.3857 47.1382 13.7732 46.6256 14.3501 46.6256C14.5458 46.6256 14.7045 46.7843 14.7045 46.98C14.7045 47.1757 14.5458 47.3343 14.3501 47.3343C14.247 47.3343 14.0944 47.4418 14.0944 47.67C14.0944 47.8657 13.9358 48.0243 13.7401 48.0243C13.5444 48.0243 13.3857 47.8657 13.3857 47.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9958 46.98C13.9958 46.7843 14.1545 46.6256 14.3502 46.6256H15.2002C15.3959 46.6256 15.5545 46.7843 15.5545 46.98C15.5545 47.1757 15.3959 47.3343 15.2002 47.3343H14.3502C14.1545 47.3343 13.9958 47.1757 13.9958 46.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8201 45.9356C16.0158 45.9356 16.1744 46.0943 16.1744 46.29C16.1744 46.8296 15.7699 47.3343 15.2001 47.3343C15.0044 47.3343 14.8457 47.1757 14.8457 46.98C14.8457 46.7843 15.0044 46.6256 15.2001 46.6256C15.3102 46.6256 15.4657 46.5103 15.4657 46.29C15.4657 46.0943 15.6244 45.9356 15.8201 45.9356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8202 45.7456C16.0159 45.7456 16.1745 45.9043 16.1745 46.1V46.29C16.1745 46.4857 16.0159 46.6443 15.8202 46.6443C15.6245 46.6443 15.4658 46.4857 15.4658 46.29V46.1C15.4658 45.9043 15.6245 45.7456 15.8202 45.7456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8457 45.41C14.8457 45.2143 15.0044 45.0557 15.2001 45.0557C15.7668 45.0557 16.1744 45.5468 16.1744 46.1C16.1744 46.2957 16.0158 46.4544 15.8201 46.4544C15.6244 46.4544 15.4657 46.2957 15.4657 46.1C15.4657 45.8732 15.3133 45.7644 15.2001 45.7644C15.0044 45.7644 14.8457 45.6057 14.8457 45.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3257 46.98C10.3257 46.7843 10.4843 46.6256 10.68 46.6256H11.34C11.5357 46.6256 11.6944 46.7843 11.6944 46.98C11.6944 47.1757 11.5357 47.3343 11.34 47.3343H10.68C10.4843 47.3343 10.3257 47.1757 10.3257 46.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57568 75.25C4.57568 75.0543 4.73433 74.8956 4.93003 74.8956H23.05C23.2457 74.8956 23.4044 75.0543 23.4044 75.25C23.4044 75.4457 23.2457 75.6043 23.05 75.6043H4.93003C4.73433 75.6043 4.57568 75.4457 4.57568 75.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93003 52.8156C5.12574 52.8156 5.28438 52.9743 5.28438 53.17V75.25C5.28438 75.4457 5.12574 75.6043 4.93003 75.6043C4.73433 75.6043 4.57568 75.4457 4.57568 75.25V53.17C4.57568 52.9743 4.73433 52.8156 4.93003 52.8156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85217 46.0022C6.19135 47.9707 5.22155 50.5923 5.28433 53.1613C5.28911 53.3569 5.13438 53.5194 4.93874 53.5242C4.7431 53.529 4.58062 53.3743 4.57584 53.1786C4.50861 50.4276 5.54382 47.6392 7.3105 45.5452C9.07916 43.4489 11.5994 42.0291 14.5046 42.0656C14.7002 42.0681 14.8569 42.2287 14.8544 42.4244C14.8519 42.6201 14.6913 42.7767 14.4956 42.7743C11.8408 42.7409 9.51102 44.036 7.85217 46.0022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1458 42.42C14.1458 42.2243 14.3044 42.0656 14.5001 42.0656H59.3401C59.5358 42.0656 59.6945 42.2243 59.6945 42.42C59.6945 42.6157 59.5358 42.7743 59.3401 42.7743H14.5001C14.3044 42.7743 14.1458 42.6157 14.1458 42.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.91 52.8156C69.1057 52.8156 69.2644 52.9743 69.2644 53.17V75.25C69.2644 75.4457 69.1057 75.6043 68.91 75.6043C68.7143 75.6043 68.5557 75.4457 68.5557 75.25V53.17C68.5557 52.9743 68.7143 52.8156 68.91 52.8156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4258 75.25C50.4258 75.0543 50.5844 74.8956 50.7801 74.8956H68.9101C69.1058 74.8956 69.2645 75.0543 69.2645 75.25C69.2645 75.4457 69.1058 75.6043 68.9101 75.6043H50.7801C50.5844 75.6043 50.4258 75.4457 50.4258 75.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7801 68.6856C50.9758 68.6856 51.1345 68.8443 51.1345 69.04V75.25C51.1345 75.4457 50.9758 75.6043 50.7801 75.6043C50.5844 75.6043 50.4258 75.4457 50.4258 75.25V69.04C50.4258 68.8443 50.5844 68.6856 50.7801 68.6856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3857 69.04C46.3857 68.8443 46.5444 68.6856 46.7401 68.6856H50.7801C50.9758 68.6856 51.1345 68.8443 51.1345 69.04C51.1345 69.2357 50.9758 69.3943 50.7801 69.3943H46.7401C46.5444 69.3943 46.3857 69.2357 46.3857 69.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7401 57.6456C46.9358 57.6456 47.0944 57.8043 47.0944 58V69.04C47.0944 69.2357 46.9358 69.3943 46.7401 69.3943C46.5444 69.3943 46.3857 69.2357 46.3857 69.04V58C46.3857 57.8043 46.5444 57.6456 46.7401 57.6456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0657 58C40.0657 57.8043 40.2243 57.6456 40.42 57.6456H46.74C46.9357 57.6456 47.0944 57.8043 47.0944 58C47.0944 58.1957 46.9357 58.3543 46.74 58.3543H40.42C40.2243 58.3543 40.0657 58.1957 40.0657 58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.42 50.7556C40.6157 50.7556 40.7744 50.9143 40.7744 51.11V58C40.7744 58.1957 40.6157 58.3543 40.42 58.3543C40.2243 58.3543 40.0657 58.1957 40.0657 58V51.11C40.0657 50.9143 40.2243 50.7556 40.42 50.7556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0657 51.11C33.0657 50.9143 33.2243 50.7556 33.42 50.7556H40.42C40.6157 50.7556 40.7744 50.9143 40.7744 51.11C40.7744 51.3057 40.6157 51.4643 40.42 51.4643H33.42C33.2243 51.4643 33.0657 51.3057 33.0657 51.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.42 50.7556C33.6157 50.7556 33.7744 50.9143 33.7744 51.11V58C33.7744 58.1957 33.6157 58.3543 33.42 58.3543C33.2243 58.3543 33.0657 58.1957 33.0657 58V51.11C33.0657 50.9143 33.2243 50.7556 33.42 50.7556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7358 58C26.7358 57.8043 26.8945 57.6456 27.0902 57.6456H33.4202C33.6159 57.6456 33.7745 57.8043 33.7745 58C33.7745 58.1957 33.6159 58.3543 33.4202 58.3543H27.0902C26.8945 58.3543 26.7358 58.1957 26.7358 58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0902 57.6456C27.2859 57.6456 27.4445 57.8043 27.4445 58V69.04C27.4445 69.2357 27.2859 69.3943 27.0902 69.3943C26.8945 69.3943 26.7358 69.2357 26.7358 69.04V58C26.7358 57.8043 26.8945 57.6456 27.0902 57.6456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6958 69.04C22.6958 68.8443 22.8544 68.6856 23.0502 68.6856H27.0902C27.2859 68.6856 27.4445 68.8443 27.4445 69.04C27.4445 69.2357 27.2859 69.3943 27.0902 69.3943H23.0502C22.8544 69.3943 22.6958 69.2357 22.6958 69.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0502 68.6856C23.2459 68.6856 23.4045 68.8443 23.4045 69.04V75.25C23.4045 75.4457 23.2459 75.6043 23.0502 75.6043C22.8544 75.6043 22.6958 75.4457 22.6958 75.25V69.04C22.6958 68.8443 22.8544 68.6856 23.0502 68.6856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4355 49.6559C23.6311 49.648 23.7961 49.8 23.804 49.9956C23.8512 51.1548 23.5938 52.4817 22.9685 53.5203C22.3357 54.5714 21.3096 55.3446 19.8577 55.2941C19.6621 55.2873 19.509 55.1233 19.5158 54.9277C19.5226 54.7321 19.6867 54.5791 19.8823 54.5859C21.0204 54.6254 21.8293 54.0386 22.3614 53.1547C22.9011 52.2583 23.1387 51.0751 23.0959 50.0244C23.0879 49.8289 23.24 49.6639 23.4355 49.6559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9576 46.6534C23.5717 47.6451 23.8411 48.9093 23.8042 50.0217C23.7978 50.2173 23.6339 50.3706 23.4383 50.3641C23.2427 50.3577 23.0894 50.1938 23.0959 49.9982C23.129 49.0007 22.8835 47.8799 22.3551 47.0265C21.833 46.1834 21.0532 45.6224 19.9873 45.6443C19.7917 45.6483 19.6298 45.4929 19.6258 45.2972C19.6218 45.1016 19.7772 44.9397 19.9728 44.9357C21.347 44.9076 22.3372 45.6515 22.9576 46.6534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2901 235.096C44.4858 235.096 44.6445 235.254 44.6445 235.45V243.31C44.6445 243.506 44.4858 243.664 44.2901 243.664C44.0944 243.664 43.9358 243.506 43.9358 243.31V235.45C43.9358 235.254 44.0944 235.096 44.2901 235.096Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0657 235.45C40.0657 235.254 40.2243 235.096 40.42 235.096H44.29C44.4858 235.096 44.6444 235.254 44.6444 235.45C44.6444 235.646 44.4858 235.804 44.29 235.804H40.42C40.2243 235.804 40.0657 235.646 40.0657 235.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.42 225.986C40.6157 225.986 40.7744 226.144 40.7744 226.34V235.45C40.7744 235.646 40.6157 235.804 40.42 235.804C40.2243 235.804 40.0657 235.646 40.0657 235.45V226.34C40.0657 226.144 40.2243 225.986 40.42 225.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0657 226.34C40.0657 226.144 40.2243 225.986 40.42 225.986H50.78C50.9757 225.986 51.1344 226.144 51.1344 226.34C51.1344 226.536 50.9757 226.694 50.78 226.694H40.42C40.2243 226.694 40.0657 226.536 40.0657 226.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7801 219.776C50.9758 219.776 51.1345 219.934 51.1345 220.13V226.34C51.1345 226.536 50.9758 226.694 50.7801 226.694C50.5844 226.694 50.4258 226.536 50.4258 226.34V220.13C50.4258 219.934 50.5844 219.776 50.7801 219.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4258 220.13C50.4258 219.934 50.5844 219.776 50.7801 219.776H68.9101C69.1058 219.776 69.2645 219.934 69.2645 220.13C69.2645 220.326 69.1058 220.484 68.9101 220.484H50.7801C50.5844 220.484 50.4258 220.326 50.4258 220.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.91 219.776C69.1057 219.776 69.2644 219.934 69.2644 220.13V232.55C69.2644 232.746 69.1057 232.904 68.91 232.904C68.7143 232.904 68.5557 232.746 68.5557 232.55V220.13C68.5557 219.934 68.7143 219.776 68.91 219.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9016 232.196C69.0972 232.191 69.2597 232.346 69.2644 232.541C69.3879 237.612 65.7541 242.88 60.6009 243.581C60.4773 243.6 60.3225 243.622 60.1613 243.624C59.8894 243.655 59.6117 243.664 59.3402 243.664C59.1445 243.664 58.9858 243.506 58.9858 243.31C58.9858 243.114 59.1445 242.956 59.3402 242.956C59.6022 242.956 59.8576 242.946 60.0996 242.918C60.113 242.916 60.1266 242.916 60.1402 242.916C60.25 242.916 60.3658 242.9 60.4963 242.88L60.5026 242.879L60.5026 242.879C65.2277 242.238 68.6725 237.347 68.556 232.559C68.5512 232.363 68.7059 232.201 68.9016 232.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9358 243.31C43.9358 243.114 44.0944 242.956 44.2901 242.956H59.3401C59.5358 242.956 59.6945 243.114 59.6945 243.31C59.6945 243.506 59.5358 243.664 59.3401 243.664H44.2901C44.0944 243.664 43.9358 243.506 43.9358 243.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5932 242.999C62.6101 243.194 62.4658 243.366 62.2709 243.383L62.0409 243.403C61.8459 243.42 61.6741 243.276 61.6571 243.081C61.6401 242.886 61.7844 242.714 61.9794 242.697L62.2094 242.677C62.4044 242.66 62.5762 242.804 62.5932 242.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5017 220.056C69.5259 220.25 69.3882 220.427 69.194 220.452L68.954 220.482C68.7598 220.506 68.5827 220.368 68.5584 220.174C68.5342 219.98 68.6719 219.803 68.8661 219.778L69.1061 219.748C69.3003 219.724 69.4774 219.862 69.5017 220.056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5584 75.206C68.5827 75.0118 68.7598 74.8741 68.954 74.8983L69.194 74.9283C69.3882 74.9526 69.5259 75.1297 69.5017 75.3239C69.4774 75.5181 69.3003 75.6558 69.1061 75.6316L68.8661 75.6016C68.6719 75.5773 68.5342 75.4002 68.5584 75.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7058 76.42C66.7058 76.2243 66.8645 76.0656 67.0602 76.0656H69.1502C69.3459 76.0656 69.5045 76.2243 69.5045 76.42C69.5045 76.6157 69.3459 76.7743 69.1502 76.7743H67.0602C66.8645 76.7743 66.7058 76.6157 66.7058 76.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7207 76.0968C65.9774 76.0754 66.4514 76.0656 67.0602 76.0656C67.2559 76.0656 67.4145 76.2243 67.4145 76.42C67.4145 76.6157 67.2559 76.7743 67.0602 76.7743C66.449 76.7743 66.0029 76.7845 65.7796 76.8031C65.7487 76.8057 65.7252 76.8088 65.7093 76.8115C65.6639 76.8326 65.6134 76.8443 65.5602 76.8443C65.3645 76.8443 65.2058 76.6857 65.2058 76.49C65.2058 76.3835 65.2521 76.308 65.2811 76.2707C65.3106 76.2326 65.3414 76.2088 65.3585 76.1967C65.3928 76.1723 65.4246 76.1587 65.4393 76.1527C65.4728 76.1391 65.5059 76.1304 65.5305 76.1247C65.5836 76.1124 65.6485 76.1029 65.7207 76.0968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0994 76.3226C65.1532 76.1345 65.3493 76.0255 65.5375 76.0793C65.5992 76.0969 65.6581 76.1218 65.7104 76.1545C65.7514 76.1801 65.829 76.2353 65.8771 76.3315C65.9646 76.5066 65.8936 76.7194 65.7186 76.8069C65.5852 76.8736 65.43 76.8483 65.3248 76.7551C65.1478 76.6943 65.0474 76.5048 65.0994 76.3226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3257 76.42C50.3257 76.2243 50.4843 76.0656 50.68 76.0656H65.44C65.6357 76.0656 65.7944 76.2243 65.7944 76.42C65.7944 76.6157 65.6357 76.7743 65.44 76.7743H50.68C50.4843 76.7743 50.3257 76.6157 50.3257 76.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8157 76.42C17.8157 76.2243 17.9743 76.0656 18.17 76.0656H30.08C30.2757 76.0656 30.4344 76.2243 30.4344 76.42C30.4344 76.6157 30.2757 76.7743 30.08 76.7743H18.17C17.9743 76.7743 17.8157 76.6157 17.8157 76.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57708 75.2188C4.59431 75.0239 4.7663 74.8798 4.96125 74.897L18.2012 76.067C18.3962 76.0843 18.5402 76.2562 18.523 76.4512C18.5058 76.6461 18.3338 76.7902 18.1389 76.773L4.89886 75.603C4.70392 75.5857 4.55985 75.4138 4.57708 75.2188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6973 75.2173C22.7154 75.0224 22.888 74.8791 23.0829 74.8972L27.6129 75.3172C27.8078 75.3352 27.9511 75.5078 27.933 75.7027C27.9149 75.8976 27.7423 76.0409 27.5475 76.0228L23.0175 75.6028C22.8226 75.5848 22.6793 75.4122 22.6973 75.2173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4275 75.215C50.4469 75.0203 50.6204 74.8781 50.8152 74.8974L55.0451 75.3174C55.2399 75.3367 55.3821 75.5103 55.3628 75.705C55.3434 75.8998 55.1699 76.042 54.9751 76.0226L50.7451 75.6026C50.5504 75.5833 50.4082 75.4097 50.4275 75.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.933 219.677C27.9511 219.872 27.8078 220.045 27.6129 220.063L23.0829 220.483C22.888 220.501 22.7154 220.358 22.6973 220.163C22.6793 219.968 22.8226 219.795 23.0175 219.777L27.5475 219.357C27.7423 219.339 27.9149 219.482 27.933 219.677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57568 220.13C4.57568 219.934 4.73433 219.776 4.93003 219.776H23.05C23.2457 219.776 23.4044 219.934 23.4044 220.13C23.4044 220.326 23.2457 220.484 23.05 220.484H4.93003C4.73433 220.484 4.57568 220.326 4.57568 220.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.523 218.929C18.5402 219.124 18.3962 219.296 18.2012 219.313L4.96125 220.483C4.7663 220.5 4.59431 220.356 4.57708 220.161C4.55985 219.966 4.70392 219.794 4.89886 219.777L18.1389 218.607C18.3338 218.59 18.5058 218.734 18.523 218.929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8157 218.96C17.8157 218.764 17.9743 218.606 18.17 218.606H30.08C30.2757 218.606 30.4344 218.764 30.4344 218.96C30.4344 219.156 30.2757 219.314 30.08 219.314H18.17C17.9743 219.314 17.8157 219.156 17.8157 218.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3257 218.96C50.3257 218.764 50.4843 218.606 50.68 218.606H65.44C65.6357 218.606 65.7944 218.764 65.7944 218.96C65.7944 219.156 65.6357 219.314 65.44 219.314H50.68C50.4843 219.314 50.3257 219.156 50.3257 218.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7186 218.573C65.8936 218.661 65.9646 218.873 65.8771 219.048C65.829 219.145 65.7514 219.2 65.7105 219.225C65.6581 219.258 65.5992 219.283 65.5375 219.301C65.3493 219.354 65.1532 219.246 65.0994 219.057C65.0474 218.875 65.1478 218.686 65.3248 218.625C65.4299 218.532 65.5852 218.506 65.7186 218.573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7093 218.568C65.664 218.547 65.6134 218.536 65.5602 218.536C65.3645 218.536 65.2058 218.694 65.2058 218.89C65.2058 218.996 65.2521 219.072 65.2811 219.109C65.3106 219.147 65.3414 219.171 65.3584 219.183C65.3928 219.208 65.4246 219.221 65.4393 219.227C65.4727 219.241 65.5058 219.25 65.5305 219.255C65.5835 219.268 65.6485 219.277 65.7207 219.283C65.9774 219.305 66.4514 219.314 67.0602 219.314C67.2559 219.314 67.4145 219.156 67.4145 218.96C67.4145 218.764 67.2559 218.606 67.0602 218.606C66.449 218.606 66.0029 218.595 65.7796 218.577C65.7487 218.574 65.7253 218.571 65.7093 218.568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7058 218.96C66.7058 218.764 66.8645 218.606 67.0602 218.606H69.1502C69.3459 218.606 69.5045 218.764 69.5045 218.96C69.5045 219.156 69.3459 219.314 69.1502 219.314H67.0602C66.8645 219.314 66.7058 219.156 66.7058 218.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3628 219.675C55.3821 219.87 55.2399 220.043 55.0451 220.063L50.8152 220.483C50.6204 220.502 50.4469 220.36 50.4275 220.165C50.4082 219.97 50.5504 219.797 50.7451 219.777L54.9751 219.357C55.1699 219.338 55.3434 219.48 55.3628 219.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2759 69.2264C45.2834 69.0308 45.448 68.8784 45.6436 68.8859L49.2936 69.0259C49.4891 69.0334 49.6416 69.198 49.6341 69.3936C49.6266 69.5891 49.462 69.7416 49.2664 69.7341L45.6164 69.5941C45.4208 69.5866 45.2684 69.422 45.2759 69.2264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2759 69.24C45.2759 69.0443 45.4345 68.8856 45.6302 68.8856H50.7802C50.9759 68.8856 51.1346 69.0443 51.1346 69.24C51.1346 69.4357 50.9759 69.5943 50.7802 69.5943H45.6302C45.4345 69.5943 45.2759 69.4357 45.2759 69.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.386 69.0259C46.3938 68.8304 46.5586 68.6781 46.7541 68.6859L50.7941 68.8459C50.9897 68.8536 51.1419 69.0184 51.1342 69.214C51.1264 69.4095 50.9616 69.5618 50.7661 69.554L46.7261 69.394C46.5305 69.3863 46.3783 69.2215 46.386 69.0259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1057 69.43C33.1057 69.2343 33.2644 69.0756 33.4601 69.0756H50.7801C50.9758 69.0756 51.1344 69.2343 51.1344 69.43C51.1344 69.6257 50.9758 69.7843 50.7801 69.7843H33.4601C33.2644 69.7843 33.1057 69.6257 33.1057 69.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6961 69.0267C22.7034 68.8311 22.8679 68.6785 23.0634 68.6859L33.4734 69.0759C33.669 69.0832 33.8216 69.2477 33.8143 69.4432C33.8069 69.6388 33.6425 69.7914 33.4469 69.7841L23.0369 69.3941C22.8413 69.3867 22.6887 69.2223 22.6961 69.0267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7361 69.0264C26.7436 68.8308 26.9082 68.6784 27.1038 68.6859L32.3138 68.8859C32.5093 68.8934 32.6618 69.058 32.6543 69.2536C32.6468 69.4491 32.4822 69.6016 32.2866 69.594L27.0766 69.3941C26.881 69.3865 26.7286 69.2219 26.7361 69.0264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9458 69.24C31.9458 69.0443 32.1044 68.8856 32.3002 68.8856H38.2702C38.4659 68.8856 38.6245 69.0443 38.6245 69.24C38.6245 69.4357 38.4659 69.5943 38.2702 69.5943H32.3002C32.1044 69.5943 31.9458 69.4357 31.9458 69.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.916 69.2273C37.923 69.0317 38.0873 68.8788 38.2828 68.8859L42.1828 69.0259C42.3784 69.0329 42.5313 69.1971 42.5242 69.3927C42.5172 69.5883 42.353 69.7411 42.1574 69.7341L38.2574 69.5941C38.0618 69.5871 37.909 69.4228 37.916 69.2273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8157 69.38C41.8157 69.1843 41.9743 69.0256 42.17 69.0256H49.28C49.4757 69.0256 49.6344 69.1843 49.6344 69.38C49.6344 69.5757 49.4757 69.7343 49.28 69.7343H42.17C41.9743 69.7343 41.8157 69.5757 41.8157 69.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8741 225.987C42.8814 226.182 42.7288 226.347 42.5333 226.354L33.4333 226.694C33.2377 226.701 33.0732 226.549 33.0659 226.353C33.0586 226.158 33.2112 225.993 33.4068 225.986L42.5068 225.646C42.7024 225.639 42.8668 225.791 42.8741 225.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6958 226.34C22.6958 226.144 22.8544 225.986 23.0502 225.986H33.4201C33.6158 225.986 33.7745 226.144 33.7745 226.34C33.7745 226.536 33.6158 226.694 33.4201 226.694H23.0502C22.8544 226.694 22.6958 226.536 22.6958 226.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8143 225.937C33.8216 226.132 33.669 226.297 33.4734 226.304L23.0634 226.694C22.8679 226.701 22.7034 226.549 22.6961 226.353C22.6887 226.158 22.8413 225.993 23.0369 225.986L33.4469 225.596C33.6425 225.589 33.8069 225.741 33.8143 225.937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1057 225.95C33.1057 225.754 33.2644 225.596 33.4601 225.596H50.7801C50.9758 225.596 51.1344 225.754 51.1344 225.95C51.1344 226.146 50.9758 226.304 50.7801 226.304H33.4601C33.2644 226.304 33.1057 226.146 33.1057 225.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2741 225.986C49.282 226.181 49.13 226.346 48.9344 226.354L42.5344 226.614L42.5335 226.614L40.4335 226.694C40.238 226.702 40.0734 226.549 40.0659 226.353C40.0585 226.158 40.211 225.993 40.4065 225.986L42.5057 225.906L42.5065 225.906L48.9056 225.646C49.1012 225.638 49.2661 225.79 49.2741 225.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1658 226C42.1658 225.804 42.3244 225.646 42.5201 225.646H48.9201C49.1158 225.646 49.2745 225.804 49.2745 226C49.2745 226.196 49.1158 226.354 48.9201 226.354H42.5201C42.3244 226.354 42.1658 226.196 42.1658 226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0661 57.9835C40.0752 57.788 40.241 57.6369 40.4365 57.646L42.1565 57.726C42.352 57.7351 42.5031 57.901 42.494 58.0965C42.4849 58.2919 42.3191 58.443 42.1236 58.434L40.4036 58.354C40.2081 58.3449 40.057 58.179 40.0661 57.9835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7856 58.08C41.7856 57.8843 41.9443 57.7256 42.14 57.7256H46.74C46.9357 57.7256 47.0944 57.8843 47.0944 58.08C47.0944 58.2757 46.9357 58.4343 46.74 58.4343H42.14C41.9443 58.4343 41.7856 58.2757 41.7856 58.08Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.066 235.436C40.0738 235.24 40.2387 235.088 40.4343 235.096L41.9226 235.156L42.2508 235.166C42.4464 235.172 42.6002 235.335 42.5942 235.531C42.5883 235.726 42.4249 235.88 42.2293 235.874L41.8958 235.864L40.4058 235.804C40.2102 235.796 40.0581 235.631 40.066 235.436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8857 235.52C41.8857 235.324 42.0444 235.166 42.2401 235.166H44.2901C44.4858 235.166 44.6445 235.324 44.6445 235.52C44.6445 235.716 44.4858 235.874 44.2901 235.874H42.2401C42.0444 235.874 41.8857 235.716 41.8857 235.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0671 51.079C33.0842 50.884 33.2561 50.7399 33.451 50.757L35.5011 50.937C35.696 50.9541 35.8402 51.126 35.8231 51.321C35.8059 51.5159 35.634 51.6601 35.4391 51.643L33.3891 51.463C33.1941 51.4459 33.0499 51.2739 33.0671 51.079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1157 51.29C35.1157 51.0943 35.2744 50.9356 35.4701 50.9356H40.4201C40.6158 50.9356 40.7744 51.0943 40.7744 51.29C40.7744 51.4857 40.6158 51.6443 40.4201 51.6443H35.4701C35.2744 51.6443 35.1157 51.4857 35.1157 51.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6164 72.6734C27.8088 72.6591 27.9549 72.4931 27.9438 72.2998C27.9327 72.1044 27.7652 71.9551 27.5699 71.9662C27.1896 71.988 26.9476 72.3085 26.8178 72.5862C26.6755 72.8906 26.5957 73.2837 26.5957 73.7C26.5957 73.8957 26.7544 74.0544 26.9501 74.0544C27.1458 74.0544 27.3044 73.8957 27.3044 73.7C27.3044 73.3663 27.3696 73.0794 27.4598 72.8863C27.5477 72.6984 27.6174 72.6752 27.6169 72.6735C27.6168 72.6734 27.6167 72.6734 27.6164 72.6734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9501 73.3456C27.1458 73.3456 27.3044 73.5043 27.3044 73.7V74.29C27.3044 74.4857 27.1458 74.6443 26.9501 74.6443C26.7544 74.6443 26.5957 74.4857 26.5957 74.29V73.7C26.5957 73.5043 26.7544 73.3456 26.9501 73.3456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9501 73.9356C27.1458 73.9356 27.3044 74.0943 27.3044 74.29C27.3044 74.6196 27.3674 74.905 27.4561 75.0988C27.544 75.2911 27.6156 75.3155 27.615 75.3172C27.615 75.3174 27.6134 75.3172 27.6103 75.3169C27.8053 75.3336 27.9498 75.5052 27.9331 75.7002C27.9164 75.8952 27.7448 76.0397 27.5498 76.023C27.1746 75.9909 26.9387 75.6716 26.8116 75.3936C26.6727 75.0899 26.5957 74.7003 26.5957 74.29C26.5957 74.0943 26.7544 73.9356 26.9501 73.9356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9331 219.68C27.9498 219.875 27.8053 220.046 27.6103 220.063C27.6134 220.063 27.615 220.063 27.615 220.063C27.6156 220.064 27.544 220.089 27.4561 220.281C27.3674 220.475 27.3044 220.76 27.3044 221.09C27.3044 221.286 27.1458 221.444 26.9501 221.444C26.7544 221.444 26.5957 221.286 26.5957 221.09C26.5957 220.68 26.6727 220.29 26.8116 219.986C26.9387 219.708 27.1746 219.389 27.5498 219.357C27.7448 219.34 27.9164 219.485 27.9331 219.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9501 220.736C27.1458 220.736 27.3044 220.894 27.3044 221.09V221.68C27.3044 221.876 27.1458 222.034 26.9501 222.034C26.7544 222.034 26.5957 221.876 26.5957 221.68V221.09C26.5957 220.894 26.7544 220.736 26.9501 220.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9501 221.326C27.1458 221.326 27.3044 221.484 27.3044 221.68C27.3044 222.014 27.3696 222.301 27.4598 222.494C27.5476 222.682 27.6174 222.705 27.6169 222.707C27.6168 222.707 27.6167 222.707 27.6164 222.707C27.8088 222.721 27.9549 222.887 27.9438 223.08C27.9327 223.276 27.7652 223.425 27.5699 223.414C27.1896 223.392 26.9476 223.072 26.8178 222.794C26.6755 222.489 26.5957 222.096 26.5957 221.68C26.5957 221.484 26.7544 221.326 26.9501 221.326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4102 71.8657H30.4202C30.6159 71.8657 30.7745 72.0243 30.7745 72.22C30.7745 72.4157 30.6159 72.5744 30.4202 72.5744H30.4165L27.6028 72.6741C27.4072 72.6811 27.243 72.5281 27.2361 72.3326C27.2291 72.137 27.3821 71.9728 27.5776 71.9659L30.4102 71.8657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2361 223.047C27.243 222.852 27.4072 222.699 27.6028 222.706L30.4065 222.806H30.4202C30.6159 222.806 30.7745 222.964 30.7745 223.16C30.7745 223.356 30.6159 223.514 30.4202 223.514H30.3876L27.5776 223.414C27.382 223.407 27.2291 223.243 27.2361 223.047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.42 225.986C33.6157 225.986 33.7744 226.144 33.7744 226.34V235.45C33.7744 235.646 33.6157 235.804 33.42 235.804C33.2243 235.804 33.0657 235.646 33.0657 235.45V226.34C33.0657 226.144 33.2243 225.986 33.42 225.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5201 225.646C42.7158 225.646 42.8745 225.804 42.8745 226V226.26C42.8745 226.456 42.7158 226.614 42.5201 226.614C42.3244 226.614 42.1658 226.456 42.1658 226.26V226C42.1658 225.804 42.3244 225.646 42.5201 225.646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.37 229.086C35.5657 229.086 35.7243 229.244 35.7243 229.44V235.52C35.7243 235.716 35.5657 235.874 35.37 235.874C35.1743 235.874 35.0156 235.716 35.0156 235.52V229.44C35.0156 229.244 35.1743 229.086 35.37 229.086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0659 235.437C33.0729 235.242 33.2372 235.089 33.4327 235.096L35.3828 235.166C35.5783 235.173 35.7312 235.337 35.7242 235.533C35.7171 235.728 35.5529 235.881 35.3573 235.874L33.4073 235.804C33.2117 235.797 33.0589 235.633 33.0659 235.437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7727 228.936C40.7913 229.131 40.6484 229.304 40.4536 229.323L38.3523 229.523L35.4023 229.793C35.2074 229.811 35.035 229.667 35.0171 229.472C34.9993 229.277 35.1428 229.105 35.3377 229.087L38.2864 228.817L38.2877 228.817L40.3864 228.617C40.5812 228.599 40.7542 228.742 40.7727 228.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0659 57.9862C33.0736 57.7906 33.2383 57.6383 33.4338 57.6459L35.4839 57.7259C35.6794 57.7335 35.8318 57.8983 35.8241 58.0938C35.8165 58.2894 35.6518 58.4417 35.4562 58.4341L33.4062 58.3541C33.2107 58.3464 33.0583 58.1817 33.0659 57.9862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4701 50.9356C35.6658 50.9356 35.8244 51.0943 35.8244 51.29V58.08C35.8244 58.2757 35.6658 58.4343 35.4701 58.4343C35.2744 58.4343 35.1157 58.2757 35.1157 58.08V51.29C35.1157 51.0943 35.2744 50.9356 35.4701 50.9356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7361 57.9855C26.7441 57.79 26.9091 57.6379 27.1046 57.6459L29.0646 57.7259C29.2602 57.7339 29.4122 57.8989 29.4042 58.0944C29.3963 58.29 29.2313 58.442 29.0357 58.434L27.0757 58.354C26.8802 58.3461 26.7282 58.1811 26.7361 57.9855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6958 58.08C28.6958 57.8843 28.8544 57.7256 29.0502 57.7256H35.4702C35.6659 57.7256 35.8245 57.8843 35.8245 58.08C35.8245 58.2757 35.6659 58.4343 35.4702 58.4343H29.0502C28.8544 58.4343 28.6958 58.2757 28.6958 58.08Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1958 235.45C29.1958 235.254 29.3544 235.096 29.5502 235.096H33.4201C33.6158 235.096 33.7745 235.254 33.7745 235.45C33.7745 235.646 33.6158 235.804 33.4201 235.804H29.5502C29.3544 235.804 29.1958 235.646 29.1958 235.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1458 235.52C31.1458 235.324 31.3044 235.166 31.5001 235.166H35.3701C35.5658 235.166 35.7244 235.324 35.7244 235.52C35.7244 235.716 35.5658 235.874 35.3701 235.874H31.5001C31.3044 235.874 31.1458 235.716 31.1458 235.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.196 235.437C29.2031 235.242 29.3673 235.089 29.5629 235.096L31.5129 235.166C31.7085 235.173 31.8613 235.337 31.8543 235.533C31.8473 235.728 31.683 235.881 31.4875 235.874L29.5374 235.804C29.3419 235.797 29.189 235.633 29.196 235.437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5502 235.096C29.7459 235.096 29.9045 235.254 29.9045 235.45V243.31C29.9045 243.506 29.7459 243.664 29.5502 243.664C29.3544 243.664 29.1958 243.506 29.1958 243.31V235.45C29.1958 235.254 29.3544 235.096 29.5502 235.096Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1458 243.31C14.1458 243.114 14.3044 242.956 14.5001 242.956H29.5501C29.7458 242.956 29.9044 243.114 29.9044 243.31C29.9044 243.506 29.7458 243.664 29.5501 243.664H14.5001C14.3044 243.664 14.1458 243.506 14.1458 243.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93872 232.196C5.13437 232.201 5.2891 232.363 5.28433 232.559C5.22155 235.133 6.1914 237.754 7.85217 239.723C9.51099 241.689 11.841 242.984 14.4963 242.956C14.692 242.954 14.8523 243.11 14.8544 243.306C14.8565 243.502 14.6996 243.662 14.5039 243.664C11.5992 243.696 9.07919 242.276 7.3105 240.18C5.54377 238.086 4.50862 235.297 4.57584 232.541C4.58061 232.346 4.74308 232.191 4.93872 232.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93003 219.776C5.12574 219.776 5.28438 219.934 5.28438 220.13V232.55C5.28438 232.746 5.12574 232.904 4.93003 232.904C4.73433 232.904 4.57568 232.746 4.57568 232.55V220.13C4.57568 219.934 4.73433 219.776 4.93003 219.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0502 219.776C23.2459 219.776 23.4045 219.934 23.4045 220.13V226.34C23.4045 226.536 23.2459 226.694 23.0502 226.694C22.8544 226.694 22.6958 226.536 22.6958 226.34V220.13C22.6958 219.934 22.8544 219.776 23.0502 219.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4258 48.21C29.4258 48.0143 29.5844 47.8557 29.7801 47.8557H30.0301C30.2258 47.8557 30.3845 48.0143 30.3845 48.21C30.3845 48.4057 30.2258 48.5644 30.0301 48.5644H29.7801C29.5844 48.5644 29.4258 48.4057 29.4258 48.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3057 51.4C26.3057 51.2043 26.4643 51.0457 26.66 51.0457C26.7007 51.0457 26.7521 51.0487 26.7899 51.0509C26.7919 51.051 26.7939 51.0512 26.7958 51.0513C26.8426 51.054 26.8729 51.0557 26.89 51.0557H26.9094C27.1051 51.0557 27.2644 51.2143 27.2644 51.41C27.2644 51.6057 27.1057 51.7644 26.91 51.7644H26.8905C26.8497 51.7644 26.7979 51.7613 26.7601 51.7591C26.7581 51.759 26.7561 51.7589 26.7542 51.7587C26.7074 51.756 26.6771 51.7544 26.66 51.7544C26.4643 51.7544 26.3057 51.5957 26.3057 51.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7603 47.8562C29.9556 47.8452 30.1229 47.9948 30.1338 48.1902C30.2451 50.1817 28.6612 51.8548 26.6423 51.7539C26.4469 51.7441 26.2963 51.5777 26.3061 51.3823C26.3159 51.1868 26.4823 51.0363 26.6777 51.046C28.2589 51.1251 29.515 49.8182 29.4262 48.2297C29.4153 48.0343 29.5649 47.8671 29.7603 47.8562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.44 53.8456C24.6357 53.8456 24.7944 54.0043 24.7944 54.2C24.7944 54.4282 24.9469 54.5356 25.05 54.5356C25.2457 54.5356 25.4044 54.6943 25.4044 54.89C25.4044 55.0857 25.2457 55.2443 25.05 55.2443C24.4731 55.2443 24.0857 54.7318 24.0857 54.2C24.0857 54.0043 24.2443 53.8456 24.44 53.8456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4296 45.8356C24.6253 45.8354 24.7841 45.9938 24.7844 46.1895L24.7944 54.1995C24.7946 54.3952 24.6362 54.5541 24.4405 54.5543C24.2448 54.5546 24.0859 54.3961 24.0857 54.2004L24.0757 46.1904C24.0754 45.9947 24.2339 45.8359 24.4296 45.8356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3316 45.456C25.3559 45.6502 25.2182 45.8273 25.024 45.8516C24.9235 45.8641 24.7844 46.0026 24.7844 46.19C24.7844 46.3857 24.6257 46.5443 24.43 46.5443C24.2343 46.5443 24.0757 46.3857 24.0757 46.19C24.0757 45.7373 24.3965 45.2158 24.9361 45.1483C25.1303 45.1241 25.3074 45.2618 25.3316 45.456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5701 45.0555V45.0556H26.6001C26.7958 45.0556 26.9545 45.2143 26.9545 45.41C26.9545 45.6057 26.7958 45.7643 26.6001 45.7643H26.5735C26.0481 45.7743 25.5323 45.7941 25.02 45.8521C24.8255 45.8741 24.65 45.7343 24.628 45.5398C24.606 45.3454 24.7458 45.1699 24.9403 45.1479C25.4869 45.086 26.03 45.0657 26.5635 45.0557L26.5701 45.0555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2458 45.41C26.2458 45.2143 26.4045 45.0557 26.6002 45.0557C27.4503 45.0557 28.4659 45.1848 29.2081 45.8574C29.3532 45.9889 29.3642 46.213 29.2328 46.358C29.1013 46.503 28.8773 46.514 28.7322 46.3826C28.1945 45.8952 27.4101 45.7644 26.6002 45.7644C26.4045 45.7644 26.2458 45.6057 26.2458 45.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7106 45.8787C28.8438 45.7354 29.068 45.7272 29.2114 45.8605C29.8753 46.4778 30.1344 47.386 30.1344 48.21C30.1344 48.4057 29.9758 48.5643 29.7801 48.5643C29.5844 48.5643 29.4257 48.4057 29.4257 48.21C29.4257 47.514 29.2048 46.8221 28.7288 46.3795C28.5855 46.2462 28.5773 46.022 28.7106 45.8787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4781 51.8419C26.4198 51.9092 26.3845 52.0025 26.3845 52.09C26.3845 52.2857 26.2258 52.4443 26.0301 52.4443C25.8344 52.4443 25.6758 52.2857 25.6758 52.09C25.6758 51.601 26.0548 51.0287 26.67 51.0458C26.8656 51.0512 27.0198 51.2142 27.0143 51.4098C27.0089 51.6055 26.8459 51.7596 26.6503 51.7542C26.5952 51.7527 26.5343 51.777 26.4781 51.8419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0301 51.7357C26.2258 51.7357 26.3845 51.8943 26.3845 52.09V54.2C26.3845 54.3957 26.2258 54.5544 26.0301 54.5544C25.8344 54.5544 25.6758 54.3957 25.6758 54.2V52.09C25.6758 51.8943 25.8344 51.7357 26.0301 51.7357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.03 53.8456C26.2257 53.8456 26.3844 54.0043 26.3844 54.2C26.3844 54.7318 25.9969 55.2443 25.42 55.2443C25.2243 55.2443 25.0657 55.0857 25.0657 54.89C25.0657 54.6943 25.2243 54.5356 25.42 54.5356C25.5231 54.5356 25.6757 54.4282 25.6757 54.2C25.6757 54.0043 25.8343 53.8456 26.03 53.8456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9458 54.89C24.9458 54.6943 25.1044 54.5356 25.3002 54.5356H25.4201C25.6158 54.5356 25.7745 54.6943 25.7745 54.89C25.7745 55.0857 25.6158 55.2443 25.4201 55.2443H25.3002C25.1044 55.2443 24.9458 55.0857 24.9458 54.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9843 46.7396C26.9901 46.9352 26.8362 47.0984 26.6406 47.1042C26.5395 47.1072 26.3845 47.2404 26.3845 47.44C26.3845 47.6357 26.2258 47.7943 26.0301 47.7943C25.8344 47.7943 25.6758 47.6357 25.6758 47.44C25.6758 46.9596 26.0407 46.4128 26.6197 46.3958C26.8153 46.39 26.9786 46.5439 26.9843 46.7396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0301 47.0856C26.2258 47.0856 26.3845 47.2443 26.3845 47.44V49.27C26.3845 49.4657 26.2258 49.6243 26.0301 49.6243C25.8344 49.6243 25.6758 49.4657 25.6758 49.27V47.44C25.6758 47.2443 25.8344 47.0856 26.0301 47.0856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0301 48.9156C26.2258 48.9156 26.3845 49.0743 26.3845 49.27C26.3845 49.3615 26.4215 49.456 26.4805 49.5227C26.5376 49.5872 26.598 49.6091 26.6505 49.6062C26.8459 49.5953 27.0131 49.7449 27.0239 49.9403C27.0348 50.1357 26.8852 50.3029 26.6898 50.3138C26.3822 50.3309 26.1226 50.1878 25.9497 49.9923C25.7788 49.799 25.6758 49.5385 25.6758 49.27C25.6758 49.0743 25.8344 48.9156 26.0301 48.9156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6157 46.12C28.6157 45.9243 28.7744 45.7656 28.9701 45.7656H29.2201C29.4158 45.7656 29.5744 45.9243 29.5744 46.12C29.5744 46.3157 29.4158 46.4743 29.2201 46.4743H28.9701C28.7744 46.4743 28.6157 46.3157 28.6157 46.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2043 45.3858C27.2121 45.5814 27.0599 45.7463 26.8644 45.7541L26.6144 45.7641C26.4188 45.7719 26.254 45.6197 26.2461 45.4242C26.2383 45.2286 26.3905 45.0638 26.586 45.0559L26.836 45.0459C27.0316 45.0381 27.1964 45.1903 27.2043 45.3858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5001 235.166C31.6958 235.166 31.8545 235.324 31.8545 235.52V243.13C31.8545 243.326 31.6958 243.484 31.5001 243.484C31.3044 243.484 31.1458 243.326 31.1458 243.13V235.52C31.1458 235.324 31.3044 235.166 31.5001 235.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.853 243.097C31.871 243.292 31.7276 243.465 31.5328 243.483L29.5827 243.663C29.3879 243.681 29.2153 243.537 29.1973 243.343C29.1793 243.148 29.3227 242.975 29.5176 242.957L31.4676 242.777C31.6625 242.759 31.835 242.903 31.853 243.097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8865 47.1144C26.8341 47.1155 26.7775 47.1405 26.7271 47.2008C26.6739 47.2646 26.6419 47.3532 26.6444 47.4399L26.6446 47.45H26.6445V49.262C26.6484 49.3381 26.6691 49.4162 26.7015 49.4758C26.734 49.5356 26.767 49.5583 26.7901 49.5666C26.8141 49.5752 26.8365 49.5861 26.8572 49.599C27.431 49.5261 27.8634 48.9644 27.8264 48.3203C27.8255 48.3047 27.8256 48.2891 27.8268 48.2735C27.8741 47.643 27.4385 47.1316 26.8865 47.1144ZM26.3642 50.1388C26.0567 49.9295 25.9466 49.5468 25.9361 49.2841L25.9358 49.27V47.4545C25.927 47.0681 26.1497 46.6462 26.5313 46.4794M26.759 46.3956C26.7592 46.3956 26.7621 46.3955 26.7715 46.395C26.7719 46.3949 26.7724 46.3949 26.7728 46.3949C26.7832 46.3943 26.8033 46.3931 26.8251 46.3931C26.853 46.3931 26.8991 46.3946 26.953 46.4079C27.9402 46.4639 28.594 47.3611 28.5351 48.303C28.5815 49.3286 27.8092 50.3647 26.6546 50.314C26.5298 50.3085 26.4229 50.2391 26.3642 50.1388",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8865 47.1144C26.8341 47.1155 26.7775 47.1405 26.7271 47.2009C26.6982 47.2356 26.6755 47.2776 26.6613 47.3226L26.6445 47.4814V49.262C26.6484 49.3382 26.6691 49.4163 26.7015 49.4758C26.734 49.5357 26.767 49.5583 26.7901 49.5666C26.8141 49.5752 26.8365 49.5862 26.8572 49.599C27.431 49.5261 27.8634 48.9644 27.8264 48.3204C27.8255 48.3048 27.8256 48.2891 27.8268 48.2735C27.8741 47.6431 27.4385 47.1316 26.8865 47.1144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6613 47.3226C26.6493 47.3604 26.6432 47.4004 26.6444 47.4399L26.6446 47.45L26.6445 47.4814L26.6613 47.3226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6758 49.27C25.6758 49.0743 25.8344 48.9156 26.0301 48.9156H26.2901C26.4858 48.9156 26.6445 49.0743 26.6445 49.27C26.6445 49.4657 26.4858 49.6243 26.2901 49.6243H26.0301C25.8344 49.6243 25.6758 49.4657 25.6758 49.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6758 52.09C25.6758 51.8943 25.8344 51.7357 26.0301 51.7357C26.0746 51.7357 26.13 51.7386 26.1732 51.7409C26.1751 51.7409 26.1769 51.741 26.1787 51.7411C26.2298 51.7438 26.2666 51.7457 26.2901 51.7457C26.4858 51.7457 26.6445 51.9043 26.6445 52.1C26.6445 52.2957 26.4858 52.4544 26.2901 52.4544C26.2456 52.4544 26.1903 52.4514 26.1471 52.4492C26.1452 52.4491 26.1434 52.449 26.1415 52.4489C26.0904 52.4462 26.0537 52.4444 26.0301 52.4444C25.8344 52.4444 25.6758 52.2857 25.6758 52.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6302 65.8856C45.8259 65.8856 45.9846 66.0443 45.9846 66.24V69.24C45.9846 69.4357 45.8259 69.5943 45.6302 69.5943C45.4345 69.5943 45.2759 69.4357 45.2759 69.24V66.24C45.2759 66.0443 45.4345 65.8856 45.6302 65.8856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2759 66.24C45.2759 66.0443 45.4345 65.8856 45.6302 65.8856H46.7402C46.9359 65.8856 47.0946 66.0443 47.0946 66.24C47.0946 66.4357 46.9359 66.5943 46.7402 66.5943H45.6302C45.4345 66.5943 45.2759 66.4357 45.2759 66.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0502 62.9456C29.2459 62.9456 29.4045 63.1043 29.4045 63.3C29.4045 64.0014 29.5331 64.6223 29.7309 65.0622C29.9398 65.527 30.1716 65.6841 30.3204 65.6969C30.5154 65.7136 30.6599 65.8852 30.6432 66.0802C30.6265 66.2752 30.4549 66.4197 30.2599 66.403C29.7088 66.3558 29.3205 65.8779 29.0845 65.3527C28.8372 64.8026 28.6958 64.0786 28.6958 63.3C28.6958 63.1043 28.8544 62.9456 29.0502 62.9456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3002 65.8856C32.4959 65.8856 32.6545 66.0443 32.6545 66.24V69.24C32.6545 69.4357 32.4959 69.5943 32.3002 69.5943C32.1044 69.5943 31.9458 69.4357 31.9458 69.24V66.24C31.9458 66.0443 32.1044 65.8856 32.3002 65.8856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9374 66.0166C29.9558 65.8218 30.1287 65.6788 30.3235 65.6972L32.3335 65.8872C32.5283 65.9056 32.6713 66.0785 32.6529 66.2733C32.6345 66.4682 32.4616 66.6112 32.2668 66.5928L30.2568 66.4028C30.062 66.3844 29.919 66.2115 29.9374 66.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0502 57.7256C29.2459 57.7256 29.4045 57.8843 29.4045 58.08V63.3C29.4045 63.4957 29.2459 63.6543 29.0502 63.6543C28.8544 63.6543 28.6958 63.4957 28.6958 63.3V58.08C28.6958 57.8843 28.8544 57.7256 29.0502 57.7256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6758 54.2C25.6758 54.0043 25.8344 53.8456 26.0301 53.8456H26.2901C26.4858 53.8456 26.6445 54.0043 26.6445 54.2C26.6445 54.3957 26.4858 54.5543 26.2901 54.5543H26.0301C25.8344 54.5543 25.6758 54.3957 25.6758 54.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0657 54.89C25.0657 54.6943 25.2243 54.5356 25.42 54.5356H25.68C25.8757 54.5356 26.0344 54.6943 26.0344 54.89C26.0344 55.0857 25.8757 55.2443 25.68 55.2443H25.42C25.2243 55.2443 25.0657 55.0857 25.0657 54.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6958 54.89C24.6958 54.6943 24.8544 54.5356 25.0502 54.5356H25.3002C25.4959 54.5356 25.6545 54.6943 25.6545 54.89C25.6545 55.0857 25.4959 55.2443 25.3002 55.2443H25.0502C24.8544 55.2443 24.6958 55.0857 24.6958 54.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8357 50.01C22.8357 49.8143 22.9943 49.6556 23.19 49.6556H23.45C23.6457 49.6556 23.8044 49.8143 23.8044 50.01C23.8044 50.2057 23.6457 50.3643 23.45 50.3643H23.19C22.9943 50.3643 22.8357 50.2057 22.8357 50.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4358 45.29C19.4358 45.0943 19.5944 44.9356 19.7901 44.9356C21.143 44.9356 22.1129 45.6852 22.7191 46.6821C23.3196 47.6695 23.5812 48.9202 23.5443 50.0218C23.5377 50.2174 23.3739 50.3707 23.1783 50.3641C22.9827 50.3576 22.8294 50.1937 22.836 49.9981C22.8691 49.0098 22.6306 47.9005 22.1136 47.0503C21.6024 46.2097 20.8373 45.6443 19.7901 45.6443C19.5944 45.6443 19.4358 45.4857 19.4358 45.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1738 49.656C23.3693 49.647 23.5351 49.7982 23.5441 49.9937C23.5966 51.1336 23.3492 52.4344 22.7457 53.4631C22.136 54.5023 21.1451 55.2843 19.7401 55.2843C19.5444 55.2843 19.3857 55.1257 19.3857 54.93C19.3857 54.7343 19.5444 54.5756 19.7401 54.5756C20.8351 54.5756 21.6192 53.9826 22.1345 53.1044C22.656 52.2156 22.8836 51.0564 22.8361 50.0263C22.8271 49.8308 22.9783 49.665 23.1738 49.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1502 49.7958C16.3458 49.8013 16.4999 49.9644 16.4944 50.16C16.4659 51.1654 16.7074 52.3025 17.2343 53.1698C17.7546 54.0263 18.5342 54.5976 19.613 54.5757C19.8087 54.5718 19.9705 54.7272 19.9745 54.9228C19.9784 55.1185 19.823 55.2803 19.6274 55.2843C18.2361 55.3124 17.2458 54.5537 16.6286 53.5377C16.0179 52.5325 15.7544 51.2546 15.786 50.14C15.7915 49.9444 15.9546 49.7903 16.1502 49.7958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6733 46.711C17.313 45.6871 18.3261 44.9244 19.7229 44.9357C19.9186 44.9372 20.076 45.0972 20.0744 45.2929C20.0728 45.4885 19.9129 45.6459 19.7172 45.6443C18.624 45.6356 17.817 46.2179 17.2743 47.0865C16.7257 47.9644 16.4658 49.1132 16.4942 50.1402C16.4996 50.3358 16.3454 50.4988 16.1498 50.5042C15.9542 50.5096 15.7912 50.3554 15.7858 50.1598C15.7542 49.0168 16.0393 47.7256 16.6733 46.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8245 49.7657C18.0202 49.7625 18.1814 49.9186 18.1845 50.1143C18.1943 50.7269 18.2636 51.4856 18.5025 52.0943C18.7382 52.6946 19.1055 53.0811 19.6974 53.1267C19.8925 53.1417 20.0385 53.312 20.0235 53.5072C20.0085 53.7023 19.8381 53.8483 19.643 53.8333C18.6748 53.7588 18.1322 53.0904 17.8428 52.3532C17.5567 51.6243 17.4861 50.763 17.4759 50.1256C17.4727 49.93 17.6288 49.7688 17.8245 49.7657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0337 46.7254C20.0473 46.9206 19.9 47.0899 19.7048 47.1035C19.1029 47.1454 18.7348 47.5303 18.5001 48.1293C18.2614 48.7385 18.1943 49.5015 18.1845 50.1256C18.1814 50.3213 18.0203 50.4774 17.8246 50.4743C17.6289 50.4712 17.4728 50.3101 17.4759 50.1144C17.486 49.4685 17.5539 48.6015 17.8403 47.8707C18.1306 47.1297 18.6775 46.4646 19.6556 46.3965C19.8508 46.3829 20.0201 46.5302 20.0337 46.7254Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2656 54.93C19.2656 54.7343 19.4243 54.5756 19.62 54.5756H19.74C19.749 54.5756 19.7581 54.576 19.7672 54.5767L19.8972 54.5867C20.0923 54.6017 20.2383 54.772 20.2233 54.9672C20.2083 55.1623 20.0379 55.3083 19.8428 55.2933L19.7264 55.2843H19.62C19.4243 55.2843 19.2656 55.1257 19.2656 54.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4601 69.0756C33.6558 69.0756 33.8144 69.2343 33.8144 69.43V70.32C33.8144 70.5157 33.6558 70.6743 33.4601 70.6743C33.2644 70.6743 33.1057 70.5157 33.1057 70.32V69.43C33.1057 69.2343 33.2644 69.0756 33.4601 69.0756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4601 224.706C33.6558 224.706 33.8144 224.864 33.8144 225.06V225.95C33.8144 226.146 33.6558 226.304 33.4601 226.304C33.2644 226.304 33.1057 226.146 33.1057 225.95V225.06C33.1057 224.864 33.2644 224.706 33.4601 224.706Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5101 50.08C21.4801 51.3 21.2701 53.25 19.8001 53.46C18.3501 53.25 18.1101 51.34 18.0801 50.12C18.1101 48.9 18.3501 46.98 19.8101 46.77C21.2501 46.97 21.4801 48.87 21.5101 50.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4513 46.4882C19.5143 46.4307 19.5982 46.3956 19.6902 46.3956C19.7339 46.3956 19.7757 46.4008 19.8108 46.4071C19.8474 46.4008 19.8914 46.3956 19.9402 46.3956C20.034 46.3956 20.1194 46.4321 20.1828 46.4917C20.8841 46.714 21.2909 47.3014 21.5212 47.9231C21.7835 48.6311 21.8492 49.4567 21.8644 50.0712C21.8646 50.077 21.8646 50.0829 21.8644 50.0887C21.8492 50.706 21.7888 51.5463 21.5286 52.2688C21.2978 52.9094 20.8844 53.5172 20.1588 53.7419C20.0958 53.7993 20.0121 53.8343 19.9202 53.8343C19.8765 53.8343 19.8347 53.8291 19.7995 53.8229C19.7629 53.8292 19.719 53.8343 19.6702 53.8343C19.5753 53.8343 19.4891 53.797 19.4255 53.7363C18.7205 53.5096 18.3095 52.919 18.0757 52.2927C17.8095 51.5797 17.7412 50.7491 17.7259 50.1287C17.7258 50.1229 17.7258 50.1171 17.7259 50.1113C17.7412 49.4909 17.8095 48.6577 18.077 47.9422C18.314 47.3083 18.732 46.7111 19.4513 46.4882ZM19.811 47.1288C19.291 47.2238 18.9576 47.6105 18.7409 48.1903C18.5169 48.7893 18.4498 49.522 18.4346 50.12C18.4498 50.7179 18.5169 51.4482 18.7397 52.0448C18.9551 52.6219 19.286 53.006 19.8005 53.101C20.3211 53.0059 20.6502 52.616 20.8618 52.0286C21.0805 51.4216 21.1405 50.6811 21.1557 50.08C21.1405 49.4861 21.0758 48.761 20.8566 48.1693C20.6447 47.5971 20.319 47.2195 19.811 47.1288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4758 50.12C17.4758 49.9243 17.6345 49.7656 17.8302 49.7656H18.0802C18.2759 49.7656 18.4345 49.9243 18.4345 50.12C18.4345 50.3157 18.2759 50.4743 18.0802 50.4743H17.8302C17.6345 50.4743 17.4758 50.3157 17.4758 50.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3257 46.75C19.3257 46.5543 19.4843 46.3956 19.68 46.3956H19.69C19.8857 46.3956 20.0444 46.5543 20.0444 46.75C20.0444 46.9457 19.8857 47.1043 19.69 47.1043H19.68C19.4843 47.1043 19.3257 46.9457 19.3257 46.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3657 45.29C19.3657 45.0943 19.5244 44.9356 19.7201 44.9356H19.9801C20.1758 44.9356 20.3344 45.0943 20.3344 45.29C20.3344 45.4857 20.1758 45.6443 19.9801 45.6443H19.7201C19.5244 45.6443 19.3657 45.4857 19.3657 45.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8227 61.3982C28.9728 61.2726 29.1963 61.2925 29.3219 61.4425L33.1516 66.0122C33.2774 66.1621 33.2579 66.3856 33.108 66.5114C32.9581 66.6372 32.7346 66.6177 32.6088 66.4678L28.7784 61.8974C28.6528 61.7473 28.6727 61.5238 28.8227 61.3982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2061 46.2663C15.2136 46.0708 15.3782 45.9183 15.5738 45.9259L15.8338 45.9359C16.0294 45.9434 16.1818 46.108 16.1743 46.3036C16.1667 46.4991 16.0021 46.6516 15.8066 46.644L15.5465 46.634C15.351 46.6265 15.1986 46.4619 15.2061 46.2663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5602 45.7456C15.7559 45.7456 15.9145 45.9043 15.9145 46.1V46.28C15.9145 46.4757 15.7559 46.6343 15.5602 46.6343C15.3645 46.6343 15.2058 46.4757 15.2058 46.28V46.1C15.2058 45.9043 15.3645 45.7456 15.5602 45.7456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2058 46.1C15.2058 45.9043 15.3645 45.7456 15.5602 45.7456H15.8202C16.0159 45.7456 16.1745 45.9043 16.1745 46.1C16.1745 46.2957 16.0159 46.4543 15.8202 46.4543H15.5602C15.3645 46.4543 15.2058 46.2957 15.2058 46.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5957 45.41C14.5957 45.2143 14.7544 45.0557 14.9501 45.0557H15.2001C15.3958 45.0557 15.5544 45.2143 15.5544 45.41C15.5544 45.6057 15.3958 45.7644 15.2001 45.7644H14.9501C14.7544 45.7644 14.5957 45.6057 14.5957 45.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5957 45.41C14.5957 45.2143 14.7544 45.0557 14.9501 45.0557C15.5269 45.0557 15.9144 45.5682 15.9144 46.1C15.9144 46.2957 15.7558 46.4544 15.5601 46.4544C15.3644 46.4544 15.2057 46.2957 15.2057 46.1C15.2057 45.8718 15.0532 45.7644 14.9501 45.7644C14.7544 45.7644 14.5957 45.6057 14.5957 45.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.596 46.9558C14.6038 46.7602 14.7687 46.6081 14.9642 46.6159L15.2142 46.6259C15.4098 46.6337 15.5619 46.7986 15.5541 46.9941C15.5463 47.1897 15.3814 47.3418 15.1859 47.334L14.9359 47.324C14.7403 47.3162 14.5882 47.1513 14.596 46.9558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5601 45.9257C15.7558 45.9257 15.9144 46.0843 15.9144 46.28C15.9144 46.8118 15.527 47.3244 14.9501 47.3244C14.7544 47.3244 14.5957 47.1657 14.5957 46.97C14.5957 46.7743 14.7544 46.6157 14.9501 46.6157C15.0532 46.6157 15.2057 46.5082 15.2057 46.28C15.2057 46.0843 15.3644 45.9257 15.5601 45.9257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4244 46.6344C11.9129 46.718 12.2445 47.169 12.2445 47.66C12.2445 47.8557 12.0858 48.0143 11.8901 48.0143C11.6944 48.0143 11.5358 47.8557 11.5358 47.66C11.5358 47.4639 11.405 47.3456 11.2948 47.3314C11.2815 47.3297 11.2683 47.3272 11.2553 47.324C11.0665 47.3162 10.9158 47.1607 10.9158 46.97C10.9158 46.7743 11.0744 46.6156 11.2701 46.6156C11.2706 46.6156 11.2712 46.6156 11.2718 46.6156C11.2817 46.6156 11.3097 46.6155 11.3404 46.6186C11.358 46.6204 11.3883 46.6241 11.4244 46.6344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0757 46.97C10.0757 46.7742 10.2343 46.6156 10.43 46.6156H11.27C11.4657 46.6156 11.6244 46.7742 11.6244 46.97C11.6244 47.1657 11.4657 47.3243 11.27 47.3243H10.43C10.2343 47.3243 10.0757 47.1657 10.0757 46.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82017 45.9257C10.0159 45.9257 10.1745 46.0843 10.1745 46.28C10.1745 46.5043 10.3336 46.6157 10.4302 46.6157C10.6259 46.6157 10.7845 46.7743 10.7845 46.97C10.7845 47.1657 10.6259 47.3244 10.4302 47.3244C9.86675 47.3244 9.46582 46.8157 9.46582 46.28C9.46582 46.0843 9.62447 45.9257 9.82017 45.9257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82017 45.7456C10.0159 45.7456 10.1745 45.9043 10.1745 46.1V46.28C10.1745 46.4757 10.0159 46.6343 9.82017 46.6343C9.62447 46.6343 9.46582 46.4757 9.46582 46.28V46.1C9.46582 45.9043 9.62447 45.7456 9.82017 45.7456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46582 46.1C9.46582 45.5643 9.86675 45.0557 10.4302 45.0557C10.6259 45.0557 10.7845 45.2143 10.7845 45.41C10.7845 45.6057 10.6259 45.7644 10.4302 45.7644C10.3336 45.7644 10.1745 45.8758 10.1745 46.1C10.1745 46.2957 10.0159 46.4544 9.82017 46.4544C9.62447 46.4544 9.46582 46.2957 9.46582 46.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3257 45.41C10.3257 45.2143 10.4843 45.0557 10.68 45.0557H14.95C15.1457 45.0557 15.3044 45.2143 15.3044 45.41C15.3044 45.6057 15.1457 45.7644 14.95 45.7644H10.68C10.4843 45.7644 10.3257 45.6057 10.3257 45.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7458 46.97C13.7458 46.7742 13.9045 46.6156 14.1002 46.6156H14.9502C15.1459 46.6156 15.3045 46.7742 15.3045 46.97C15.3045 47.1657 15.1459 47.3243 14.9502 47.3243H14.1002C13.9045 47.3243 13.7458 47.1657 13.7458 46.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1257 47.66C13.1257 47.1203 13.5302 46.6156 14.1001 46.6156C14.2958 46.6156 14.4545 46.7742 14.4545 46.97C14.4545 47.1657 14.2958 47.3243 14.1001 47.3243C13.99 47.3243 13.8344 47.4396 13.8344 47.66C13.8344 47.8557 13.6758 48.0143 13.4801 48.0143C13.2844 48.0143 13.1257 47.8557 13.1257 47.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4801 47.3057C13.6758 47.3057 13.8344 47.4643 13.8344 47.66V54.15C13.8344 54.3457 13.6758 54.5044 13.4801 54.5044C13.2844 54.5044 13.1257 54.3457 13.1257 54.15V47.66C13.1257 47.4643 13.2844 47.3057 13.4801 47.3057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.48 53.7957C13.6757 53.7957 13.8343 53.9543 13.8343 54.15C13.8343 54.6953 13.4438 55.1944 12.87 55.1944C12.6743 55.1944 12.5156 55.0357 12.5156 54.84C12.5156 54.6443 12.6743 54.4857 12.87 54.4857C12.9762 54.4857 13.1256 54.3847 13.1256 54.15C13.1256 53.9543 13.2843 53.7957 13.48 53.7957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1458 54.84C12.1458 54.6443 12.3044 54.4857 12.5001 54.4857H12.8701C13.0658 54.4857 13.2244 54.6443 13.2244 54.84C13.2244 55.0357 13.0658 55.1944 12.8701 55.1944H12.5001C12.3044 55.1944 12.1458 55.0357 12.1458 54.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 53.7957C12.0857 53.7957 12.2443 53.9543 12.2443 54.15C12.2443 54.3847 12.3938 54.4857 12.5 54.4857C12.6957 54.4857 12.8544 54.6443 12.8544 54.84C12.8544 55.0357 12.6957 55.1944 12.5 55.1944C11.9262 55.1944 11.5356 54.6953 11.5356 54.15C11.5356 53.9543 11.6943 53.7957 11.89 53.7957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 47.3057C12.0857 47.3057 12.2443 47.4643 12.2443 47.66V54.15C12.2443 54.3457 12.0857 54.5044 11.89 54.5044C11.6943 54.5044 11.5356 54.3457 11.5356 54.15V47.66C11.5356 47.4643 11.6943 47.3057 11.89 47.3057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0757 45.41C10.0757 45.2143 10.2343 45.0557 10.43 45.0557H10.68C10.8757 45.0557 11.0344 45.2143 11.0344 45.41C11.0344 45.6057 10.8757 45.7644 10.68 45.7644H10.43C10.2343 45.7644 10.0757 45.6057 10.0757 45.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7461 46.9558C13.754 46.7602 13.9188 46.6081 14.1144 46.6159L14.3644 46.6259C14.5599 46.6337 14.7121 46.7986 14.7043 46.9941C14.6964 47.1897 14.5316 47.3418 14.336 47.334L14.086 47.324C13.8905 47.3162 13.7383 47.1513 13.7461 46.9558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.126 47.6463C13.1335 47.4508 13.2982 47.2983 13.4937 47.3059L13.7537 47.3159C13.9493 47.3234 14.1017 47.488 14.0942 47.6836C14.0867 47.8791 13.922 48.0316 13.7265 48.024L13.4665 48.014C13.2709 48.0065 13.1185 47.8419 13.126 47.6463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.126 54.1364C13.1335 53.9408 13.2982 53.7884 13.4937 53.7959L13.7537 53.8059C13.9493 53.8134 14.1017 53.9781 14.0942 54.1736C14.0867 54.3692 13.922 54.5216 13.7265 54.5141L13.4665 54.5041C13.2709 54.4966 13.1185 54.3319 13.126 54.1364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5159 54.8263C12.5234 54.6308 12.688 54.4783 12.8836 54.4859L13.1436 54.4959C13.3392 54.5034 13.4916 54.668 13.4841 54.8636C13.4766 55.0591 13.3119 55.2116 13.1164 55.204L12.8564 55.194C12.6608 55.1865 12.5084 55.0219 12.5159 54.8263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.17 66.2456C42.3657 66.2456 42.5244 66.4043 42.5244 66.6V69.38C42.5244 69.5757 42.3657 69.7343 42.17 69.7343C41.9743 69.7343 41.8157 69.5757 41.8157 69.38V66.6C41.8157 66.4043 41.9743 66.2456 42.17 66.2456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2701 65.8856C38.4658 65.8856 38.6245 66.0443 38.6245 66.24V69.24C38.6245 69.4357 38.4658 69.5943 38.2701 69.5943C38.0744 69.5943 37.9158 69.4357 37.9158 69.24V66.24C37.9158 66.0443 38.0744 65.8856 38.2701 65.8856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8372 66.298C38.8548 66.1031 39.0271 65.9594 39.222 65.9771L42.202 66.247C42.3969 66.2647 42.5406 66.437 42.523 66.6319C42.5053 66.8268 42.333 66.9705 42.1381 66.9529L39.1581 66.6829C38.9632 66.6652 38.8195 66.4929 38.8372 66.298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9171 66.2093C37.9341 66.0143 38.1059 65.87 38.3008 65.887L39.2209 65.967C39.4158 65.9839 39.5601 66.1557 39.5432 66.3507C39.5262 66.5457 39.3544 66.69 39.1595 66.673L38.2394 66.593C38.0445 66.5761 37.9002 66.4043 37.9171 66.2093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.146 54.8258C12.1539 54.6303 12.3187 54.4781 12.5143 54.4859L12.7643 54.4959C12.9598 54.5037 13.112 54.6686 13.1042 54.8641C13.0964 55.0596 12.9315 55.2118 12.736 55.204L12.486 55.194C12.2904 55.1862 12.1382 55.0213 12.146 54.8258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9458 66.24C31.9458 66.0443 32.1044 65.8856 32.3002 65.8856H38.2702C38.4659 65.8856 38.6245 66.0443 38.6245 66.24C38.6245 66.4357 38.4659 66.5943 38.2702 66.5943H32.3002C32.1044 66.5943 31.9458 66.4357 31.9458 66.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.076 46.9558C10.0838 46.7602 10.2487 46.6081 10.4442 46.6159L10.6942 46.6259C10.8898 46.6337 11.0419 46.7986 11.0341 46.9941C11.0263 47.1897 10.8614 47.3418 10.6659 47.334L10.4159 47.324C10.2203 47.3162 10.0681 47.1513 10.076 46.9558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8157 66.6C41.8157 66.4043 41.9743 66.2456 42.17 66.2456H45.63C45.8257 66.2456 45.9844 66.4043 45.9844 66.6C45.9844 66.7957 45.8257 66.9543 45.63 66.9543H42.17C41.9743 66.9543 41.8157 66.7957 41.8157 66.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.17 76.0656C18.3657 76.0656 18.5244 76.2243 18.5244 76.42V218.96C18.5244 219.156 18.3657 219.314 18.17 219.314C17.9743 219.314 17.8157 219.156 17.8157 218.96V76.42C17.8157 76.2243 17.9743 76.0656 18.17 76.0656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1028 218.896C66.1216 219.091 65.979 219.264 65.7842 219.283L65.4742 219.313C65.2794 219.332 65.1062 219.189 65.0874 218.994C65.0685 218.799 65.2111 218.626 65.4059 218.607L65.7159 218.577C65.9107 218.558 66.0839 218.701 66.1028 218.896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0874 76.3859C65.1062 76.1911 65.2794 76.0484 65.4742 76.0673L65.7842 76.0973C65.979 76.1161 66.1216 76.2893 66.1028 76.4841C66.0839 76.6789 65.9107 76.8215 65.7159 76.8027L65.4059 76.7727C65.2111 76.7538 65.0685 76.5806 65.0874 76.3859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.487 53.141C72.5031 52.946 72.6741 52.8008 72.8692 52.8168L91.3892 54.3368C91.5842 54.3528 91.7294 54.5239 91.7134 54.719C91.6974 54.914 91.5263 55.0591 91.3312 55.0431L72.8112 53.5231C72.6162 53.5071 72.471 53.336 72.487 53.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9858 38C58.9858 37.8043 59.1445 37.6456 59.3402 37.6456C59.6742 37.6456 60.0178 37.6556 60.3656 37.6973C67.5786 38.2785 73.1945 45.0122 73.1945 53.17C73.1945 53.3657 73.0359 53.5243 72.8402 53.5243C72.6445 53.5243 72.4858 53.3657 72.4858 53.17C72.4858 45.3105 67.0855 38.9459 60.3019 38.4032L60.2875 38.4018C59.9778 38.3642 59.6639 38.3543 59.3402 38.3543C59.1445 38.3543 58.9858 38.1957 58.9858 38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4968 39.5347C78.5107 39.3395 78.6803 39.1926 78.8755 39.2065C79.1704 39.2276 79.4625 39.2695 79.7321 39.3095L79.733 39.3096L79.733 39.3096C86.575 40.34 91.7145 46.9053 91.7145 54.69C91.7145 54.8857 91.5559 55.0443 91.3602 55.0443C91.1645 55.0443 91.0058 54.8857 91.0058 54.69C91.0058 47.1948 86.0656 40.9802 79.6279 40.0105C79.3576 39.9704 79.0899 39.9324 78.825 39.9134C78.6298 39.8995 78.4828 39.73 78.4968 39.5347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8402 232.206C73.0359 232.206 73.1945 232.364 73.1945 232.56C73.1945 240.546 67.8019 247.175 60.8058 247.991C60.6745 248.01 60.512 248.032 60.3524 248.034C60.0091 248.075 59.67 248.084 59.3402 248.084C59.1445 248.084 58.9858 247.926 58.9858 247.73C58.9858 247.534 59.1445 247.376 59.3402 247.376C59.6639 247.376 59.9778 247.366 60.2875 247.328C60.3017 247.327 60.3159 247.326 60.3302 247.326C60.4416 247.326 60.5682 247.309 60.7101 247.289L60.7192 247.288L60.7192 247.288C67.3009 246.522 72.4858 240.252 72.4858 232.56C72.4858 232.364 72.6445 232.206 72.8402 232.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1458 247.73C14.1458 247.534 14.3044 247.376 14.5001 247.376H59.3401C59.5358 247.376 59.6945 247.534 59.6945 247.73C59.6945 247.926 59.5358 248.084 59.3401 248.084H14.5001C14.3044 248.084 14.1458 247.926 14.1458 247.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0001 232.206C1.1958 232.206 1.35445 232.364 1.35445 232.56C1.35445 240.784 7.27357 247.376 14.5001 247.376C14.6958 247.376 14.8545 247.534 14.8545 247.73C14.8545 247.926 14.6958 248.084 14.5001 248.084C6.80664 248.084 0.645752 241.096 0.645752 232.56C0.645752 232.364 0.8044 232.206 1.0001 232.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0001 52.8156C1.1958 52.8156 1.35445 52.9743 1.35445 53.17V232.56C1.35445 232.756 1.1958 232.914 1.0001 232.914C0.8044 232.914 0.645752 232.756 0.645752 232.56V53.17C0.645752 52.9743 0.8044 52.8156 1.0001 52.8156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.645752 53.17C0.645752 44.6343 6.80664 37.6456 14.5001 37.6456C14.6958 37.6456 14.8545 37.8043 14.8545 38C14.8545 38.1957 14.6958 38.3543 14.5001 38.3543C7.27357 38.3543 1.35445 44.9457 1.35445 53.17C1.35445 53.3657 1.1958 53.5243 1.0001 53.5243C0.8044 53.5243 0.645752 53.3657 0.645752 53.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1458 38C14.1458 37.8043 14.3044 37.6456 14.5001 37.6456H59.3401C59.5358 37.6456 59.6945 37.8043 59.6945 38C59.6945 38.1957 59.5358 38.3543 59.3401 38.3543H14.5001C14.3044 38.3543 14.1458 38.1957 14.1458 38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8402 52.8156C73.0359 52.8156 73.1945 52.9743 73.1945 53.17V141.48C73.1945 141.676 73.0359 141.834 72.8402 141.834C72.6445 141.834 72.4858 141.676 72.4858 141.48V53.17C72.4858 52.9743 72.6445 52.8156 72.8402 52.8156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.076 141.215C73.2221 141.346 73.2349 141.57 73.1047 141.716L72.3647 142.546C72.2345 142.692 72.0105 142.705 71.8644 142.574C71.7183 142.444 71.7055 142.22 71.8357 142.074L72.5757 141.244C72.7059 141.098 72.9299 141.085 73.076 141.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1002 141.956C72.2959 141.956 72.4545 142.114 72.4545 142.31V143.41C72.4545 143.606 72.2959 143.764 72.1002 143.764C71.9045 143.764 71.7458 143.606 71.7458 143.41V142.31C71.7458 142.114 71.9045 141.956 72.1002 141.956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8644 143.145C72.0105 143.015 72.2345 143.028 72.3647 143.174L73.1047 144.004C73.2349 144.15 73.2221 144.374 73.076 144.504C72.9299 144.635 72.7059 144.622 72.5757 144.476L71.8357 143.646C71.7055 143.5 71.7183 143.276 71.8644 143.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8402 143.886C73.0359 143.886 73.1945 144.044 73.1945 144.24V232.56C73.1945 232.756 73.0359 232.914 72.8402 232.914C72.6445 232.914 72.4858 232.756 72.4858 232.56V144.24C72.4858 144.044 72.6445 143.886 72.8402 143.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1458 243.58C14.1458 243.384 14.3044 243.226 14.5001 243.226H59.3401C59.5358 243.226 59.6945 243.384 59.6945 243.58C59.6945 243.776 59.5358 243.934 59.3401 243.934H14.5001C14.3044 243.934 14.1458 243.776 14.1458 243.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1502 232.196C69.3459 232.196 69.5045 232.354 69.5045 232.55C69.5045 238.315 65.6852 243.109 60.655 243.83C60.2236 243.903 59.7849 243.934 59.3402 243.934C59.1445 243.934 58.9858 243.776 58.9858 243.58C58.9858 243.384 59.1445 243.226 59.3402 243.226C59.7538 243.226 60.1535 243.197 60.5406 243.131L60.5501 243.129L60.5501 243.129C65.1776 242.468 68.7958 238.023 68.7958 232.55C68.7958 232.354 68.9545 232.196 69.1502 232.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1501 53.17V76.42V218.96V232.55",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0601 76.42V218.96H69.1501V76.42H67.0601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1502 52.8156C69.3459 52.8156 69.5045 52.9743 69.5045 53.17V232.55C69.5045 232.746 69.3459 232.904 69.1502 232.904C68.9545 232.904 68.7958 232.746 68.7958 232.55V219.314H67.0602C66.8645 219.314 66.7058 219.156 66.7058 218.96V76.42C66.7058 76.2243 66.8645 76.0656 67.0602 76.0656H68.7958V53.17C68.7958 52.9743 68.9545 52.8156 69.1502 52.8156ZM68.7958 76.7743H67.4145V218.606H68.7958V76.7743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0059 42.14C59.0059 41.9443 59.1645 41.7856 59.3602 41.7856C59.85 41.7856 60.3408 41.8273 60.8122 41.9111C61.0049 41.9454 61.1334 42.1293 61.0991 42.322C61.0648 42.5147 60.8809 42.6431 60.6882 42.6089C60.2597 42.5327 59.8105 42.4943 59.3602 42.4943C59.1645 42.4943 59.0059 42.3357 59.0059 42.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4205 42.2024C60.4523 42.0093 60.6346 41.8786 60.8277 41.9103C65.7652 42.7228 69.5045 47.4846 69.5045 53.17C69.5045 53.3657 69.3459 53.5243 69.1502 53.5243C68.9545 53.5243 68.7958 53.3657 68.7958 53.17C68.7958 47.7754 65.2551 43.3571 60.7126 42.6096C60.5195 42.5779 60.3888 42.3956 60.4205 42.2024Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1658 42.14C14.1658 41.9443 14.3244 41.7856 14.5201 41.7856H59.3401C59.5358 41.7856 59.6945 41.9443 59.6945 42.14C59.6945 42.3357 59.5358 42.4943 59.3401 42.4943H14.5201C14.3244 42.4943 14.1658 42.3357 14.1658 42.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32568 53.17C4.32568 46.9241 8.84679 41.7856 14.5 41.7856C14.6957 41.7856 14.8544 41.9443 14.8544 42.14C14.8544 42.3357 14.6957 42.4943 14.5 42.4943C9.31329 42.4943 5.03438 47.2359 5.03438 53.17C5.03438 53.3657 4.87574 53.5244 4.68003 53.5244C4.48433 53.5244 4.32568 53.3657 4.32568 53.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68003 52.8156C4.87574 52.8156 5.03438 52.9743 5.03438 53.17V232.55C5.03438 232.746 4.87574 232.904 4.68003 232.904C4.48433 232.904 4.32568 232.746 4.32568 232.55V53.17C4.32568 52.9743 4.48433 52.8156 4.68003 52.8156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68003 232.196C4.87574 232.196 5.03438 232.354 5.03438 232.55C5.03438 238.494 9.31309 243.226 14.5 243.226C14.6957 243.226 14.8544 243.384 14.8544 243.58C14.8544 243.776 14.6957 243.934 14.5 243.934C8.84699 243.934 4.32568 238.806 4.32568 232.55C4.32568 232.354 4.48433 232.196 4.68003 232.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3602 54.3356C91.5559 54.3356 91.7146 54.4943 91.7146 54.69V141.48C91.7146 141.676 91.5559 141.834 91.3602 141.834C91.1645 141.834 91.0059 141.676 91.0059 141.48V54.69C91.0059 54.4943 91.1645 54.3356 91.3602 54.3356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5906 141.211C91.7392 141.338 91.7564 141.562 91.629 141.711L91.5036 141.857L90.8836 142.547C90.7528 142.692 90.5287 142.704 90.3831 142.574C90.2376 142.443 90.2256 142.219 90.3564 142.073L90.9736 141.386L91.0909 141.249C91.2183 141.101 91.442 141.084 91.5906 141.211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7458 142.31C71.7458 142.114 71.9045 141.956 72.1002 141.956H90.6202C90.8159 141.956 90.9745 142.114 90.9745 142.31C90.9745 142.506 90.8159 142.664 90.6202 142.664H72.1002C71.9045 142.664 71.7458 142.506 71.7458 142.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7458 143.41C71.7458 143.214 71.9045 143.056 72.1002 143.056H90.6202C90.8159 143.056 90.9745 143.214 90.9745 143.41C90.9745 143.606 90.8159 143.764 90.6202 143.764H72.1002C71.9045 143.764 71.7458 143.606 71.7458 143.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3831 143.146C90.5287 143.016 90.7528 143.028 90.8836 143.173L91.5091 143.869L91.629 144.009C91.7564 144.158 91.7392 144.382 91.5906 144.509C91.442 144.636 91.2183 144.619 91.0909 144.471L90.9736 144.334L90.3564 143.647C90.2256 143.501 90.2376 143.277 90.3831 143.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3602 143.886C91.5559 143.886 91.7146 144.044 91.7146 144.24V231.03C91.7146 231.226 91.5559 231.384 91.3602 231.384C91.1645 231.384 91.0059 231.226 91.0059 231.03V144.24C91.0059 144.044 91.1645 143.886 91.3602 143.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7133 231.001C91.7295 231.196 91.5844 231.367 91.3894 231.383L72.8694 232.913C72.6743 232.929 72.5032 232.784 72.4871 232.589C72.4709 232.394 72.616 232.223 72.811 232.207L91.331 230.677C91.5261 230.661 91.6972 230.806 91.7133 231.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3602 230.676C91.5559 230.676 91.7145 230.834 91.7145 231.03C91.7145 238.815 86.575 245.38 79.733 246.41L79.7321 246.411C79.4625 246.45 79.1704 246.492 78.8755 246.513C78.6803 246.527 78.5107 246.38 78.4968 246.185C78.4828 245.99 78.6298 245.821 78.825 245.807C79.0898 245.788 79.3574 245.75 79.6276 245.71C86.0654 244.74 91.0058 238.525 91.0058 231.03C91.0058 230.834 91.1645 230.676 91.3602 230.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.62 141.956C90.8157 141.956 90.9743 142.114 90.9743 142.31V143.41C90.9743 143.606 90.8157 143.764 90.62 143.764C90.4243 143.764 90.2656 143.606 90.2656 143.41V142.31C90.2656 142.114 90.4243 141.956 90.62 141.956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3657 242.21C33.3657 242.014 33.5244 241.856 33.7201 241.856H37.2601C37.4558 241.856 37.6144 242.014 37.6144 242.21C37.6144 242.406 37.4558 242.564 37.2601 242.564H33.7201C33.5244 242.564 33.3657 242.406 33.3657 242.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9058 242.21C36.9058 242.014 37.0644 241.856 37.2601 241.856H44.2901C44.4858 241.856 44.6445 242.014 44.6445 242.21C44.6445 242.406 44.4858 242.564 44.2901 242.564H37.2601C37.0644 242.564 36.9058 242.406 36.9058 242.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1573 241.831C31.2066 241.641 31.4001 241.528 31.5894 241.577C32.292 241.76 33.002 241.856 33.7202 241.856C33.9159 241.856 34.0745 242.014 34.0745 242.21C34.0745 242.406 33.9159 242.564 33.7202 242.564C32.9383 242.564 32.1684 242.46 31.4109 242.263C31.2215 242.214 31.108 242.02 31.1573 241.831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6335 242.033C39.6483 242.228 39.5021 242.399 39.307 242.413L37.3269 242.563C37.1318 242.578 36.9616 242.432 36.9468 242.237C36.932 242.042 37.0783 241.871 37.2734 241.857L39.2534 241.707C39.4485 241.692 39.6187 241.838 39.6335 242.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9258 242.06C38.9258 241.864 39.0844 241.706 39.2801 241.706H44.2901C44.4858 241.706 44.6445 241.864 44.6445 242.06C44.6445 242.256 44.4858 242.414 44.2901 242.414H39.2801C39.0844 242.414 38.9258 242.256 38.9258 242.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6436 241.675C44.6576 241.87 44.5108 242.039 44.3156 242.053L39.3055 242.413C39.1103 242.427 38.9407 242.281 38.9267 242.085C38.9127 241.89 39.0596 241.721 39.2548 241.707L44.2648 241.347C44.46 241.333 44.6296 241.479 44.6436 241.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2601 237.716C37.4558 237.716 37.6145 237.874 37.6145 238.07V242.21C37.6145 242.406 37.4558 242.564 37.2601 242.564C37.0644 242.564 36.9058 242.406 36.9058 242.21V238.07C36.9058 237.874 37.0644 237.716 37.2601 237.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6436 237.534C44.6577 237.73 44.511 237.899 44.3158 237.913L37.2858 238.423C37.0906 238.438 36.9209 238.291 36.9067 238.096C36.8925 237.9 37.0393 237.731 37.2345 237.717L44.2645 237.207C44.4597 237.192 44.6294 237.339 44.6436 237.534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8757 238.07C32.8757 237.874 33.0344 237.716 33.2301 237.716H37.2601C37.4558 237.716 37.6144 237.874 37.6144 238.07C37.6144 238.266 37.4558 238.424 37.2601 238.424H33.2301C33.0344 238.424 32.8757 238.266 32.8757 238.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6335 237.534C40.6477 237.73 40.5009 237.899 40.3057 237.913L33.2557 238.423C33.0605 238.438 32.8908 238.291 32.8767 238.096C32.8626 237.9 33.0093 237.731 33.2045 237.717L40.2545 237.207C40.4497 237.192 40.6194 237.339 40.6335 237.534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9258 237.56C39.9258 237.364 40.0844 237.206 40.2801 237.206H44.2901C44.4858 237.206 44.6445 237.364 44.6445 237.56C44.6445 237.756 44.4858 237.914 44.2901 237.914H40.2801C40.0844 237.914 39.9258 237.756 39.9258 237.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1665 237.641C31.2323 237.456 31.4351 237.36 31.6194 237.426C32.145 237.614 32.6847 237.716 33.2302 237.716C33.4259 237.716 33.5845 237.874 33.5845 238.07C33.5845 238.266 33.4259 238.424 33.2302 238.424C32.5957 238.424 31.9754 238.306 31.381 238.094C31.1967 238.028 31.1007 237.825 31.1665 237.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2109 234.023C35.3858 233.935 35.5988 234.006 35.6867 234.181C36.6335 236.065 38.399 237.206 40.2801 237.206C40.4758 237.206 40.6344 237.364 40.6344 237.56C40.6344 237.756 40.4758 237.914 40.2801 237.914C38.1011 237.914 36.1066 236.595 35.0534 234.499C34.9656 234.324 35.0361 234.111 35.2109 234.023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0165 230.985C35.0304 230.79 35.1999 230.643 35.3952 230.657L38.3452 230.867C38.5404 230.88 38.6874 231.05 38.6735 231.245C38.6596 231.44 38.4901 231.587 38.2948 231.573L35.3448 231.363C35.1496 231.35 35.0026 231.18 35.0165 230.985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3202 228.816C38.5159 228.816 38.6745 228.974 38.6745 229.17V231.22C38.6745 231.416 38.5159 231.574 38.3202 231.574C38.1245 231.574 37.9658 231.416 37.9658 231.22V229.17C37.9658 228.974 38.1245 228.816 38.3202 228.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0156 231.22C35.0156 231.024 35.1743 230.866 35.37 230.866H38.32C38.5157 230.866 38.6743 231.024 38.6743 231.22C38.6743 231.416 38.5157 231.574 38.32 231.574H35.37C35.1743 231.574 35.0156 231.416 35.0156 231.22Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3257 99.81C60.3257 99.6143 60.4843 99.4556 60.68 99.4556H65.43C65.6257 99.4556 65.7844 99.6143 65.7844 99.81C65.7844 100.006 65.6257 100.164 65.43 100.164H60.68C60.4843 100.164 60.3257 100.006 60.3257 99.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1658 99.81C26.1658 99.6143 26.3244 99.4556 26.5201 99.4556H60.6801C60.8758 99.4556 61.0345 99.6143 61.0345 99.81C61.0345 100.006 60.8758 100.164 60.6801 100.164H26.5201C26.3244 100.164 26.1658 100.006 26.1658 99.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1658 85.31C26.1658 85.1143 26.3244 84.9556 26.5201 84.9556H60.6801C60.8758 84.9556 61.0345 85.1143 61.0345 85.31C61.0345 85.5057 60.8758 85.6643 60.6801 85.6643H26.5201C26.3244 85.6643 26.1658 85.5057 26.1658 85.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3257 85.31C60.3257 85.1143 60.4843 84.9556 60.68 84.9556H65.43C65.6257 84.9556 65.7844 85.1143 65.7844 85.31C65.7844 85.5057 65.6257 85.6643 65.43 85.6643H60.68C60.4843 85.6643 60.3257 85.5057 60.3257 85.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7559 82.57C39.7559 82.3743 39.9145 82.2156 40.1102 82.2156H45.8502C46.0459 82.2156 46.2046 82.3743 46.2046 82.57C46.2046 82.7657 46.0459 82.9243 45.8502 82.9243H40.1102C39.9145 82.9243 39.7559 82.7657 39.7559 82.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7358 70.37C31.7358 70.1743 31.8945 70.0156 32.0902 70.0156H50.7802C50.9759 70.0156 51.1345 70.1743 51.1345 70.37C51.1345 70.5657 50.9759 70.7243 50.7802 70.7243H32.0902C31.8945 70.7243 31.7358 70.5657 31.7358 70.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3157 81.06C53.3157 80.8643 53.4743 80.7056 53.67 80.7056H53.71C53.9057 80.7056 54.0644 80.8643 54.0644 81.06C54.0644 81.2557 53.9057 81.4143 53.71 81.4143H53.67C53.4743 81.4143 53.3157 81.2557 53.3157 81.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7358 225.01C31.7358 224.814 31.8945 224.656 32.0902 224.656H50.7802C50.9759 224.656 51.1345 224.814 51.1345 225.01C51.1345 225.206 50.9759 225.364 50.7802 225.364H32.0902C31.8945 225.364 31.7358 225.206 31.7358 225.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0059 54.69C91.0059 54.4943 91.1645 54.3356 91.3602 54.3356H96.3302C96.5259 54.3356 96.6846 54.4943 96.6846 54.69C96.6846 54.8857 96.5259 55.0443 96.3302 55.0443H91.3602C91.1645 55.0443 91.0059 54.8857 91.0059 54.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0059 231.03C91.0059 230.834 91.1645 230.676 91.3602 230.676H96.3302C96.5259 230.676 96.6846 230.834 96.6846 231.03C96.6846 231.226 96.5259 231.384 96.3302 231.384H91.3602C91.1645 231.384 91.0059 231.226 91.0059 231.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.17 50.9356C37.3657 50.9356 37.5244 51.0943 37.5244 51.29V59.46C37.5244 59.6557 37.3657 59.8143 37.17 59.8143C36.9743 59.8143 36.8157 59.6557 36.8157 59.46V51.29C36.8157 51.0943 36.9743 50.9356 37.17 50.9356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7058 51.6005C40.8215 51.7583 40.7874 51.98 40.6296 52.0958C40.5691 52.1401 40.541 52.2085 40.5439 52.2603C40.5547 52.4557 40.4051 52.6229 40.2097 52.6338C40.0143 52.6447 39.8471 52.4951 39.8363 52.2997C39.8192 51.9915 39.971 51.6999 40.2105 51.5243C40.3683 51.4085 40.5901 51.4426 40.7058 51.6005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2097 53.0362C40.4051 53.0471 40.5547 53.2143 40.5439 53.4097C40.5408 53.4644 40.571 53.5248 40.6166 53.5552C40.7794 53.6637 40.8234 53.8837 40.7149 54.0466C40.6063 54.2094 40.3863 54.2534 40.2235 54.1448C39.9691 53.9752 39.8193 53.6756 39.8363 53.3703C39.8471 53.1749 40.0143 53.0253 40.2097 53.0362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8357 53.39C39.8357 53.1943 39.9943 53.0356 40.19 53.0356H40.42C40.6157 53.0356 40.7744 53.1943 40.7744 53.39C40.7744 53.5857 40.6157 53.7443 40.42 53.7443H40.19C39.9943 53.7443 39.8357 53.5857 39.8357 53.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8357 52.28C39.8357 52.0843 39.9943 51.9257 40.19 51.9257H40.42C40.6157 51.9257 40.7744 52.0843 40.7744 52.28C40.7744 52.4757 40.6157 52.6344 40.42 52.6344H40.19C39.9943 52.6344 39.8357 52.4757 39.8357 52.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.19 59.9056C39.3857 59.9056 39.5444 60.0643 39.5444 60.26V66.33C39.5444 66.5257 39.3857 66.6843 39.19 66.6843C38.9943 66.6843 38.8357 66.5257 38.8357 66.33V60.26C38.8357 60.0643 38.9943 59.9056 39.19 59.9056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5557 53.17C68.5557 52.9743 68.7143 52.8156 68.91 52.8156H69.15C69.3457 52.8156 69.5044 52.9743 69.5044 53.17C69.5044 53.3657 69.3457 53.5243 69.15 53.5243H68.91C68.7143 53.5243 68.5557 53.3657 68.5557 53.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5557 232.55C68.5557 232.354 68.7143 232.196 68.91 232.196H69.15C69.3457 232.196 69.5044 232.354 69.5044 232.55C69.5044 232.746 69.3457 232.904 69.15 232.904H68.91C68.7143 232.904 68.5557 232.746 68.5557 232.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1958 75.67C50.1958 75.4743 50.3544 75.3156 50.5502 75.3156H55.0101C55.2058 75.3156 55.3645 75.4743 55.3645 75.67C55.3645 75.8657 55.2058 76.0243 55.0101 76.0243H50.5502C50.3544 76.0243 50.1958 75.8657 50.1958 75.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2258 75.67C27.2258 75.4743 27.3845 75.3156 27.5802 75.3156H30.0102C30.2059 75.3156 30.3645 75.4743 30.3645 75.67C30.3645 75.8657 30.2059 76.0243 30.0102 76.0243H27.5802C27.3845 76.0243 27.2258 75.8657 27.2258 75.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2258 219.71C27.2258 219.514 27.3845 219.356 27.5802 219.356H30.0102C30.2059 219.356 30.3645 219.514 30.3645 219.71C30.3645 219.906 30.2059 220.064 30.0102 220.064H27.5802C27.3845 220.064 27.2258 219.906 27.2258 219.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1958 219.71C50.1958 219.514 50.3544 219.356 50.5502 219.356H55.0101C55.2058 219.356 55.3645 219.514 55.3645 219.71C55.3645 219.906 55.2058 220.064 55.0101 220.064H50.5502C50.3544 220.064 50.1958 219.906 50.1958 219.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2358 72.32C27.2358 72.1243 27.3945 71.9656 27.5902 71.9656H30.3902C30.5859 71.9656 30.7445 72.1243 30.7445 72.32C30.7445 72.5157 30.5859 72.6743 30.3902 72.6743H27.5902C27.3945 72.6743 27.2358 72.5157 27.2358 72.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1658 73.7C50.1658 73.5043 50.3244 73.3456 50.5201 73.3456H50.7801C50.9758 73.3456 51.1345 73.5043 51.1345 73.7C51.1345 73.8957 50.9758 74.0543 50.7801 74.0543H50.5201C50.3244 74.0543 50.1658 73.8957 50.1658 73.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5957 73.7C26.5957 73.5043 26.7544 73.3456 26.9501 73.3456H30.0801C30.2758 73.3456 30.4344 73.5043 30.4344 73.7C30.4344 73.8957 30.2758 74.0543 30.0801 74.0543H26.9501C26.7544 74.0543 26.5957 73.8957 26.5957 73.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5957 74.29C26.5957 74.0943 26.7544 73.9356 26.9501 73.9356H30.0201C30.2158 73.9356 30.3744 74.0943 30.3744 74.29C30.3744 74.4857 30.2158 74.6443 30.0201 74.6443H26.9501C26.7544 74.6443 26.5957 74.4857 26.5957 74.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1658 74.29C50.1658 74.0943 50.3244 73.9356 50.5201 73.9356H50.7801C50.9758 73.9356 51.1345 74.0943 51.1345 74.29C51.1345 74.4857 50.9758 74.6443 50.7801 74.6443H50.5201C50.3244 74.6443 50.1658 74.4857 50.1658 74.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1658 221.09C50.1658 220.894 50.3244 220.736 50.5201 220.736H50.7801C50.9758 220.736 51.1345 220.894 51.1345 221.09C51.1345 221.286 50.9758 221.444 50.7801 221.444H50.5201C50.3244 221.444 50.1658 221.286 50.1658 221.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5957 221.09C26.5957 220.894 26.7544 220.736 26.9501 220.736H30.0201C30.2158 220.736 30.3744 220.894 30.3744 221.09C30.3744 221.286 30.2158 221.444 30.0201 221.444H26.9501C26.7544 221.444 26.5957 221.286 26.5957 221.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5957 221.68C26.5957 221.484 26.7544 221.326 26.9501 221.326H30.0801C30.2758 221.326 30.4344 221.484 30.4344 221.68C30.4344 221.876 30.2758 222.034 30.0801 222.034H26.9501C26.7544 222.034 26.5957 221.876 26.5957 221.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1658 221.68C50.1658 221.484 50.3244 221.326 50.5201 221.326H50.7801C50.9758 221.326 51.1345 221.484 51.1345 221.68C51.1345 221.876 50.9758 222.034 50.7801 222.034H50.5201C50.3244 222.034 50.1658 221.876 50.1658 221.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2358 223.06C27.2358 222.864 27.3945 222.706 27.5902 222.706H30.3902C30.5859 222.706 30.7445 222.864 30.7445 223.06C30.7445 223.256 30.5859 223.414 30.3902 223.414H27.5902C27.3945 223.414 27.2358 223.256 27.2358 223.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2759 46.75C26.2759 46.5543 26.4345 46.3956 26.6302 46.3956H26.7602C26.9559 46.3956 27.1146 46.5543 27.1146 46.75C27.1146 46.9457 26.9559 47.1043 26.7602 47.1043H26.6302C26.4345 47.1043 26.2759 46.9457 26.2759 46.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1102 82.6356C34.3059 82.6356 34.4646 82.7943 34.4646 82.99V83.27C34.4646 83.4657 34.3059 83.6243 34.1102 83.6243C33.9145 83.6243 33.7559 83.4657 33.7559 83.27V82.99C33.7559 82.7943 33.9145 82.6356 34.1102 82.6356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.18 79.0256C31.3757 79.0256 31.5344 79.1843 31.5344 79.38V83.27C31.5344 83.4657 31.3757 83.6243 31.18 83.6243C30.9843 83.6243 30.8257 83.4657 30.8257 83.27V79.38C30.8257 79.1843 30.9843 79.0256 31.18 79.0256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9858 42.14C58.9858 41.9443 59.1445 41.7856 59.3402 41.7856H59.3602C59.3704 41.7856 59.3805 41.7861 59.3907 41.787L60.7655 41.9056H60.7702C60.9659 41.9056 61.1245 42.0643 61.1245 42.26C61.1245 42.4557 60.9659 42.6143 60.7702 42.6143H60.7502C60.74 42.6143 60.7299 42.6139 60.7197 42.613L59.3449 42.4943H59.3402C59.1445 42.4943 58.9858 42.3357 58.9858 42.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1239 243.449C61.1354 243.644 60.9864 243.812 60.791 243.824L60.6247 243.833L59.3682 243.933C59.1732 243.949 59.0025 243.803 58.987 243.608C58.9715 243.413 59.1171 243.242 59.3122 243.227L60.5794 243.126L60.7494 243.116C60.9447 243.105 61.1124 243.254 61.1239 243.449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1458 42.14C14.1458 41.9443 14.3044 41.7856 14.5001 41.7856H14.5201C14.5287 41.7856 14.5373 41.786 14.5459 41.7866L18.3759 42.0666C18.5711 42.0809 18.7178 42.2507 18.7035 42.4458C18.6892 42.641 18.5195 42.7877 18.3243 42.7734L14.5072 42.4943H14.5001C14.3044 42.4943 14.1458 42.3357 14.1458 42.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7036 243.285C18.7173 243.48 18.5701 243.65 18.3749 243.663L14.5249 243.933C14.3297 243.947 14.1603 243.8 14.1466 243.605C14.1329 243.41 14.2801 243.24 14.4753 243.227L18.3253 242.957C18.5206 242.943 18.6899 243.09 18.7036 243.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0737 242.186C34.0869 242.381 33.9393 242.55 33.744 242.564L31.524 242.714C31.3287 242.727 31.1598 242.579 31.1466 242.384C31.1334 242.189 31.281 242.02 31.4762 242.006L33.6962 241.856C33.8915 241.843 34.0605 241.991 34.0737 242.186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32683 53.1417C4.34243 52.9466 4.51323 52.8012 4.7083 52.8168L4.95831 52.8368C5.15338 52.8524 5.29888 53.0232 5.28327 53.2182C5.26767 53.4133 5.09688 53.5588 4.9018 53.5432L4.6518 53.5232C4.45672 53.5076 4.31123 53.3368 4.32683 53.1417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28327 232.502C5.29889 232.697 5.15341 232.868 4.95834 232.883L4.70834 232.903C4.51326 232.919 4.34245 232.773 4.32683 232.578C4.31121 232.383 4.45669 232.212 4.65177 232.197L4.90177 232.177C5.09684 232.161 5.26765 232.307 5.28327 232.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 61.5C58 63.433 56.433 65 54.5 65C52.567 65 51 63.433 51 61.5C51 59.567 52.567 58 54.5 58C56.433 58 58 59.567 58 61.5Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 61.5C60 64.5376 57.5376 67 54.5 67C51.4624 67 49 64.5376 49 61.5C49 58.4624 51.4624 56 54.5 56C57.5376 56 60 58.4624 60 61.5ZM54.5 65C56.433 65 58 63.433 58 61.5C58 59.567 56.433 58 54.5 58C52.567 58 51 59.567 51 61.5C51 63.433 52.567 65 54.5 65Z",
    fill: "#F26850"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_wd_back_arrow_fadein",
    attributeName: "fill-opacity",
    from: 0,
    to: 1,
    begin: "hinava_random_uuid_wd_back_fadein.end+1s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_wd_back_arrow_move",
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "4 0",
    begin: "hinava_random_uuid_wd_back_arrow_fadein.end+0.5s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    from: 1,
    to: 0,
    begin: "hinava_random_uuid_wd_hinava_blink.end+2s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "4 0",
    to: "0 0",
    begin: "hinava_random_uuid_wd_hinava_blink.end+3s",
    dur: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0229 70.5L50.6105 61.5L35.0229 52.5V58.6502V64.2222V70.5Z",
    fill: "#F26850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.135 58.0712L11 63.64L35.0229 64.2222V58.6502L11.135 58.0712Z",
    fill: "#F26850"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorWifi);
export default __webpack_public_path__ + "static/media/door-wifi.b899dc6b06da21a120be78d45caf0af6.svg";
export { ForwardRef as ReactComponent };